<template>
  <div id="app"
    :class="{ 'home-default': themeCode === 'default' && homeType !== 'newHome', 'home': themeCode === 'blue' && homeType !== 'newHome', 'new-home': homeType === 'newHome' }">
    <div class="mode-view">
      <div v-for="item in 200" :key="item" class="mode-view-flashing"></div>
      <div class="star"></div>
      <div class="star" style="top: 4vw; left: 35vw; animation-delay: 3s;"></div>
      <div class="star" style="top: 2vw; left: 47.3vw; animation-delay: 2s;"></div>
      <div class="star" style="top: 6vw; left: 34.75vw; animation-delay: 4s;"></div>
      <div class="star" style="top: 6vw; left: 50vw; animation-delay: 2s;"></div>
      <div class="star" style="top: 6vw; left: 63.25vw; animation-delay: 4s;"></div>
      <div class="star" style="top: 6vw; left: 78.25vw; animation-delay: 1.5s;"></div>
      <div class="star" style="top: 6vw; left: 95vw; animation-delay: 3s;"></div>
      <div class="star" style="top: 6vw; left: 82.5vw; animation-delay: 1.7s;"></div>
      <div class="star" style="top: 6vw; left: 115vw; animation-delay: 4s;"></div>
    </div>
    <div v-show="homeType != 'newHome'" id="outline">
      <div class="outline-header">
        <div class="outline-header-bg">
          <img v-if="themeCode === 'default'" src="../../assets/default/headerbg.png" alt="">
          <img v-else-if="themeCode === 'blue'" src="../../assets/electricity/headerbg.png" alt="">
        </div>
        <div class="outline-header-left">
          <div v-if="ImageUrl">
            <img :src="ImageUrl" alt="">
          </div>
        </div>
        <div class="outline-header-center">
          <div class="outline-header-center-top">

            <img
              :src="themeCode === 'default' ? require('../../assets/default/decorate_left.png') : require('../../assets/electricity/decorate_left.png')"
              alt="">
            <div class="outline-header-center-title">
              {{ TittleName }}
            </div>
            <!-- <dv-decoration-1 style="width:200px;height:50px; transform: rotateY(180deg);" /> -->
            <img
              :src="themeCode === 'default' ? require('../../assets/default/decorate_rigth.png') : require('../../assets/electricity/decorate_rigth.png')"
              alt="">

          </div>
          <div class="outline-header-center-bottom" style="letter-spacing: 0px;">
            {{ TittleNameEN }}
          </div>
        </div>
        <div class="outline-header-right">
          <Dropdown style="cursor:pointer;">
            <div
              style="color:#fff; text-align: center; width:6vw;  line-height:2.5vw; height: 2.5vw;margin-top: 0.675vw;font-size:16px;">
              <span>{{ LangageType == 'zh' ? '中文' : 'English' }}</span>
              <Icon type="md-arrow-dropdown" style="margin-left: 0.2vw;" /></div>
            <DropdownMenu slot='list'>
              <DropdownItem @click.native="setLangage('en')">
                English
              </DropdownItem>
              <DropdownItem @click.native="setLangage('zh')">
                中文
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Dropdown>
            <a href="javascript:void(0)">
              <img
                :src="themeCode === 'default' ? require('../../assets/default/qiehuan.png') : require('../../assets/electricity/qiehuan.png')"
                :alt="$t('smartCity.Home.943046-0')">
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in themeList" :key="item.id" @click.native="setTheme(item)">{{ item.name }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Dropdown>
            <a>
              <img
                :src="themeCode === 'default' ? require('../../assets/default/switch.png') : require('../../assets/electricity/switch.png')"
                :alt="$t('smartCity.Home.943046-1')">
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in HomeModeList" :key="item.id" @click.native="switchIndex(item.code, true)">{{
                item.name }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <img v-if="PlayIndex" @click="StopSound"
            :src="themeCode === 'default' ? require('../../assets/default/yousheng.png') : require('../../assets/electricity/yousheng.png')"
            :alt="$t('smartCity.Home.943046-0')">
          <img v-else @click="PlaySound"
            :src="themeCode === 'default' ? require('../../assets/default/wusheng.png') : require('../../assets/electricity/wusheng.png')"
            :alt="$t('smartCity.Home.943046-0')">

          <Poptip confirm :title="$t('smartCity.Home.943046-2')" placement="top-end" offset='-20' @on-ok="ok"
            @on-cancel="cancel">
            <img
              :src="themeCode === 'default' ? require('../../assets/default/tuichu.png') : require('../../assets/electricity/tuichu.png')"
              :alt="$t('smartCity.Home.943046-3')">
          </Poptip>

        </div>
        <div class="outline-and"></div>
      </div>
      <div class="outline-content">
        <div class="outline-left">
          <div class="outline-left-title">{{ $t('smartCity.Home.943046-4') }}</div>
          <div class="outline-left-list">
            <div class="outline-left-lists" :class="{ 'outline_offset': offsetMsg }" v-if="GetAbDataLists.length > 0">
              <div class="outline-left-top-item" v-for="(item, index) in GetAbDataLists" :key="item.Id"
                @dblclick="deviceDetails(item)">
                <Tooltip :content="item.AbnormalTime" placement="right">
                  <div class="outline-left-top-item-time">
                    <div class="outline-left-top-item-time-bg-img">
                      <img v-if="index < 3"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAUCAYAAAA5g+sCAAAA/UlEQVRYhe2YPQrCQBBGX4InsBH1EtbeQAtvIBaKhXcS7MXCRo9gqb210cLewl8WRxAnrqJB2HUfBMK3IWxekmF2o/08qgF9oIhbrIE2ME2bda5yUpkNIyJxUMINI6Ok0g9ExA5LIMu5xyr5U4IIIYgQcirxnMMi/d2np27RymK2PogYAGOgoEbsmP4pkaNm+oiz9XJ32AI9YMhDH3FYxK+ece1TscwDZZW+R+RLsdwBTWCkRq5fR3Q7vyuWdVlaHIGuDyLML9EAZmrEzuS+M/VBRBVYqvQJz9YgPtSItyXYCJ2lEEQIQYQQy+aGq2yyFNHJ8oY/ZCVbdd8DXADvhSzN7qNDBAAAAABJRU5ErkJggg=="
                        alt="">
                      <img v-else
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAUCAYAAAA5g+sCAAABFUlEQVRYhe2Yv2oCQRCHvzsOOxuLhGCZxme4NzBF3kBCiFgErPIcNlofGizFwsY8QcgjWIilf5B0KQJBSTiYgyNjjkMPYTf7wcLyG3YZfswOw3q1sFsHIuAKs1gDD8DLoaxnr22lZeEbagKSc6TUI/ENNSGhsNx9pfxTnBGCM0JwRgiBUszjDnjOm3WjvVAallTEAJgAlyqSTTw/rWTVbaiImFsgBB6B0e/g/dP2O9kHpbI6vPv6iGzqERWgqtR8eLZUxGf8/IGxigD9zoWX7FM94kYm0z3QssGId3kabyqSzTQ9mdpgRNwb5kr9g2Hv+mDAhh6R24Qs3EAlOCMEZ4Tgy0+PqWyKNKJZ5IVnZClfdacD/ADsAigQ3sKtDwAAAABJRU5ErkJggg=="
                        alt="">
                    </div>
                    <template v-if="index < 3">
                      <span style="color: #000000;">{{ item.AbnormalTime | intercept }}</span>
                    </template>
                    <template v-else>
                      <span style="color: #fff;">{{ item.AbnormalTime | intercept }}</span>
                    </template>
                  </div>
                </Tooltip>

                <div class="outline-left-top-item-name">
                  {{ item.UserDeviceName }}
                </div>
                <div class="outline-left-top-item-group">{{ item.AbnormalName }}</div>
              </div>
            </div>
            <div class="map-right-group-list-none" v-else>{{ $t('smartCity.Home.943046-5') }}</div>

            <Spin size="large" fix v-if="!GetAbDataListsMsg"></Spin>
          </div>
          <div class="outline-left-title">{{ $t('smartCity.Home.943046-6') }}</div>
          <div class="outline-left-bottom">
            <div class="outline-left-bottom-detail">
              <div class="outline-left-bottom-detail-div"></div>
              <div class="outline-left-bottom-detail-text">{{ $t('smartCity.Home.943046-7') }}</div>
              <div class="outline-left-bottom-detail-number">
                <span>
                  <span id="count_to_42" class="count-to-count-text">{{ processed ? processed : '0' }}</span>
                  <span class="count-to-unit-text"></span>
                </span>
              </div>
            </div>
            <div class="outline-left-bottom-chart">
              <div id="myChart" :style="{ width: '100%', height: '100%' }"></div>
            </div>
            <Spin size="large" fix v-if="!GetEchartAbDataMsg"></Spin>
          </div>
          <div class="outline-left-absolute">
            <img src="../../assets/home/outlineBorder1.png" alt="">
          </div>
          <div class="outline-left-absolute1">
            <img src="../../assets/home/outlineBorder1.png" alt="">
          </div>
        </div>

        <div class="outline-center">

          <div class="outline-center-data-alarm2">
            <div class="outline-center-data-alarm2-item" @click="openPopup(3, $t('smartCity.Home.943046-8'), 2)">
              {{ $t('smartCity.Home.943046-9') }}
              <span>
                <span>
                  <span id="itemImg1" class="count-to-count-text">0</span>
                  <span class="count-to-unit-text"></span>
                </span>
              </span>
            </div>
            <div class="outline-center-data-alarm2-item" @click="openPopup(3, $t('smartCity.Home.943046-10'), 1)">
              {{ $t('smartCity.Home.943046-11') }}
              <span>
                <span>
                  <span id="itemImg2" class="count-to-count-text">0</span>
                  <span class="count-to-unit-text"></span>
                </span>
              </span>
            </div>
          </div>

          <!-- <img class="outline-center-light1" src="https://big.darongshu360.com/img/earthbg1.2604d64e.png" alt=""> -->
          <div class="outline-center-data">
            <div class="outline-center-data-alarm" @click="openPopup(1, $t('smartCity.Home.943046-12'))">

              <!-- <span class="outline-center-data-alarm-number">
								<span class="item">
									<span id="count_to_124" class="count-to-count-text">{{GetNavDataYHJs.todayAb}}</span>
									<span class="count-to-unit-text"></span>
								</span>
							</span> -->
              <div id="itemImg3" class="outline-center-data-alarm-code">0</div>
              <div class="outline-center-data-alarm-title">{{ $t('smartCity.Home.943046-12') }}</div>


            </div>
            <div class="outline-center-data-circle">
              <div class="outline-center-data-circle-item" @click="openPopup(5, $t('smartCity.Home.943046-13'))">

                <div id="itemImg4" class="outline-center-data-circle-item-title1" style="height: 3vw;">
                  0
                  <!-- <dv-digital-flop :config="AbTenants" style="width:100%;height:2.5vw" /> -->
                </div>
                <div class="outline-center-data-circle-item-title">{{ $t('smartCity.Home.943046-14') }}</div>
              </div>
              <div class="outline-center-data-circle-item" @click="openPopup(4, $t('smartCity.Home.943046-15'))">
                <div id="itemImg5" class="outline-center-data-circle-item-title1" style=" height: 3vw;">
                  0
                  <!-- <dv-digital-flop :config="abDevices" style="width:100%;height:2.5vw" /> -->
                </div>
                <div class="outline-center-data-circle-item-title">{{ $t('smartCity.Home.943046-16') }}</div>
              </div>
              <div class="outline-center-data-circle-item" @click="openPopup(2, $t('smartCity.Home.943046-17'), '1')">
                <div id="itemImg6" class="outline-center-data-circle-item-title1" style=" height: 3vw;">
                  0
                  <!-- <dv-digital-flop :config="ZxDevices" style="width:100%;height:2.5vw" /> -->
                </div>
                <div class="outline-center-data-circle-item-title">{{ $t('smartCity.Home.943046-18') }}</div>
              </div>
              <div class="outline-center-data-circle-item" @click="openPopup(2, $t('smartCity.Home.943046-19'), '0')">
                <div id="itemImg7" class="outline-center-data-circle-item-title1" style="height: 3vw;">
                  0
                  <!-- <dv-digital-flop :config="LxDevices" style="width:100%;height:2.5vw" /> -->
                </div>
                <div class="outline-center-data-circle-item-title">{{ $t('smartCity.Home.943046-20') }}</div>
              </div>
            </div>
          </div>


        </div>

        <div class="outline-right">
          <div class="outline-right-title">{{ $t('smartCity.Home.943046-21') }}</div>
          <div class="outline-right-top">
            <div class="outline-right-top-chart">
              <div id="myChart1" :style="{ width: '100%', height: '100%' }"></div>
            </div>
            <div class="outline-right-top-list-tab">
              <div class="outline-right-top-tab-item">{{ $t('smartCity.Home.943046-22') }}</div>
              <div class="outline-right-top-tab-item">{{ $t('smartCity.Home.943046-23') }}</div>
              <div class="outline-right-top-tab-item">{{ $t('smartCity.Home.943046-24') }}</div>
            </div>
            <div class="outline-right-top-list" id="wrapper">
              <div id="content" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 0">
                <div class="outline-right-top-list-item" v-for="(item, index) in GetDeviceDataLists" :key="index"
                  @dblclick="deviceDetails(item)">
                  <div class="outline-right-top-list-item-time2" style="padding: 0 0.5vw;" :title="item.AddressDetail">
                    {{ item.AddressDetail }}</div>
                  <div class="outline-right-top-list-item-name2">{{ item.UserDeviceName }}</div>
                  <div class="outline-right-top-list-item-group2">
                    <img v-if="item.SwitchStatus == 1" src="../../assets/home/close.png" alt="">
                    <img v-else-if="item.SwitchStatus == 2" src="../../assets/home/open.png" alt="">
                    <span v-else>--</span>
                  </div>
                  <!-- {{item.SwitchStatus == 1 ? $t('smartCity.Home.943046-93') : $t('smartCity.Home.943046-94')}} -->
                </div>
              </div>
              <div id="fakeContent" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 4"></div>

              <div class="map-right-group-list-none" v-if="GetDeviceDataLists.length == 0">{{
                $t('smartCity.Home.943046-25') }}</div>
              <Spin size="large" fix v-if="!GetDeviceDataListsMsg"></Spin>
            </div>

          </div>
          <div class="outline-right-middle" v-if="homeType !== 'newHome'">
            <div class="outline-right-middle-view" @click="goPages('smartElectricity')">
              <dv-border-box-5 :color="['rgb(42,238,208)', 'rgb(32,148,238)']" :reverse="true" style="overflow: hidden;">
                <div class="outline-right-middle-view-vm">
                  <div class="outline-right-middle-img2">
                    <img src="../../assets/home/btnicon1.png" alt="">
                  </div>
                  <div class="outline-right-middle-view-dev">{{ $t('smartCity.Home.943046-26') }}</div>
                </div>
              </dv-border-box-5>
            </div>
            <div class="outline-right-middle-view" @click="goPages('bigScreen')">
              <dv-border-box-5 :color="['rgb(42,238,208)', 'rgb(32,148,238)']" style="overflow: hidden;">
                <div class="outline-right-middle-view-vm">
                  <div class="outline-right-middle-img2">
                    <img src="../../assets/home/btnicon2.png" alt="">
                  </div>
                  <div class="outline-right-middle-view-dev">{{ $t('smartCity.Home.943046-27') }}</div>
                </div>
              </dv-border-box-5>
            </div>
          </div>
          <!-- <div class="outline-right-entrance">
            <div class="outline-right-entrance-mask">
              <div class="outline-right-entrance-mask1">
                <img class="outline-right-entrance-img" src="../../assets/home/btnl.png" alt="">
              </div>
              <div class="outline-right-entrance-mask2">
                <img class="outline-right-entrance-img" src="../../assets/home/btnr.png" alt="">
              </div>
            </div>
          </div> -->
          <div class="outline-right-title">{{ $t('smartCity.Home.943046-28') }}</div>
          <div class="outline-right-bottom">
            <div class="outline-right-bottom-list-tab">
              <div class="outline-right-bottom-tab-item">{{ $t('smartCity.Home.943046-29') }}</div>
              <div class="outline-right-bottom-tab-item">{{ $t('smartCity.Home.943046-30') }}</div>
              <div class="outline-right-bottom-tab-item">{{ $t('smartCity.Home.943046-31') }}</div>
            </div>
            <div class="outline-right-bottom-list">
              <div class="outline-right-top-lists1" v-if="GetOperationDataList.length > 0">
                <div class="outline-right-top-list-item" v-for="(item, index) in GetOperationDataList" :key="index"
                  @dblclick="deviceDetails(item)">
                  <div class="outline-right-top-list-item-time">{{ item.CreateTime }}</div>
                  <div class="outline-right-top-list-item-name">{{ item.UserDeviceName }}</div>
                  <div class="outline-right-top-list-item-group">{{ item.Remark }}</div>
                </div>
              </div>
              <div class="map-right-group-list-none" v-else>{{ $t('smartCity.Home.943046-32') }}</div>
              <Spin size="large" fix v-if="!GetOperationDataListMsg"></Spin>
            </div>
          </div>
          <div class="outline-right-absolute">
            <img src="../../assets/home/outlineBorder2.png" alt="">
          </div>
          <div class="outline-right-absolute1">
            <img src="../../assets/home/outlineBorder2.png" alt="">
          </div>
        </div>

        <!-- :class="{'hiddenTop' : !userListHideIndex}" -->

      </div>
    </div>

    <div v-show="homeType == 'newHome'" id="newOutline" @click="cancelMore">
      <div class="outline-header">
        <div class="outline-header-left">
          <!-- <div class="backTag" v-show="!showArea" @click="back()">{{ $t('smartCity.Home.943046-42') }}</div> -->
        </div>
        <div class="outline-header-center">
          <div class="outline-header-center-top">
            <div class="outline-header-center-title">
              <!-- 逸慧家智慧用电与消防安全隐患预警系统 -->
              {{ TittleName }}
            </div>
          </div>
          <div class="outline-header-center-bottom" style="letter-spacing: 0px;">
            <!-- Smart electricity equipment supervision -->
            {{ TittleNameEN }}
          </div>
        </div>
        <div class="outline-header-right" id="step2">
          <Dropdown style="cursor:pointer;">
            <div
              style="color:#fff; text-align: center; width:6vw; line-height:2.5vw; height: 2.5vw;margin-top: 0.675vw;font-size:16px;">
              <span>{{ LangageType == 'zh' ? '中文' : 'English' }}</span>
              <Icon type="md-arrow-dropdown" style="margin-left: 0.2vw;" />
            </div>
            <DropdownMenu slot='list'>
              <DropdownItem @click.native="setLangage('en')">
                English
              </DropdownItem>
              <DropdownItem @click.native="setLangage('zh')">
                中文
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <a @click="showGuide" v-show="showArea">
            <img :src="require('../../assets/newHome/guide.png')" :alt="$t('smartCity.Home.943046-33')"
              :title="$t('smartCity.Home.943046-33')">
          </a>
          <Dropdown>
            <a>
              <img :src="require('../../assets/electricity/switch.png')" :alt="$t('smartCity.Home.943046-1')">
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in HomeModeList" :key="item.id" @click.native="switchIndex(item.code, true)">{{
                item.name }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <img class="cursor" v-if="PlayIndex" @click="StopSound" :src="require('../../assets/electricity/yousheng.png')"
            :alt="$t('smartCity.Home.943046-0')" :title="$t('smartCity.Home.943046-34')">
          <img class="cursor" v-else @click="PlaySound" :src="require('../../assets/electricity/wusheng.png')"
            :alt="$t('smartCity.Home.943046-0')" :title="$t('smartCity.Home.943046-35')">

          <!-- <img src="../../assets/electricity/return.png" :alt="$t('smartCity.Home.943046-42')"> -->
          <Poptip confirm :title="$t('smartCity.Home.943046-2')" placement="top-end" offset='-20' @on-ok="ok"
            @on-cancel="cancel">
            <img class="cursor" :src="require('../../assets/electricity/tuichu.png')" :alt="$t('smartCity.Home.943046-3')"
              :title="$t('smartCity.Home.943046-36')">
          </Poptip>

        </div>
        <div class="outline-and"></div>
      </div>
      <div v-show="showArea" class="outline-content">
        <div class="outline-left">
          <div class="pie-chart">
            <div class="pie-title">{{ $t('smartCity.Home.943046-6') }}</div>
            <div class="pie-card">
              <div id="newChart1" style="height: 100%; width: 100%;"></div>
            </div>
          </div>
          <div class="pie-chart">
            <div class="outline-right-top-list-tab">
              <div class="outline-right-top-tab-item">{{ $t('smartCity.Home.943046-22') }}</div>
              <div class="outline-right-top-tab-item">{{ $t('smartCity.Home.943046-23') }}</div>
              <div class="outline-right-top-tab-item">{{ $t('smartCity.Home.943046-24') }}</div>
            </div>
            <div class="outline-right-top-list" id="wrapper2">
              <div id="content2" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 0">
                <div class="outline-right-top-list-item" v-for="(item, index) in GetDeviceDataLists" :key="index"
                  @dblclick="deviceDetails(item)">
                  <div class="outline-right-top-list-item-time2" style="padding: 0 0.5vw;" :title="item.AddressDetail">
                    {{ item.AddressDetail }}</div>
                  <div class="outline-right-top-list-item-name2">{{ item.UserDeviceName }}</div>
                  <div class="outline-right-top-list-item-group2">
                    <img v-if="item.SwitchStatus == 1" src="../../assets/home/close.png" alt="">
                    <img v-else-if="item.SwitchStatus == 2" src="../../assets/home/open.png" alt="">
                    <span v-else>--</span>
                  </div>
                  <!-- {{item.SwitchStatus == 1 ? $t('smartCity.Home.943046-93') : $t('smartCity.Home.943046-94')}} -->
                </div>
              </div>
              <div id="fakeContent2" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 6"></div>

              <div class="map-right-group-list-none" v-if="GetDeviceDataLists.length == 0">{{
                $t('smartCity.Home.943046-25') }}</div>
              <Spin size="large" fix v-if="!GetDeviceDataListsMsg"></Spin>
            </div>
          </div>
          <div class="outline-right-title">{{ $t('smartCity.Home.943046-28') }}</div>
          <div class="outline-right-bottom">
            <div class="outline-right-bottom-list-tab">
              <div class="outline-right-bottom-tab-item">{{ $t('smartCity.Home.943046-29') }}</div>
              <div class="outline-right-bottom-tab-item">{{ $t('smartCity.Home.943046-30') }}</div>
              <div class="outline-right-bottom-tab-item">{{ $t('smartCity.Home.943046-31') }}</div>
            </div>
            <div class="outline-right-bottom-list">
              <div class="outline-right-top-lists1" v-if="GetOperationDataList.length > 0">
                <div class="outline-right-top-list-item" v-for="(item, index) in GetOperationDataList" :key="index"
                  @dblclick="deviceDetails(item)">
                  <div class="outline-right-top-list-item-time">{{ item.CreateTime }}</div>
                  <div class="outline-right-top-list-item-name">{{ item.UserDeviceName }}</div>
                  <div class="outline-right-top-list-item-group">{{ item.Remark }}</div>
                </div>
              </div>
              <div class="map-right-group-list-none" v-else>{{ $t('smartCity.Home.943046-32') }}</div>
              <Spin size="large" fix v-if="!GetOperationDataListMsg"></Spin>
            </div>
          </div>

        </div>
        <div class="outline-center">
          <div class="center-top">
            <div class="village" id="area">
              <div class="content" :class="{ content2: over }">
                <div class="con" ref="con">
                  <div v-for="item in areaList" :key="item.Id" class="villageTag" @click="setArea(item)">
                    {{ item.Cname }}
                  </div>
                </div>
                <i class="el-icon-arrow-right" v-if="show"
                  style="position: absolute; top: 30px;right: 5px; font-size: 18px; color:'#fff';"
                  @click="handleClick"></i>
                <i class="el-icon-arrow-down" v-if="show2"
                  style="position: absolute; top: 30px;right: 5px; font-size: 18px; color:'#fff';"
                  @click="handleClick"></i>
              </div>

            </div>
            <div class="map" id="myMap" style="margin-top: 95px"></div>
          </div>
          <div class="center-bottom">
            <div class="pie-chart">
              <div class="pie-title">{{ $t('smartCity.Home.943046-37') }}</div>
              <div class="pie-card">
                <div id="newChart4" style="height: 100%; width: 100%;"></div>
              </div>
            </div>
            <div class="other-chart">
              <div id="newChart5" style="height: 100%; width: 100%;"></div>
            </div>
          </div>
        </div>
        <div class="outline-right">
          <div class="pie-chart">
            <div class="pie-title">{{ $t('smartCity.Home.943046-21') }}</div>
            <div class="pie-card">
              <div id="newChart2" style="height: 100%; width: 100%;"></div>
            </div>
          </div>
          <div class="outline-right-middle" v-if="homeType == 'newHome'">
            <div class="outline-right-middle-view" @click="goPages('smartElectricity')" id="smartElectricity">
              <dv-border-box-5 :color="['rgb(42,238,208)', 'rgb(32,148,238)']" :reverse="true" style="overflow: hidden;"
                :key='key1'>
                <div class="outline-right-middle-view-vm">
                  <div class="outline-right-middle-img2">
                    <img src="../../assets/home/btnicon1.png" alt="">
                  </div>
                  <div class="outline-right-middle-view-dev">{{ $t('smartCity.Home.943046-26') }}</div>
                </div>
              </dv-border-box-5>
            </div>
            <div class="outline-right-middle-view" @click="goPages('bigScreen')" id="useGas">
              <dv-border-box-5 :color="['rgb(42,238,208)', 'rgb(32,148,238)']" style="overflow: hidden;" :key='key2'>
                <div class="outline-right-middle-view-vm">
                  <div class="outline-right-middle-img2">
                    <img src="../../assets/home/btnicon2.png" alt="">
                  </div>
                  <div class="outline-right-middle-view-dev">{{ $t('smartCity.Home.943046-27') }}</div>
                </div>
              </dv-border-box-5>
            </div>
          </div>
          <div class="outline-left-title">{{ $t('smartCity.Home.943046-4') }}</div>
          <div class="outline-left-list" id="wrapper3">
            <div id="content3" class="outline-left-lists2" :class="{ 'outline_offset': offsetMsg }"
              v-if="GetAbDataLists.length > 0">
              <div class="outline-left-top-item" v-for="(item, index) in GetAbDataLists" :key="item.Id"
                @dblclick="deviceDetails(item)">
                <Tooltip :content="item.AbnormalTime" placement="right">
                  <div class="outline-left-top-item-time">
                    <div class="outline-left-top-item-time-bg-img">
                      <img v-if="index < 3"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAUCAYAAAA5g+sCAAAA/UlEQVRYhe2YPQrCQBBGX4InsBH1EtbeQAtvIBaKhXcS7MXCRo9gqb210cLewl8WRxAnrqJB2HUfBMK3IWxekmF2o/08qgF9oIhbrIE2ME2bda5yUpkNIyJxUMINI6Ok0g9ExA5LIMu5xyr5U4IIIYgQcirxnMMi/d2np27RymK2PogYAGOgoEbsmP4pkaNm+oiz9XJ32AI9YMhDH3FYxK+ece1TscwDZZW+R+RLsdwBTWCkRq5fR3Q7vyuWdVlaHIGuDyLML9EAZmrEzuS+M/VBRBVYqvQJz9YgPtSItyXYCJ2lEEQIQYQQy+aGq2yyFNHJ8oY/ZCVbdd8DXADvhSzN7qNDBAAAAABJRU5ErkJggg=="
                        alt="">
                      <img v-else
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAUCAYAAAA5g+sCAAABFUlEQVRYhe2Yv2oCQRCHvzsOOxuLhGCZxme4NzBF3kBCiFgErPIcNlofGizFwsY8QcgjWIilf5B0KQJBSTiYgyNjjkMPYTf7wcLyG3YZfswOw3q1sFsHIuAKs1gDD8DLoaxnr22lZeEbagKSc6TUI/ENNSGhsNx9pfxTnBGCM0JwRgiBUszjDnjOm3WjvVAallTEAJgAlyqSTTw/rWTVbaiImFsgBB6B0e/g/dP2O9kHpbI6vPv6iGzqERWgqtR8eLZUxGf8/IGxigD9zoWX7FM94kYm0z3QssGId3kabyqSzTQ9mdpgRNwb5kr9g2Hv+mDAhh6R24Qs3EAlOCMEZ4Tgy0+PqWyKNKJZ5IVnZClfdacD/ADsAigQ3sKtDwAAAABJRU5ErkJggg=="
                        alt="">
                    </div>
                    <template v-if="index < 3">
                      <span style="color: #000000;">{{ item.AbnormalTime | intercept }}</span>
                    </template>
                    <template v-else>
                      <span style="color: #fff;">{{ item.AbnormalTime | intercept }}</span>
                    </template>
                  </div>
                </Tooltip>

                <div class="outline-left-top-item-name">
                  {{ item.UserDeviceName }}
                </div>
                <div class="outline-left-top-item-group">{{ item.AbnormalName }}</div>
              </div>
            </div>
            <div id="fakeContent3" class="outline-left-lists" :class="{ 'outline_offset': offsetMsg }"
              v-if="GetAbDataLists.length > 6"></div>
            <div class="map-right-group-list-none" v-else>{{ $t('smartCity.Home.943046-5') }}</div>

            <Spin size="large" fix v-if="!GetAbDataListsMsg"></Spin>
          </div>
        </div>
      </div>
      <div v-show="!showArea" class="outline-content">
        <div class="mode">
          <div id="gasModeTag" @click="switchMode('gas')" class="mode-tag"
            :class="[mode == 'gas' ? 'mode-tag-selected' : 'mode-tag-unselected']" v-show="!isDetail">
            <img class="mode-icon"
              :src="mode == 'gas' ? require('../../assets/newHome/village/gasModeActive.png') : require('../../assets/newHome/village/gasMode.png')" />
            <span>{{ $t('smartCity.Home.943046-38') }}</span>
          </div>
          <div id="mapModeTag" @click="switchMode('map')" class="mode-tag"
            :class="[mode == 'map' ? 'mode-tag-selected' : 'mode-tag-unselected']" v-show="!isDetail">
            <img class="mode-icon"
              :src="mode == 'map' ? require('../../assets/newHome/village/mapModeActive.png') : require('../../assets/newHome/village/mapMode.png')" />
            <span>{{ $t('smartCity.Home.943046-39') }}</span>
          </div>
          <div id="tableModeTag" @click="switchMode('table')" class="mode-tag"
            :class="[mode == 'table' ? 'mode-tag-selected' : 'mode-tag-unselected']">
            <img class="mode-icon"
              :src="mode == 'table' ? require('../../assets/newHome/village/tableModeActive.png') : require('../../assets/newHome/village/tableMode.png')" />
            <span>{{ $t('smartCity.Home.943046-40') }}</span>
          </div>
          <div id="cardModeTag" @click="switchMode('card')" class="mode-tag"
            :class="[mode == 'card' ? 'mode-tag-selected' : 'mode-tag-unselected']">
            <img class="mode-icon"
              :src="mode == 'card' ? require('../../assets/newHome/village/cardModeActive.png') : require('../../assets/newHome/village/cardMode.png')" />
            <span>{{ $t('smartCity.Home.943046-41') }}</span>
          </div>
          <div class="backTag" v-show="!showArea" @click="back()" id="backTag">{{ $t('smartCity.Home.943046-42') }}</div>
        </div>

        <div class="village-left">
          <div class="villageTagActive cursor" @click="level > 2 ? preLevel() : setVillage(selectedVillage);"
            id="preLevelTag">
            {{ (level == 4 && selectedThreeLevel.Sname) || (level == 3 && selectedVillage.Vname) || (level == 2 &&
              selectedArea.Cname) }}
          </div>
          <div class="sVillage-card" id="menu-left">
            <div style="position: absolute; left: 10px; top: 10px; color: #FFF; font-size: 12px; cursor: pointer;"
              v-show="level > 2" @click="preLevel">{{ $t('smartCity.Home.943046-43') }}</div>
            <div class="sVillage-item" v-for="(item, index) in villageList" v-show="level == 2">
              <div class="sVillage" :key="item.Id" @click="setVillage(item)"
                :class="{ 'village-active': selectedVillage.Vname == item.Vname }">{{ item.Vname }}</div>
              <div @click="getThreeLevelList(item)" style="font-size: 12px; cursor: pointer;">{{
                $t('smartCity.Home.943046-44') }}</div>
            </div>
            <div class="sVillage-item" v-for="(item, index) in threeLevelList" v-show="level == 3">
              <div class="sVillage" :key="item.Id" @click="setThreeLevel(item)"
                :class="{ 'village-active': selectedThreeLevel.Sname == item.Sname }">{{ item.Sname }}</div>
              <div @click="getFourLevelList(item)" style="font-size: 12px; cursor: pointer;">{{
                $t('smartCity.Home.943046-44') }}</div>
            </div>
            <div class="sVillage-item" v-for="(item, index) in fourLevelList" v-show="level == 4">
              <div class="cursor" :key="item.Id" @click="setFourLevel(item)"
                :class="{ 'village-active': selectedFourLevel.Zname == item.Zname }">{{ item.Zname }}</div>
            </div>
          </div>
        </div>

        <div class="village-right" v-show="mode == 'map'" id="mapModeMain">
          <div class="village-right-top">
            <div class="top-card cursor" @click="openPopup(4, $t('smartCity.Home.943046-15'))">
              <div>{{ $t('smartCity.Home.943046-15') }}</div>
              <div class="num">{{ GetNavDataYHJsNew.abDevice }}<span class="unit">{{ $t('smartCity.Home.943046-45')
              }}</span></div>
            </div>
            <div class="top-card cursor" @click="openPopup(2, $t('smartCity.Home.943046-46'), 1)">
              <div>{{ $t('smartCity.Home.943046-46') }}</div>
              <div class="num">{{ GetNavDataYHJsNew.ZxDevice }}<span class="unit">{{ $t('smartCity.Home.943046-45')
              }}</span></div>
            </div>
            <div class="top-card cursor" @click="openPopup(2, $t('smartCity.Home.943046-47'), 0)">
              <div>{{ $t('smartCity.Home.943046-47') }}</div>
              <div class="num">{{ GetNavDataYHJsNew.LxDevice }}<span class="unit">{{ $t('smartCity.Home.943046-45')
              }}</span></div>
            </div>
            <div class="top-card cursor" @click="openPopup(6, $t('smartCity.Home.943046-48'))">
              <div>{{ $t('smartCity.Home.943046-49') }}</div>
              <div class="num">{{ GetNavDataYHJsNew.currentTenant }}<span class="unit">{{ $t('smartCity.Home.943046-50')
              }}</span></div>
            </div>
            <div class="top-card cursor" @click="openPopup(3, $t('smartCity.Home.943046-51'), 1)">
              <div>{{ $t('smartCity.Home.943046-51') }}</div>
              <div class="num">{{ GetNavDataYHJsNew.todayAbWeiSolve }}<span class="unit">{{ $t('smartCity.Home.943046-52')
              }}</span></div>
            </div>
          </div>
          <div class="village-right-bottom">
            <div class="areaMap">
              <div class="areaMap" id="areaMap"></div>
              <Spin size="large" fix v-if="mapSpin"></Spin>
            </div>
            <div class="village-right-bottom-right">
              <div class="right-card" @click="openPopup(2.5, $t('smartCity.Home.943046-53'), '', 'wd')">
                <div>{{ $t('smartCity.Home.943046-54') }}</div>
                <div class="num">{{ deviceCatCountList.length && deviceCatCountList[0].value }}<span class="unit">{{
                  $t('smartCity.Home.943046-45') }}</span>
                </div>
              </div>
              <div class="right-card" @click="openPopup(2.5, $t('smartCity.Home.943046-55'), '', 'qg1')">
                <div>{{ $t('smartCity.Home.943046-56') }}</div>
                <div class="num">{{ deviceCatCountList.length && deviceCatCountList[1].value }}<span class="unit">{{
                  $t('smartCity.Home.943046-45') }}</span>
                </div>
              </div>
              <div class="right-card" @click="openPopup(2.5, $t('smartCity.Home.943046-57'), '', 'yg')">
                <div>{{ $t('smartCity.Home.943046-58') }}</div>
                <div class="num">{{ deviceCatCountList.length && deviceCatCountList[2].value }}<span class="unit">{{
                  $t('smartCity.Home.943046-45') }}</span>
                </div>
              </div>
              <div class="right-card" @click="openPopup(2.5, $t('smartCity.Home.943046-59'), '', 'rqdcf')">
                <div>{{ $t('smartCity.Home.943046-60') }}</div>
                <div class="num">{{ deviceCatCountList.length && deviceCatCountList[3].value }}<span class="unit">{{
                  $t('smartCity.Home.943046-45') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="village-right" v-show="!isDetail && (mode == 'table' || mode == 'card')">
          <div class="table-top">
            <div class="table-top-left">
              <div class="title">
                <img src="../../assets/newHome/village/tableIcon.png" style="margin-right: 0.5vw; width: 1vw" />
                <div>{{ selectedFourLevel.Zname || selectedThreeLevel.Sname || selectedVillage.Vname || selectedArea.Cname
                }}</div>
              </div>
              <div class="status cursor" @click="userSearch('0')">
                <div class="circle" style="background-color: #2a7abe;" />
                <div :style="{ color: (userSearchForm.RunStatus == '0' ? '#0efcff' : '') }">{{
                  $t('smartCity.Home.943046-61') }}</div>
              </div>
              <div class="status cursor" @click="userSearch('1')">
                <div class="circle" style="background-color: #d6412d;" />
                <div :style="{ color: (userSearchForm.RunStatus == '1' ? '#0efcff' : '') }">{{
                  $t('smartCity.Home.943046-62') }}</div>
              </div>
            </div>
            <div class="table-top-right">
              <Input v-model="userSearchForm.OwnerName" :placeholder="$t('smartCity.Home.943046-63')" style="width:200px"
                clearable />
              <Button type="primary" @click="UserPageIndex = 1, GetRoshRoomAll()">{{ $t('smartCity.Home.943046-64')
              }}</Button>
              <Button type="warning" @click="userFormReset">{{ $t('smartCity.Home.943046-65') }}</Button>
            </div>
          </div>
          <div class="user-table" v-show="mode == 'table'" id="userTable">
            <Table height="640" :columns="columns1" :data="GetRoshRoomAllLists" @on-row-dblclick="rowDbClick"
              @on-cell-click="cellClick" border :key="tableKey">
              <template slot-scope="{ row }" slot="RoomType">
                {{ row.RoomType === 1 ? $t('smartCity.Home.943046-66') : row.RoomType === 2 ?
                  $t('smartCity.Home.943046-67') : '' }}
              </template>
              <template slot-scope="{ row }" slot="YearExamState">
                {{ row.YearExamState === '1' ? $t('smartCity.Home.943046-68') : row.YearExamState === '2' ?
                  $t('smartCity.Home.943046-69') : '' }}
              </template>
              <template slot-scope="{ row }" slot="RunStatus">
                {{ statusToStr(row.RunStatus) }}
              </template>
              <template slot-scope="{ row }" slot="Jdzsyxq">
                {{ formDateNew(row.Jdzsyxq_start) }} - {{ formDateNew(row.Jdzsyxq_end) }}
              </template>
              <template slot-scope="{ row }" slot="action">
                <div style="display: flex;">
                  <Button style="margin-right: 8px;" type="primary" @click="userOption('showPics', row)">{{
                    $t('smartCity.Home.943046-70') }}</Button>
                  <Button type="success" @click="userOption('edit', row)">{{ $t('smartCity.Home.943046-71') }}</Button>
                  <!-- <Button style="" type="error" @click="userOption('del', row)">{{ $t('smartCity.Home.943046-87') }}</Button> -->
                </div>
              </template>
            </Table>
            <Page :total="UserTotalCount" @on-change="UserPageChange" style="align-self: center;"
              :page-size="UserPageSize" :page-size-opts="[12, 20, 30, 40]" @on-page-size-change="UserPageSizeChange"
              :current="UserPageIndex" show-sizer show-elevator show-total />
          </div>
          <div class="card-contianer" v-show="mode == 'card'" id="userCard">
            <div class="card-wrapper">
              <div v-for="item in GetRoshRoomAllLists" class="card" @click="rowDbClick(item)">
                <div class="card-status" :class="{
                  'statu0': item.RunStatus == '0' || !item.RunStatus,
                  'statu2': item.RunStatus == '1'
                }">
                  {{ statusToStr(item.RunStatus) }}
                </div>
                <img class="avatar" :src="item.HeadImg || require('../../assets/newHome/village/avator.png')" />
                <div class="user-info">
                  <div>{{ $t('smartCity.Home.943046-63') }}：{{ item.OwnerName }}</div>
                  <div>{{ $t('smartCity.Home.943046-73') }}{{ item.Vname }}</div>
                  <div>{{ $t('smartCity.Home.943046-74') }}{{ item.OwnerPhone }}</div>
                  <div style="text-overflow: ellipsis; white-space: nowrap; width: 12vw; overflow: hidden;"
                    :title="item.RoomAddress">{{ $t('smartCity.Home.943046-75') }}{{ item.RoomAddress }}</div>
                  <div>{{ $t('smartCity.Home.943046-76') }}{{ item.CreateDate }}</div>
                </div>
                <div style="display: flex; flex-wrap: wrap; justify-content: center; width: 100%">
                  <Button style="margin-right: 8px;" type="primary" @click.stop="userOption('showPics', item)">{{
                    $t('smartCity.Home.943046-70') }}</Button>
                  <Button type="success" @click.stop="userOption('edit', item)">{{ $t('smartCity.Home.943046-71')
                  }}</Button>
                  <!-- <Button style="" type="error" @click.stop="userOption('del', item)">{{ $t('smartCity.Home.943046-87') }}</Button> -->
                </div>
              </div>
            </div>
            <Page :total="UserTotalCount" @on-change="UserPageChange" style="align-self: center;"
              :page-size="UserPageSize" :page-size-opts="[12, 20, 30, 40]" @on-page-size-change="UserPageSizeChange"
              :current="UserPageIndex" show-sizer show-elevator show-total />
          </div>
        </div>

        <div class="village-right" v-show="mode == 'gas'">
          <div class="table-top">
            <div class="table-top-left">
              <div class="title">
                <img src="../../assets/newHome/village/tableIcon.png" style="margin-right: 0.5vw; width: 1vw" />
                <div>{{ selectedFourLevel.Zname || selectedThreeLevel.Sname || selectedVillage.Vname || selectedArea.Cname
                }}</div>
              </div>
            </div>
            <div class="table-top-right">
              <Input v-model="gasQueryModel.Qjmc" :placeholder="$t('smartCity.Home.943046-77')" style="width:200px"
                clearable />
              <Button type="primary" @click="gasPage.pageIndex = 1, getGasList()">{{ $t('smartCity.Home.943046-64')
              }}</Button>
              <Button type="warning" @click="gasQueryModel = {}, getGasList()">{{ $t('smartCity.Home.943046-65')
              }}</Button>
              <Button type="success" @click="getAllSelection(), gasQueryState = true">{{ $t('smartCity.Home.943046-78')
              }}</Button>
              <Button type="info" @click="gasOption('add')">{{ $t('smartCity.Home.943046-79') }}</Button>
            </div>
          </div>
          <div class="gas-table">
            <Table height="600" :columns="columns3" :data="gasList" border id="gasTable" :key="tableKey">
              <template slot-scope="{ row }" slot="Xsfs">
                {{ row.Xsfs == '1' ? $t('smartCity.Home.943046-80') : $t('smartCity.Home.943046-81') }}
              </template>
              <template slot-scope="{ row }" slot="Lzsyfs">
                {{ row.Lzsyfs == '0' ? $t('smartCity.Home.943046-82') : row.Lzsyfs == '1' ? $t('smartCity.Home.943046-83')
                  : row.Lzsyfs == '2' ? $t('smartCity.Home.943046-84') : '/' }}
              </template>
              <template slot-scope="{ row }" slot="Lzsyrq">
                {{ formDate(row.Lzsyrq).slice(0, 11) }}
              </template>
              <template slot-scope="{ row }" slot="Jlxnfhx">
                {{ row.Jlxnfhx == '0' ? $t('smartCity.Home.943046-69') : row.Jlxnfhx == '1' ?
                  $t('smartCity.Home.943046-68') : row.Jlxnfhx == '2' ? $t('smartCity.Home.943046-85') : row.Jlxnfhx == '3'
                    ? $t('smartCity.Home.943046-86') : '/' }}
              </template>
              <template slot-scope="{ row }" slot="action">
                <div style="display: flex;">
                  <Button style="margin-right: 8px;" type="success" @click="gasOption('edit', row)">{{
                    $t('smartCity.Home.943046-71') }}</Button>
                  <Button style="" type="error" @click="gasOption('del', row)">{{ $t('smartCity.Home.943046-87')
                  }}</Button>
                </div>
              </template>
            </Table>
            <Page :total="gasPage.TotalCount" @on-change="GasPageChange" style="align-self: center;"
              :page-size="gasPage.pageSize" @on-page-size-change="GasPageSizeChange" :current="gasPage.pageIndex"
              show-sizer show-elevator show-total />
          </div>
        </div>

        <div class="village-right" v-show="isDetail">
          <div class="table-top">
            <div class="table-top-left">
              <div class="title">
                <img src="../../assets/newHome/village/tableIcon.png" style="margin-right: 0.5vw; width: 1vw" />
                <div>{{ selectedDevice.UserDeviceName || selectedUser.OwnerName }}</div>
              </div>
              <div class="status cursor" @click="deviceSearch('0')">
                <div class="circle" style="background-color: #2a7abe;" />
                <div :style="{ color: (deviceSearchForm.RunStatus == '0' ? '#0efcff' : '') }">{{
                  $t('smartCity.Home.943046-61') }}</div>
              </div>
              <div class="status cursor" @click="deviceSearch('1')">
                <div class="circle" style="background-color: #d6412d;" />
                <div :style="{ color: (deviceSearchForm.RunStatus == '1' ? '#0efcff' : '') }">{{
                  $t('smartCity.Home.943046-62') }}</div>
              </div>
              <!-- <div class="status cursor" @click="deviceSearch('', 0)">
                <div class="circle" style="background-color: #696969;"/>
                <div :style="{ color:(deviceSearchForm.onlineState === 0 ? '#0efcff': '') }">{{ $t('smartCity.Home.943046-92') }}</div>
              </div> -->
            </div>
            <div class="table-top-right">
              <span style="color: #FFF;">{{ $t('smartCity.Home.943046-88') }}</span>
              <Select v-model="deviceSearchForm.DeviceType" style="width:200px" clearable
                :placeholder="$t('smartCity.Home.943046-89')">
                <Option value="wd">{{ $t('smartCity.Home.943046-53') }}</Option>
                <Option value="qg1">{{ $t('smartCity.Home.943046-55') }}</Option>
                <Option value="yg">{{ $t('smartCity.Home.943046-57') }}</Option>
                <Option value="rqdcf">{{ $t('smartCity.Home.943046-60') }}</Option>
              </Select>
              <Input v-model="deviceSearchForm.deviceName" clearable :placeholder="$t('smartCity.Home.943046-23')"
                style="width:200px" />
              <Input v-model="deviceSearchForm.deviceCode" clearable :placeholder="$t('smartCity.Home.943046-90')"
                style="width:200px" />
              <Button type="primary" @click="devicePage = 1, getUserDevice()">{{ $t('smartCity.Home.943046-64')
              }}</Button>
              <Button type="warning" @click="clear">{{ $t('smartCity.Home.943046-65') }}</Button>
            </div>
          </div>
          <div class="user-table-detail" v-show="mode == 'table'" id="deviceTable">
            <Table height="540" :columns="columns2" :data="userDeviceList" @on-row-click="selectDevice" border
              highlight-row :key="tableKey">
              <template slot-scope="{ row }" slot="IsHealth">
                {{ IsHealthToStr(row.IsHealth, row.IsOnline) }}
              </template>
              <template slot-scope="{ row }" slot="DeviceId">
                {{ DeviceIdToStr(row.DeviceId, row.DeviceItemId) }}
              </template>
              <template slot-scope="{ row }" slot="IsOnline">
                <img v-if="row.IsOnline" src="@/assets/newHome/village/online.png"
                  :title="$t('smartCity.Home.943046-91')" />
                <img v-else src="@/assets/newHome/village/offline.png" :title="$t('smartCity.Home.943046-92')">
              </template>
              <template slot-scope="{ row }" slot="SwitchStatus">
                <div v-if="row.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'">
                  <img v-if="row.SwitchStatus == 1" :src="getSwitchImg(row)" :title="$t('smartCity.Home.943046-93')" />
                  <img v-else :src="getSwitchImg(row)" :title="$t('smartCity.Home.943046-94')" />
                </div>
                <!-- <img :src="getSwitchImg(row)"/> -->
              </template>
              <template slot-scope="{ row }" slot="action">
                <div style="display: flex; flex-wrap: wrap">
                  <Button style="margin-right: 8px;" type="primary" @click="deviceOption(1, row)">{{
                    $t('smartCity.Home.943046-95') }}</Button>
                  <Button style="margin-right: 8px;" type="success" @click="deviceOption(2, row)">{{
                    $t('smartCity.Home.943046-96') }}</Button>
                  <Button style="margin-right: 8px;" type="warning" @click="deviceOption(3, row)">{{
                    $t('smartCity.Home.943046-97') }}</Button>
                  <Button type="error" @click.stop="deviceOption(4, row, $event)">{{ $t('smartCity.Home.943046-98')
                  }}</Button>
                </div>
              </template>
            </Table>
            <Page :total="deviceTotal" @on-change="DevicePageChange" style="align-self: center;"
              :page-size="devicePageSize" @on-page-size-change="DevicePageSizeChange" :current="devicePage" show-sizer
              show-elevator show-total />
          </div>
          <div class="detail-card-contianer" v-show="mode == 'card'" id="deviceCard">
            <div class="card-wrapper">
              <div v-for="item in userDeviceList" class="card" @click="selectDevice(item)"
                :class="{ 'card-active': selectedDevice.Id == item.Id }">
                <div class="card-top"
                  :style="{ backgroundColor: (selectedDevice.Id == item.Id ? '#35a2ff' : '#055ba4') }">
                  {{ DeviceIdToStr(item.DeviceId, item.DeviceItemId) }}
                </div>
                <div class="card-bottom">
                  <div class="card-bottom-top">
                    <div class="card-status" :class="[item.IsHealth == 1 ? 'statu0' : 'statu2']">
                      {{ IsHealthToStr(item.IsHealth, item.IsOnline) }}
                    </div>
                    <img class="avatar" :src="getDeviceImg(item)" />
                    <div class="device-info">
                      <div class="nowrap">{{ $t('smartCity.Home.943046-23') }}：{{ item.UserDeviceName }}</div>
                      <div :title="item.DeviceCode" class="nowrap">{{ $t('smartCity.Home.943046-90') }}：{{ item.DeviceCode
                      }}</div>
                      <div class="nowrap">{{ $t('smartCity.Home.943046-101') }}{{ item.UpdateTime }}</div>
                      <div :title="item.Address" class="nowrap">{{ $t('smartCity.Home.943046-102') }}{{ item.Address }}
                      </div>
                      <div v-if="DeviceIdToStr(item.DeviceId, item.DeviceItemId) == $t('smartCity.Home.943046-53')">{{
                        $t('smartCity.Home.943046-24') }}：{{ item.SwitchStatus == 1
    ? $t('smartCity.Home.943046-93') : item.SwitchStatus == 2 ? $t('smartCity.Home.943046-94') :
      $t('smartCity.Home.943046-82') }}</div>
                    </div>
                  </div>
                  <div class="card-bottom-bottom">
                    <Button style="margin-right: 8px;" type="primary" @click="deviceOption(1, item)">{{
                      $t('smartCity.Home.943046-95') }}</Button>
                    <Button style="margin-right: 8px;" type="success" @click="deviceOption(2, item)">{{
                      $t('smartCity.Home.943046-96') }}</Button>
                    <Button style="margin-right: 8px;" type="warning" @click="deviceOption(3, item)">{{
                      $t('smartCity.Home.943046-97') }}</Button>
                    <Button type="error" @click.stop="deviceOption(4, item, $event)">{{ $t('smartCity.Home.943046-98')
                    }}</Button>
                  </div>
                </div>
              </div>
              <div v-if="!userDeviceList.length" class="card">
                <div class="card-top"></div>
                <div class="card-bottom" style="display: flex; justify-content: center; align-items: center;">{{
                  $t('smartCity.Home.943046-104') }}</div>
              </div>
            </div>
            <Page :total="deviceTotal" @on-change="DevicePageChange" style="align-self: center;"
              :page-size="devicePageSize" @on-page-size-change="DevicePageSizeChange" :current="devicePage" show-sizer
              show-elevator show-total />
          </div>
          <Tabs v-model="tabValue" class="tab">
            <TabPane :label="$t('smartCity.Home.943046-105')" name="tab1">
              <div class="info-card-contianer">
                <template v-if="selectedDevice.DeviceId != '7febbea4-0326-496d-9b71-5b058729cb42'">
                  <div class="info-card" v-for="(item, index) in DeviceParameterLookLists" :key="index">
                    <span class="label">{{ item.ParamName }}</span>
                    <div class="info-card-bottom">
                      <span>{{ item.ParamValue ? item.ParamValue : 0 }}</span>
                      <span>{{ item.ParamUnit }}</span>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div class="info-card" v-if="DeviceInfoBaseModel.GongNengKaiGuanZhuangTai">
                    <span class="label">{{ $t('smartCity.Home.943046-106') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.GongNengKaiGuanZhuangTai }}</span>
                    </div>
                  </div>
                  <div class="info-card" v-if="DeviceInfoBaseModel.DianCiType">
                    <span class="label">{{ $t('smartCity.Home.943046-107') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.DianCiType }}</span>
                    </div>
                  </div>

                  <div class="info-card" v-if="DeviceInfoBaseModel.DianCiDianLiangZhuangTai">
                    <span class="label">{{ $t('smartCity.Home.943046-108') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.DianCiDianLiangZhuangTai }}</span>
                    </div>
                  </div>
                  <div class="info-card" v-if="DeviceInfoBaseModel.DianCiDianYa">
                    <span class="label">{{ $t('smartCity.Home.943046-109') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.DianCiDianYa }}</span>
                    </div>
                  </div>

                  <div class="info-card" v-if="DeviceInfoBaseModel.DaKaiGuanBi">
                    <span class="label">{{ $t('smartCity.Home.943046-110') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.DaKaiGuanBi }}</span>
                    </div>
                  </div>
                  <div class="info-card" v-if="DeviceInfoBaseModel.FangCai">
                    <span class="label">{{ $t('smartCity.Home.943046-111') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.FangCai }}</span>
                    </div>
                  </div>

                  <div class="info-card" v-if="DeviceInfoBaseModel.ShiDuZhi">
                    <span class="label">{{ $t('smartCity.Home.943046-112') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.ShiDuZhi }}</span>
                    </div>
                  </div>
                  <div class="info-card" v-if="DeviceInfoBaseModel.WenDuZhi">
                    <span class="label">{{ $t('smartCity.Home.943046-113') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.WenDuZhi }}</span>
                    </div>
                  </div>

                  <div class="info-card" v-if="DeviceInfoBaseModel.baojingleixing">
                    <span class="label">{{ $t('smartCity.Home.943046-110') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.baojingleixing }}</span>
                    </div>
                  </div>
                  <div class="info-card" v-if="DeviceInfoBaseModel.fangcai">
                    <span class="label">{{ $t('smartCity.Home.943046-111') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.fangcai }}</span>
                    </div>
                  </div>
                  <div class="info-card" v-if="DeviceInfoBaseModel.CommandWenzi">
                    <span class="label">{{ $t('smartCity.Home.943046-110') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.CommandWenzi }}</span>
                    </div>
                  </div>
                  <div class="info-card" v-if="DeviceInfoBaseModel.Commandma">
                    <span class="label">{{ $t('smartCity.Home.943046-111') }}</span>
                    <div class="info-card-bottom">
                      <span>{{ DeviceInfoBaseModel.Commandma }}</span>
                    </div>
                  </div>

                  <template v-if="!DeviceInfoBaseModel.GongNengKaiGuanZhuangTai">
                    <div class="info-card" v-if="DeviceInfoBaseModel.Commandma">
                      <span class="label">{{ $t('smartCity.Home.943046-114') }}</span>
                      <div class="info-card-bottom">
                        <span>{{ DeviceDianCiModel.GongDianFangSi }}</span>
                      </div>
                    </div>
                    <div class="info-card" v-if="DeviceInfoBaseModel.Commandma">
                      <span class="label">{{ $t('smartCity.Home.943046-115') }}</span>
                      <div class="info-card-bottom">
                        <span>{{ DeviceDianCiModel.DianCiGongDian }}</span>
                      </div>
                    </div>
                    <div class="info-card" v-if="DeviceInfoBaseModel.Commandma">
                      <span class="label">{{ $t('smartCity.Home.943046-116') }}</span>
                      <div class="info-card-bottom">
                        <span>{{ DeviceDianCiModel.DianCiDianLiang }}</span>
                      </div>
                    </div>
                    <div class="info-card" v-if="DeviceInfoBaseModel.Commandma">
                      <span class="label">{{ $t('smartCity.Home.943046-117') }}</span>
                      <div class="info-card-bottom">
                        <span>{{ DeviceDianCiModel.DianCiDianYa }}{{ DeviceDianCiModel.DianYaDanWei }}</span>
                      </div>
                    </div>
                    <div class="info-card" v-if="DeviceInfoBaseModel.Commandma">
                      <span class="label">{{ $t('smartCity.Home.943046-118') }}</span>
                      <div class="info-card-bottom">
                        <span>{{ DeviceDianCiModel.DianCiDianLiangBaiFenBi }}</span>
                      </div>
                    </div>
                  </template>

                </template>
              </div>
            </TabPane>
            <TabPane :label="$t('smartCity.Home.943046-119')" name="tab2">
              <div class="status-list">
                <Button class="tag" :class="[pstate == 1 ? 'statu2Active' : 'statu2']" @click="pstateChange(1)">{{
                  $t('smartCity.Home.943046-120') }}</Button>
                <Button class="tag" :class="[pstate == 3 ? 'statu1Active' : 'statu1']" @click="pstateChange(3)">{{
                  $t('smartCity.Home.943046-121') }}</Button>
                <Button class="tag" :class="[pstate == 2 ? 'statu0Active' : 'statu0']" @click="pstateChange(2)">{{
                  $t('smartCity.Home.943046-7') }}</Button>
              </div>
              <div class="alarm-info" v-for="item in AbnormalList">
                <div>
                  <span style="color: aqua; margin-right: 2vw;">{{ item.UserDeviceName }}</span>
                  <span>{{ item.AbnormalTime }}</span>
                  <span style="float: right; padding: 0.1vw 0.8vw; color: #FFF" :class="{
                    'statu2': item.ProcessStatus == 1,
                    'statu0': item.ProcessStatus == 2,
                    'statu1': item.ProcessStatus == 3
                  }">{{ ProcessStatusToStr(item.ProcessStatus) }}</span>
                </div>
                <div style="margin-top: 1vh; margin-bottom: 0.5vh;">
                  <span class="mr">{{ $t('smartCity.Home.943046-122') }}{{ item.CurrentValue }}</span>
                  <span class="mr">{{ $t('smartCity.Home.943046-123') }}{{ item.RatedValue }}</span>
                  <span class="mr">{{ $t('smartCity.Home.943046-124') }}{{ item.BalaceValue }}</span>
                </div>
                <div>
                  <span class="mr">{{ $t('smartCity.Home.943046-125') }}{{ item.AbnormalName }}</span>
                  <span class="mr">{{ $t('smartCity.Home.943046-126') }}{{ item.AbnormalCode }}</span>
                  <span class="mr">{{ $t('smartCity.Home.943046-127') }}{{ item.AbnormalType }}</span>
                </div>
              </div>
              <Page :total="AbnormalTotal" @on-change="AbnormalPageChange" :page-size="AbnormalPageSize"
                :current="AbnormalPage" style="text-align: center; margin: 2vh 0;" show-elevator show-total />
            </TabPane>
            <TabPane :label="$t('smartCity.Home.943046-128')" name="tab3">
              <div class="info-card-contianer">
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-89') }}</span>
                  <div class="info-card-bottom">{{ userEx.DeviceType || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-130') }}</span>
                  <div class="info-card-bottom">{{ userEx.ProvinceName || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-131') }}</span>
                  <div class="info-card-bottom">{{ userEx.CcodeName || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-132') }}</span>
                  <div class="info-card-bottom">{{ userEx.VcodeName || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-133') }}</span>
                  <div class="info-card-bottom">{{ userEx.ScodeName || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-134') }}</span>
                  <div class="info-card-bottom">{{ userEx.ZcodeName || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-135') }}</span>
                  <div class="info-card-bottom">{{ userEx.OwnerName || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-136') }}</span>
                  <div class="info-card-bottom">{{ userEx.OwnerPhone || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-137') }}</span>
                  <div class="info-card-bottom">{{ userEx.Jd || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-138') }}</span>
                  <div class="info-card-bottom">{{ userEx.Wd || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card"><span class="label">{{ $t('smartCity.Home.943046-139') }}</span>
                  <div class="info-card-bottom">{{ userEx.CreateTime || $t('smartCity.Home.943046-129') }}</div>
                </div>
                <div class="info-card" v-if="selectedDevice.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"><span
                    class="label">几P{{ $t('smartCity.Home.943046-30') }}</span>
                  <div class="info-card-bottom">{{ userEx.DeviceP || $t('smartCity.Home.943046-129') }}</div>
                </div>
              </div>
            </TabPane>
            <TabPane v-if="selectedDevice.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
              :label="$t('smartCity.Home.943046-141')" name="tab4">
              <div class="tag-list">
                <div class="chart-tag" :class="[checkCode === 'Axiangdianya' ? 'tag-selected' : 'tag-unselected']"
                  @click="getDeviceCheckDataABCxiang_T('Axiangdianya')">{{ $t('smartCity.Home.943046-142') }}</div>
                <div class="chart-tag" :class="[checkCode === 'Axiangdianliu' ? 'tag-selected' : 'tag-unselected']"
                  @click="getDeviceCheckDataABCxiang_T('Axiangdianliu')">{{ $t('smartCity.Home.943046-143') }}</div>
                <div class="chart-tag" :class="[checkCode === 'Axiangwendu' ? 'tag-selected' : 'tag-unselected']"
                  @click="getDeviceCheckDataABCxiang_T('Axiangwendu')">{{ $t('smartCity.Home.943046-144') }}</div>
                <div class="chart-tag" :class="[checkCode === 'yggl' ? 'tag-selected' : 'tag-unselected']"
                  @click="getDeviceCheckDataGL_T('yggl')">{{ $t('smartCity.Home.943046-145') }}</div>
                <div class="chart-tag" :class="[checkCode === 'wggl' ? 'tag-selected' : 'tag-unselected']"
                  @click="getDeviceCheckDataGL_T('wggl')">{{ $t('smartCity.Home.943046-146') }}</div>
                <div class="chart-tag" :class="[checkCode === 'Zongloudian' ? 'tag-selected' : 'tag-unselected']"
                  @click="getDeviceCheckDataV2_T('Zongloudian')">{{ $t('smartCity.Home.943046-147') }}</div>
              </div>
              <div style="background-color: #1b2535; padding: 5vh 2vw; height: 60vh; width: 100%; margin-top: 2vh;">
                <div id="tab4Chart" class="chart" style="height: 100%; width: 100%;" />
              </div>
            </TabPane>
            <TabPane v-if="selectedDevice.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
              :label="$t('smartCity.Home.943046-148')" name="tab5">
              <div style="background-color: #1b2535; padding: 5vh 2vw; height: 60vh; width: 100%; margin-top: 2vh;">
                <div id="tab5Chart" class="chart" style="height: 100%; width: 100%;" />
              </div>
            </TabPane>
            <TabPane v-if="selectedDevice.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
              :label="$t('smartCity.Home.943046-149')" name="tab6">
              <Form :model="formThreshold" label-position="right" :label-width="150" inline>
                <template v-if="selectedDevice.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c'">
                  <Collapse accordion>
                    <Panel name="2">
                      {{ $t('smartCity.Home.943046-150') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-151')" class="tab6FI">
                            <Input v-model="formThreshold.Guoliutiaozhandingzhi"
                              :placeholder="$t('smartCity.Home.943046-151')">
                            <span slot="append">A</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-152')" class="tab6FI">
                            <Input v-model="formThreshold.Guoliugaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-152')">
                            <span slot="append">A</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-153')" class="tab6FI">
                            <Input v-model="formThreshold.Guoliutiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-153')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-154')" class="tab6FI">
                            <Input v-model="formThreshold.Guoliugaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-154')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-155')" class="tab6FI">
                            <Select v-model="formThreshold.Guoliugaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-158')" class="tab6FI">
                            <Select v-model="formThreshold.Guoliutiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-159')" class="tab6FI">
                            <Select v-model="formThreshold.Guoliutiaozhabisuo" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="3">
                      {{ $t('smartCity.Home.943046-160') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-161')" class="tab6FI">
                            <Input v-model="formThreshold.Guozaitiaozhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-161')">
                            <span slot="append">W</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-162')" class="tab6FI">
                            <Input v-model="formThreshold.Guozaigaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-162')">
                            <span slot="append">W</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-163')" class="tab6FI">
                            <Input v-model="formThreshold.Guozaitiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-163')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-164')" class="tab6FI">
                            <Input v-model="formThreshold.Guozaigaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-164')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-165')" class="tab6FI">
                            <Select v-model="formThreshold.Guozaigaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-166')" class="tab6FI">
                            <Select v-model="formThreshold.Guozaitiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-167')" class="tab6FI">
                            <Select v-model="formThreshold.Guozaitiaozhabisuo" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="4">
                      {{ $t('smartCity.Home.943046-168') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-169')" class="tab6FI">
                            <Input v-model="formThreshold.Loudiantiaozhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-169')">
                            <span slot="append">mA</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-170')" class="tab6FI">
                            <Input v-model="formThreshold.Loudiangaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-170')">
                            <span slot="append">mA</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-171')" class="tab6FI">
                            <Input v-model="formThreshold.Loudiantiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-171')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-172')" class="tab6FI">
                            <Input v-model="formThreshold.Loudiangaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-172')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-173')" class="tab6FI">
                            <Select v-model="formThreshold.Loudiangaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-174')" class="tab6FI">
                            <Select v-model="formThreshold.Loudiantiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="5">
                      {{ $t('smartCity.Home.943046-175') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-176')" class="tab6FI">
                            <Input v-model="formThreshold.Guoyatiaozhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-176')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-177')" class="tab6FI">
                            <Input v-model="formThreshold.Guoyagaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-177')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-178')" class="tab6FI">
                            <Input v-model="formThreshold.Guoyatiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-178')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-179')" class="tab6FI">
                            <Input v-model="formThreshold.Guoyagaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-179')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-180')" class="tab6FI">
                            <Select v-model="formThreshold.Guoyagaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-181')" class="tab6FI">
                            <Select v-model="formThreshold.Guoyatiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="6">
                      {{ $t('smartCity.Home.943046-182') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-183')" class="tab6FI">
                            <Input v-model="formThreshold.Qianyatiaozhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-183')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-184')" class="tab6FI">
                            <Input v-model="formThreshold.Qianyagaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-184')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-185')" class="tab6FI">
                            <Input v-model="formThreshold.Qianyatiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-185')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-186')" class="tab6FI">
                            <Input v-model="formThreshold.Qianyagaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-186')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-187')" class="tab6FI">
                            <Select v-model="formThreshold.Qianyagaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-188')" class="tab6FI">
                            <Select v-model="formThreshold.Qianyatiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="7">
                      {{ $t('smartCity.Home.943046-189') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-190')" class="tab6FI">
                            <Input v-model="formThreshold.Guoyahuifuhezhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-190')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-191')" class="tab6FI">
                            <Input v-model="formThreshold.Qianyahuifuhezhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-191')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-192')" class="tab6FI">
                            <Input v-model="formThreshold.Guoyahuifuhezhayanshi"
                              :placeholder="$t('smartCity.Home.943046-192')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-193')" class="tab6FI">
                            <Input v-model="formThreshold.Qianyahuifuhezhayanshi"
                              :placeholder="$t('smartCity.Home.943046-193')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-194')" class="tab6FI">
                            <Select v-model="formThreshold.Guoyahuifuhezhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-195')" class="tab6FI">
                            <Select v-model="formThreshold.Qianyahuifuhezhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="8">
                      {{ $t('smartCity.Home.943046-196') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-197')" class="tab6FI">
                            <Input v-model="formThreshold.Dianhutiaozhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-197')">
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-198')" class="tab6FI">
                            <Input v-model="formThreshold.Dianhugaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-198')">
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-199')" class="tab6FI">
                            <Input v-model="formThreshold.Dianhutiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-199')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-200')" class="tab6FI">
                            <Input v-model="formThreshold.Dianhugaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-200')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-201')" class="tab6FI">
                            <Select v-model="formThreshold.Dianhugaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-202')" class="tab6FI">
                            <Select v-model="formThreshold.Dianhutiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="9">
                      {{ $t('smartCity.Home.943046-203') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-204')" class="tab6FI">
                            <Input v-model="formThreshold.Guowentiaozhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-204')">
                            <span slot="append">℃</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-205')" class="tab6FI">
                            <Input v-model="formThreshold.Guoweigaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-205')">
                            <span slot="append">℃</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-206')" class="tab6FI">
                            <Input v-model="formThreshold.Guowentiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-206')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-207')" class="tab6FI">
                            <Input v-model="formThreshold.Guowengaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-207')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-208')" class="tab6FI">
                            <Select v-model="formThreshold.Guowengaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-209')" class="tab6FI">
                            <Select v-model="formThreshold.Guowentiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="10">
                      {{ $t('smartCity.Home.943046-210') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-211')" class="tab6FI">
                            <Input v-model="formThreshold.Quexiangtiaozhadingzhi"
                              :placeholder="$t('smartCity.Home.943046-211')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-212')" class="tab6FI">
                            <Input v-model="formThreshold.Quexianggaojingdingzhi"
                              :placeholder="$t('smartCity.Home.943046-212')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-213')" class="tab6FI">
                            <Input v-model="formThreshold.Quexiangtiaozhayanshi"
                              :placeholder="$t('smartCity.Home.943046-213')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-214')" class="tab6FI">
                            <Input v-model="formThreshold.Quexianggaojingyanshi"
                              :placeholder="$t('smartCity.Home.943046-214')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-215')" class="tab6FI">
                            <Select v-model="formThreshold.Quexianggaojingtoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-216')" class="tab6FI">
                            <Select v-model="formThreshold.Quexiangtiaozhatoutui" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="11">
                      {{ $t('smartCity.Home.943046-217') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-218')" class="tab6FI">
                            <Input v-model="formThreshold.Bisuoshijian" :placeholder="$t('smartCity.Home.943046-218')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-219')" class="tab6FI">
                            <Input v-model="formThreshold.Dongzuocishu" :placeholder="$t('smartCity.Home.943046-219')">
                            <span slot="append">{{ $t('smartCity.Home.943046-52') }}</span>
                            </Input>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                  </Collapse>
                </template>
                <template v-else>
                  <Collapse accordion>
                    <Panel name="2">
                      {{ $t('smartCity.Home.943046-150') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-151')" class="tab6FI">
                            <Input v-model="formThreshold.GuoLiuTZDZ" :placeholder="$t('smartCity.Home.943046-151')">
                            <span slot="append">A</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-152')" class="tab6FI">
                            <Input v-model="formThreshold.GuoLiuGJDZ" :placeholder="$t('smartCity.Home.943046-152')">
                            <span slot="append">A</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-153')" class="tab6FI">
                            <Input v-model="formThreshold.GuoLiuTZYC" :placeholder="$t('smartCity.Home.943046-153')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-154')" class="tab6FI">
                            <Input v-model="formThreshold.GuoLiuGJYC" :placeholder="$t('smartCity.Home.943046-154')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-155')" class="tab6FI">
                            <Select v-model="formThreshold.GuoLiuGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-158')" class="tab6FI">
                            <Select v-model="formThreshold.GuoLiuTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-159')" class="tab6FI">
                            <Select v-model="formThreshold.GuoLiuTZBS" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="3">
                      {{ $t('smartCity.Home.943046-175') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-176')" class="tab6FI">
                            <Input v-model="formThreshold.GuoYaTZDZ" :placeholder="$t('smartCity.Home.943046-176')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-177')" class="tab6FI">
                            <Input v-model="formThreshold.GuoYaGJDZ" :placeholder="$t('smartCity.Home.943046-177')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-178')" class="tab6FI">
                            <Input v-model="formThreshold.GuoYaTZYC" :placeholder="$t('smartCity.Home.943046-178')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-179')" class="tab6FI">
                            <Input v-model="formThreshold.GuoYaGJYC" :placeholder="$t('smartCity.Home.943046-179')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-220')" class="tab6FI">
                            <Input v-model="formThreshold.sanXiangGyHffz" :placeholder="$t('smartCity.Home.943046-220')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-180')" class="tab6FI">
                            <Select v-model="formThreshold.GuoYaGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-181')" class="tab6FI">
                            <Select v-model="formThreshold.GuoYaTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="4">
                      {{ $t('smartCity.Home.943046-182') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-183')" class="tab6FI">
                            <Input v-model="formThreshold.QianYaTZDZ" :placeholder="$t('smartCity.Home.943046-183')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-184')" class="tab6FI">
                            <Input v-model="formThreshold.QianYaGJDZ" :placeholder="$t('smartCity.Home.943046-184')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-185')" class="tab6FI">
                            <Input v-model="formThreshold.QianYaTZYC" :placeholder="$t('smartCity.Home.943046-185')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-186')" class="tab6FI">
                            <Input v-model="formThreshold.QianYaGJYC" :placeholder="$t('smartCity.Home.943046-186')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-221')" class="tab6FI">
                            <Input v-model="formThreshold.sanXiangQyHffz" :placeholder="$t('smartCity.Home.943046-221')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-222')" class="tab6FI">
                            <Input v-model="formThreshold.guoqianyaHfshijian"
                              :placeholder="$t('smartCity.Home.943046-222')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-187')" class="tab6FI">
                            <Select v-model="formThreshold.QianYaGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-188')" class="tab6FI">
                            <Select v-model="formThreshold.QianYaTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="5">
                      {{ $t('smartCity.Home.943046-168') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-169')" class="tab6FI">
                            <Input v-model="formThreshold.LouDianTZDZ" :placeholder="$t('smartCity.Home.943046-169')">
                            <span slot="append">mA</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-170')" class="tab6FI">
                            <Input v-model="formThreshold.LouDianGJDZ" :placeholder="$t('smartCity.Home.943046-170')">
                            <span slot="append">mA</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-171')" class="tab6FI">
                            <Input v-model="formThreshold.LouDianTZYC" :placeholder="$t('smartCity.Home.943046-171')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-172')" class="tab6FI">
                            <Input v-model="formThreshold.LouDianGJYC" :placeholder="$t('smartCity.Home.943046-172')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-173')" class="tab6FI">
                            <Select v-model="formThreshold.LouDianGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-174')" class="tab6FI">
                            <Select v-model="formThreshold.LouDianTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="6">
                      {{ $t('smartCity.Home.943046-203') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-204')" class="tab6FI">
                            <Input v-model="formThreshold.GuoWenTZDZ" :placeholder="$t('smartCity.Home.943046-204')">
                            <span slot="append">℃</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-205')" class="tab6FI">
                            <Input v-model="formThreshold.GuoWenGJDZ" :placeholder="$t('smartCity.Home.943046-205')">
                            <span slot="append">℃</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-206')" class="tab6FI">
                            <Input v-model="formThreshold.GuoWenTZYC" :placeholder="$t('smartCity.Home.943046-206')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-207')" class="tab6FI">
                            <Input v-model="formThreshold.GuoWenGJYC" :placeholder="$t('smartCity.Home.943046-207')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-208')" class="tab6FI">
                            <Select v-model="formThreshold.GuoWenGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-209')" class="tab6FI">
                            <Select v-model="formThreshold.GuoWenTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="7">
                      {{ $t('smartCity.Home.943046-196') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-197')" class="tab6FI">
                            <Input v-model="formThreshold.DianHuTZDZ" :placeholder="$t('smartCity.Home.943046-197')">
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-198')" class="tab6FI">
                            <Input v-model="formThreshold.DianHuGJDZ" :placeholder="$t('smartCity.Home.943046-198')">
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-199')" class="tab6FI">
                            <Input v-model="formThreshold.DianHuTZYC" :placeholder="$t('smartCity.Home.943046-199')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-200')" class="tab6FI">
                            <Input v-model="formThreshold.DianHuGJYC" :placeholder="$t('smartCity.Home.943046-200')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-201')" class="tab6FI">
                            <Select v-model="formThreshold.DianHuGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-202')" class="tab6FI">
                            <Select v-model="formThreshold.DianHuTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="8">
                      {{ $t('smartCity.Home.943046-160') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-161')" class="tab6FI">
                            <Input v-model="formThreshold.GuoZaiTZDZ" :placeholder="$t('smartCity.Home.943046-161')">
                            <span slot="append">W</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-162')" class="tab6FI">
                            <Input v-model="formThreshold.GuoZaiGJDZ" :placeholder="$t('smartCity.Home.943046-162')">
                            <span slot="append">W</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-163')" class="tab6FI">
                            <Input v-model="formThreshold.GuoZaiTZYC" :placeholder="$t('smartCity.Home.943046-163')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-164')" class="tab6FI">
                            <Input v-model="formThreshold.GuoZaiGJYC" :placeholder="$t('smartCity.Home.943046-164')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-165')" class="tab6FI">
                            <Select v-model="formThreshold.GuoZaiGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-166')" class="tab6FI">
                            <Select v-model="formThreshold.GuoZaiTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-167')" class="tab6FI">
                            <Select v-model="formThreshold.GuoZaiTZBS" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="9">
                      {{ $t('smartCity.Home.943046-210') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-211')" class="tab6FI">
                            <Input v-model="formThreshold.QueXiangTZDZ" :placeholder="$t('smartCity.Home.943046-211')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-212')" class="tab6FI">
                            <Input v-model="formThreshold.QueXiangGJDZ" :placeholder="$t('smartCity.Home.943046-212')">
                            <span slot="append">V</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-213')" class="tab6FI">
                            <Input v-model="formThreshold.QueXiangTZYC" :placeholder="$t('smartCity.Home.943046-213')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-214')" class="tab6FI">
                            <Input v-model="formThreshold.QueXiangGJYC" :placeholder="$t('smartCity.Home.943046-214')">
                            <span slot="append">S</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-215')" class="tab6FI">
                            <Select v-model="formThreshold.QueXiangGJTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-216')" class="tab6FI">
                            <Select v-model="formThreshold.QueXiangTZTT" class="tab6Select">
                              <Option value="0">{{ $t('smartCity.Home.943046-156') }}</Option>
                              <Option value="1">{{ $t('smartCity.Home.943046-157') }}</Option>
                            </Select>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel name="10">
                      {{ $t('smartCity.Home.943046-223') }}
                      <div slot="content" style="width: 97%;">
                        <Row>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-224')" class="tab6FI">
                            <Input v-model="formThreshold.DianLiangCCJG" :placeholder="$t('smartCity.Home.943046-224')">
                            <span slot="append">min</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-225')" class="tab6FI">
                            <Input v-model="formThreshold.LiJiCCDLFZ" :placeholder="$t('smartCity.Home.943046-225')">
                            <span slot="append">kwh</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-226')" class="tab6FI">
                            <Input v-model="formThreshold.JianGeDianLiangCCFZ"
                              :placeholder="$t('smartCity.Home.943046-226')">
                            <span slot="append">kwh</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-227')" class="tab6FI">
                            <Input v-model="formThreshold.DianLiang" :placeholder="$t('smartCity.Home.943046-227')">
                            <span slot="append">kwh</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-228')" class="tab6FI">
                            <Input v-model="formThreshold.SJCQZDCS" :placeholder="$t('smartCity.Home.943046-228')">
                            <span slot="append">{{ $t('smartCity.Home.943046-52') }}</span>
                            </Input>
                          </FormItem>
                          </Col>
                          <Col :span="6">
                          <FormItem :label="$t('smartCity.Home.943046-229')" class="tab6FI">
                            <Input v-model="formThreshold.XTYCCQCS" :placeholder="$t('smartCity.Home.943046-229')">
                            <span slot="append">{{ $t('smartCity.Home.943046-52') }}</span>
                            </Input>
                          </FormItem>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                  </Collapse>
                </template>
              </Form>
              <Col span="24" style="display: flex; margin-top: 2vh;">
              <Button type="primary" style="font-size: 0.6vw; margin-right: 0.5vw;" @click="setThreshold">{{
                $t('smartCity.Home.943046-230') }}</Button>
              <template v-if="selectedDevice.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c'">
                <Button type="success" style="font-size: 0.6vw;" @click="DeviceRWByType()">{{
                  $t('smartCity.Home.943046-231') }}</Button>
              </template>
              <template v-else>
                <Button type="success" style="font-size: 0.6vw; margin-right: 0.5vw;" @click="DeviceRWByType(1)">{{
                  $t('smartCity.Home.943046-231') }}1</Button>
                <Button type="success" style="font-size: 0.6vw;" @click="DeviceRWByType(2)">{{
                  $t('smartCity.Home.943046-231') }}2</Button>
              </template>
              </Col>
            </TabPane>
          </Tabs>
        </div>

      </div>
      <div class="more-popup" :style="{ top: moreY + 'px', left: moreX + 'px' }" v-if="moreStatu" @click.stop="">
        <Row>
          <Col span="8" v-if="DeviceBtns.indexOf('edit') >= 0">
          <div class="btn" @click="openEdit">{{ $t('smartCity.Home.943046-71') }}</div>
          </Col>
          <Col span="8" v-if="DeviceBtns.indexOf('del') >= 0">
          <Poptip confirm :title="$t('smartCity.Home.943046-234')" placement="top-end" offset='-20'
            @on-ok="moreStatu = false, DelDevice()" @on-cancel="cancel">
            <div class="btn">{{ $t('smartCity.Home.943046-87') }}</div>
          </Poptip>
          </Col>
          <Col span="8">
          <div class="btn" @click="moreStatu = false, passWordState = true">{{ $t('smartCity.Home.943046-235') }}</div>
          </Col>
          <Col span="8" v-if="DeviceBtns.indexOf('slience') >= 0">
          <Poptip confirm :title="$t('smartCity.Home.943046-236')" placement="top-start" offset='0'
            @on-ok="Device_YanGan_Silence" @on-cancel="cancel">
            <div class="btn">{{ $t('smartCity.Home.943046-237') }}</div>
          </Poptip>
          </Col>
          <Col span="8" v-if="DeviceBtns.indexOf('read') >= 0">
          <div class="btn" :class="{ 'allowed': !callState }"
            @click="InitDeviceRead(selectedRow.DeviceCode, selectedRow.Id)">{{ $t('smartCity.Home.943046-238') }}
          </div>
          </Col>
          <Col span="8" v-if="DeviceBtns.indexOf('open') >= 0 && selectedRow.SwitchStatus != 2">
          <Poptip confirm :title="$t('smartCity.Home.943046-239')" :disabled="!saveState" placement="top-start" offset='0'
            @on-ok="VerifyPassword(1)" @on-cancel="cancel">
            <div class="btn">{{ $t('smartCity.Home.943046-94') }}</div>
          </Poptip>
          </Col>
          <Col span="8" v-if="DeviceBtns.indexOf('close') >= 0 && selectedRow.SwitchStatus != 1">
          <Poptip confirm :title="$t('smartCity.Home.943046-240')" :disabled="!saveState" placement="top-start" offset='0'
            @on-ok="VerifyPassword(1)" @on-cancel="cancel">
            <div class="btn">{{ $t('smartCity.Home.943046-93') }}</div>
          </Poptip>
          </Col>
          <Col span="8" v-if="DeviceBtns.indexOf('closeFa') >= 0">
          <Poptip confirm :title="$t('smartCity.Home.943046-241')" :disabled="!saveState" placement="top-start" offset='0'
            @on-ok="VerifyPassword(2)" @on-cancel="cancel">
            <div class="btn">{{ $t('smartCity.Home.943046-242') }}</div>
          </Poptip>
          </Col>
          <Col span="8"
            v-if="selectedRow.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857' && selectedRow.DeviceItemId != '881a191a-e3da-4bea-867a-69988dbf1fef' && selectedRow.DeviceItemId != '147df81e-3f30-49b7-8894-f0b5794d917f' && selectedRow.DeviceItemId != 'c5307581-ff30-4115-87c0-52ac83bbd1cc'">
          <div class="btn" @click="GetQtcgqTtItemList(selectedRow.DeviceCode)">{{ $t('smartCity.Home.943046-243') }}
          </div>
          </Col>
          <Col span="8"
            v-if="selectedRow.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c' && selectedRow.DeviceXY == '3.0'">
          <div class="btn" @click="moreStatu = false, clockState = true">{{ $t('smartCity.Home.943046-244') }}</div>
          </Col>
        </Row>
        <Spin fix v-if="moreSpin">{{ $t('smartCity.Home.943046-245') }}</Spin>
      </div>
    </div>



    <div class="outline-view" v-if="popupState" @click="shutDown('self')">
      <div class="outline-top" @click.stop="shutDown()">
        <dv-border-box-11 :color="themeCode === 'default' && homeType !== 'newHome' ? ['#46857b', '#497470'] : []"
          :backgroundColor="themeCode === 'default' && homeType !== 'newHome' ? 'rgba(83,134,123,1)' : 'rgba(7,22,55, 1)'"
          :title="popupTitle">
          <div class="outline-remove" @click="shutDown('self')">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <template v-if="popupType == 1">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-23') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-90') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-246') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-247') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-29') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-248') }}</div>
                <div class="map-bottom-content-tab-item tabHandle">{{ $t('smartCity.Home.943046-31') }}</div>
              </div>
              <div class="map-bottom-list">
                <div id="content" class="map-bottom-lists" v-if="DeviceAbnormalList.length > 0">
                  <div class="map-bottom-list-item" v-for="(item) in DeviceAbnormalList" :key="item.Id"
                    @dblclick="deviceDetails(item)">
                    <div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.OwnerName }}</div>
                    <div class="map-bottom-list-item-addr" :title="item.AddressDetail">{{ item.AddressDetail }}</div>
                    <div class="map-bottom-list-item-date">{{ item.AbnormalTime }}</div>
                    <div class="map-bottom-list-item-type">{{ item.AbnormalName }}</div>
                    <div class="map-bottom-list-item-handle">
                      <div class="ivu-dropdown">
                        <div class="" style="margin-top: 0.1vw;">
                          <div class="map-bottom-list-item-handle-btn">
                            <Dropdown trigger="click" style="width: 5vw;">
                              <a href="javascript:void(0)">
                                {{ $t('smartCity.Home.943046-249') }}
                                <Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
                              </a>
                              <DropdownMenu slot="list" style="width: 5vw;">
                                <DropdownItem @click.native="SolveAbData(item.Id, 2, 109)">{{
                                  $t('smartCity.Home.943046-250') }}</DropdownItem>
                                <DropdownItem @click.native="SolveAbData(item.Id, 3, 109)">{{
                                  $t('smartCity.Home.943046-121') }}</DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-if="DeviceAbnormalList.length == 0">{{
                  $t('smartCity.Home.943046-251') }}</div>
              </div>
              <div class="user-top-list-page">
                <Page :total="DeviceAbnormalTotalCount" @on-change="DeviceAbnormalChange"
                  @on-page-size-change="DeviceAbnormalSizeChange" size="small" show-elevator show-sizer show-total
                  placement="top" />
              </div>
            </template>
            <template v-else-if="popupType == 2">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-252') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-23') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-90') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-253') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-254') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-255') }}</div>
                <div class="map-bottom-content-tab-item tabHandle">{{ $t('smartCity.Home.943046-21') }}</div>
              </div>
              <div class="map-bottom-list">
                <div id="content" class="map-bottom-lists" v-if="DeviceLists.length > 0">
                  <div class="map-bottom-list-item" v-for="(item, index) in DeviceLists" :key="item.Id"
                    @dblclick="deviceDetails(item)" @click="goToDevice(item)">
                    <div class="map-bottom-list-item-device">{{ (pageIndex - 1) * pageSize + index + 1 }}</div>
                    <div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.UserName }}</div>
                    <div class="map-bottom-list-item-date" :title="item.Address">{{ item.Address }}</div>
                    <div class="map-bottom-list-item-date">{{ item.UpdateTime }}</div>
                    <div class="map-bottom-list-item-handle">{{ DeviceIdToStr(item.DeviceId, item.DeviceItemId) !=
                      $t('smartCity.Home.943046-53')
                      ?
                      '--' : item.SwitchStatus == 1 ? $t('smartCity.Home.943046-93') : item.SwitchStatus == 2 ?
                        $t('smartCity.Home.943046-94') : '--' }}</div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-if="DeviceLists.length == 0">{{ $t('smartCity.Home.943046-104')
                }}</div>
              </div>
              <div class="user-top-list-page">
                <Page :total="DeviceTotal" @on-change="DeviceChange" @on-page-size-change="DeviceSizeChange" size="small"
                  show-elevator show-sizer show-total placement="top" />
              </div>
            </template>
            <template v-else-if="popupType == 2.5">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-252') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-23') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-90') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-254') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-255') }}</div>
                <div class="map-bottom-content-tab-item tabHandle" v-if="deviceType == 'wd'">{{
                  $t('smartCity.Home.943046-21') }}</div>
                <div class="map-bottom-content-tab-item tabHandle" v-else>{{ $t('smartCity.Home.943046-256') }}</div>
              </div>
              <div class="map-bottom-list">
                <div id="content" class="map-bottom-lists" v-if="DeviceLists.length > 0">
                  <div class="map-bottom-list-item" v-for="(item, index) in DeviceLists" :key="item.Id"
                    @dblclick="deviceDetails(item)" @click="goToDevice(item)">
                    <div class="map-bottom-list-item-device">{{ (pageIndex - 1) * pageSize + index + 1 }}</div>
                    <div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
                    <div class="map-bottom-list-item-date" :title="item.Address">{{ item.Address }}</div>
                    <div class="map-bottom-list-item-date">{{ item.UpdateTime }}</div>
                    <div class="map-bottom-list-item-handle" v-if="deviceType == 'wd'">{{ item.SwitchStatus == 1 ?
                      $t('smartCity.Home.943046-93') :
                      item.SwitchStatus == 2 ? $t('smartCity.Home.943046-94') : '--' }}</div>
                    <div class="map-bottom-list-item-handle" v-else>{{ item.IsOnline ? $t('smartCity.Home.943046-91') :
                      $t('smartCity.Home.943046-92') }}</div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-if="DeviceLists.length == 0">{{ $t('smartCity.Home.943046-104')
                }}</div>
              </div>
              <div class="user-top-list-page">
                <Page :total="DeviceTotal" @on-change="DeviceChange" @on-page-size-change="DeviceSizeChange" size="small"
                  show-elevator show-sizer show-total placement="top" />
              </div>
            </template>
            <template v-else-if="popupType == 3">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-252') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-23') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-90') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-246') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-247') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-29') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-248') }}</div>
                <div class="map-bottom-content-tab-item tabHandle">{{ $t('smartCity.Home.943046-31') }}</div>
              </div>
              <div class="map-bottom-list">
                <div id="content" class="map-bottom-lists" v-if="DeviceAbnormalList.length > 0">
                  <div class="map-bottom-list-item" v-for="(item, index) in DeviceAbnormalList" :key="item.Id"
                    @dblclick="deviceDetails(item)" @click="goToDevice(item)">
                    <div class="map-bottom-list-item-device">{{ (pageIndex - 1) * pageSize + index + 1 }}</div>
                    <div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.OwnerName }}</div>
                    <div class="map-bottom-list-item-addr" :title="item.AddressDetail">{{ item.AddressDetail }}</div>
                    <div class="map-bottom-list-item-date">{{ item.AbnormalTime }}</div>
                    <div class="map-bottom-list-item-type">{{ item.AbnormalName }}</div>
                    <div class="map-bottom-list-item-handle" @click.stop="">
                      <template v-if="DeviceCategory == 1">
                        <div class="ivu-dropdown">
                          <div class="" style="margin-top: 0.1vw;">
                            <div class="map-bottom-list-item-handle-btn">
                              <Dropdown trigger="click" style="width: 5vw;">
                                <a href="javascript:void(0)">
                                  {{ $t('smartCity.Home.943046-249') }}
                                  <Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
                                </a>
                                <DropdownMenu slot="list" style="width: 5vw;">
                                  <DropdownItem @click.native="SolveAbData(item.Id, 2, 109)">{{
                                    $t('smartCity.Home.943046-250') }}</DropdownItem>
                                  <DropdownItem @click.native="SolveAbData(item.Id, 3, 109)">{{
                                    $t('smartCity.Home.943046-121') }}</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="DeviceCategory == 2">
                        {{ $t('smartCity.Home.943046-7') }}
                      </template>
                      <template v-else>
                        {{ $t('smartCity.Home.943046-121') }}
                      </template>
                    </div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-if="DeviceAbnormalList.length == 0">{{
                  $t('smartCity.Home.943046-251') }}</div>
              </div>
              <div class="user-top-list-page">
                <Page :total="DeviceAbnormalTotalCount" @on-change="DeviceAbnormalChange1"
                  @on-page-size-change="DeviceAbnormalSizeChange1" size="small" show-elevator show-sizer show-total
                  placement="top" />
              </div>
            </template>
            <template v-else-if="popupType == 4">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-252') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-23') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-90') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-253') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-254') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-256') }}</div>
                <div class="map-bottom-content-tab-item tabHandle">{{ $t('smartCity.Home.943046-21') }}</div>
              </div>
              <div class="map-bottom-list">
                <div id="content" class="map-bottom-lists" v-if="DeviceCountList.length > 0">
                  <div class="map-bottom-list-item" v-for="(item, index) in DeviceCountList" :key="item.Id"
                    @dblclick="deviceDetails(item)" @click="goToDevice(item)">
                    <div class="map-bottom-list-item-device">{{ (pageIndex - 1) * pageSize + index + 1 }}</div>
                    <div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
                    <div class="map-bottom-list-item-addr">{{ item.UserName }}</div>
                    <div class="map-bottom-list-item-date" :title="item.Address">{{ item.Address }}</div>
                    <div class="map-bottom-list-item-date">{{ item.IsOnline ? $t('smartCity.Home.943046-91') :
                      $t('smartCity.Home.943046-92') }}</div>
                    <div class="map-bottom-list-item-handle">{{ DeviceIdToStr(item.DeviceId, item.DeviceItemId) !=
                      $t('smartCity.Home.943046-53')
                      ?
                      '--' : item.SwitchStatus == 1 ? $t('smartCity.Home.943046-93') : item.SwitchStatus == 2 ?
                        $t('smartCity.Home.943046-94') : '--' }}</div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-if="DeviceCountList.length == 0">{{
                  $t('smartCity.Home.943046-251') }}</div>
              </div>
              <div class="user-top-list-page">
                <Page :total="AlarmTotalCount" @on-change="AlarmPageChange" @on-page-size-change="AlarmPageSizeChange"
                  size="small" show-elevator show-sizer show-total placement="top" />
              </div>
            </template>
            <template v-else-if="popupType == 5">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-257') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-258') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-259') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-260') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-261') }}</div>
              </div>
              <div class="map-bottom-list" style="height: calc(100% - 1.75vw);">
                <div id="content" class="map-bottom-lists" v-if="GetCurrRoomAbLists.length > 0">
                  <div class="map-bottom-list-item" v-for="(item) in GetCurrRoomAbLists" :key="item.Id">
                    <div class="map-bottom-list-item-device">{{ item.VName }}</div>
                    <!-- <div class="map-bottom-list-item-addr">{{`${item.Zhuang}{{ $t('smartCity.Home.943046-274') }}-${item.Unit}{{ $t('smartCity.Home.943046-275') }}-${item.Floor}楼-${item.RoomNo}房间`}}</div> -->
                    <div class="map-bottom-list-item-addr">{{ item.AddressDetail }}</div>
                    <div class="map-bottom-list-item-date">{{ item.OwnerName }}</div>
                    <div class="map-bottom-list-item-date">{{ item.OwnerPhone }}</div>
                    <div class="map-bottom-list-item-date">{{ item.CreateDate }}</div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-if="GetCurrRoomAbLists.length == 0">{{
                  $t('smartCity.Home.943046-262') }}</div>
              </div>
            </template>
            <template v-else-if="popupType == 6">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-252') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-253') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-247') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-260') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-263') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-264') }}</div>
              </div>
              <div class="map-bottom-list">
                <div id="content" class="map-bottom-lists" v-if="mapGetRoshRoomAllLists.length > 0">
                  <div class="map-bottom-list-item" v-for="(item, index) in mapGetRoshRoomAllLists" :key="item.Id"
                    @click="goToUser(item)">
                    <div class="map-bottom-list-item-device">{{ (pageIndex - 1) * pageSize + index + 1 }}</div>
                    <div class="map-bottom-list-item-date">{{ item.OwnerName }}</div>
                    <!-- <div class="map-bottom-list-item-addr">{{`${item.Zhuang || ''}-${item.Unit || ''}-${item.Floor || ''}-${item.RoomNo || ''}`}}</div> -->
                    <div class="map-bottom-list-item-addr">{{ item.AddressDetail }}</div>
                    <div class="map-bottom-list-item-date">{{ item.OwnerPhone }}</div>
                    <div class="map-bottom-list-item-device">{{ item.Vname }}</div>
                    <div class="map-bottom-list-item-date">{{ item.CreateDate }}</div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-if="GetRoshRoomAllLists.length == 0">{{
                  $t('smartCity.Home.943046-265') }}</div>
              </div>
              <div class="user-top-list-page">
                <Page :total="mapUserTotalCount" @on-change="mapUserPageChange"
                  @on-page-size-change="mapUserPageSizeChange" size="small" show-elevator show-total show-sizer
                  placement="top" />
              </div>
            </template>
            <template v-else-if="popupType == 7">
              <Table :columns="columns7" :data="UserGasCheckLogs" class="table7" @on-selection-change="logSelect" border>
                <template slot-scope="{ row }" slot="Rq1_1">
                  {{ row.Rq1_1.slice(0, 10) }}
                </template>
                <template slot-scope="{ row }" slot="ZiJian_1">
                  <Icon type="md-checkmark" v-show="row.ZiJian_1 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="XiaoYin_1">
                  <Icon type="md-checkmark" v-show="row.XiaoYin_1 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="DianYuan_1">
                  <Icon type="md-checkmark" v-show="row.DianYuan_1 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="XunJian_1">
                  <Icon type="md-checkmark" v-show="row.XunJian_1 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="Bjsbyxqk_1">
                  <Icon type="md-checkmark" v-show="row.Bjsbyxqk_1 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="Bjsbyxqk_2">
                  <Icon type="md-checkmark" v-show="row.Bjsbyxqk_1 == '2'" />
                </template>
                <template slot-scope="{ row }" slot="Bjsbyxqk_3">
                  <Icon type="md-checkmark" v-show="row.Bjsbyxqk_1 == '0'" />
                </template>
                <template slot-scope="{ row }" slot="Ldsbyxqk_1">
                  <Icon type="md-checkmark" v-show="row.Ldsbyxqk_1 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="Ldsbyxqk_2">
                  <Icon type="md-checkmark" v-show="row.Ldsbyxqk_1 == '0'" />
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="success" @click="tableAction('edit', row)">{{ $t('smartCity.Home.943046-71') }}</Button>
                </template>
              </Table>
              <div class="new-user-top-list-page">
                <Page :total="logsTotal" @on-change="logsPageChange" :current="logPageIndex" :page-size="6" size="small"
                  show-elevator show-total placement="top" />
                <div class="btn-group">
                  <Button type="primary" @click="tableAction('add')">{{ $t('smartCity.Home.943046-79') }}</Button>
                  <Button type="error" style="margin-left: 0.5vw;" @click="tableAction('del')">{{
                    $t('smartCity.Home.943046-87') }}</Button>
                </div>
              </div>
            </template>
            <template v-else-if="popupType == 8">
              <Table :columns="columns8" :data="UserGasCheckLogs" class="table7" @on-selection-change="logSelect" border>
                <template slot-scope="{ row }" slot="Rq2_2">
                  {{ row.Rq2_2.slice(0, 10) }}
                </template>
                <template slot-scope="{ row }" slot="Xcdzzjl_1">
                  <Icon type="md-checkmark" v-show="row.Xcdzzjl_2 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="Xcdzzjl_2">
                  <Icon type="md-checkmark" v-show="row.Xcdzzjl_2 == '2'" />
                </template>
                <template slot-scope="{ row }" slot="Xcdzzjl_3">
                  <Icon type="md-checkmark" v-show="row.Xcdzzjl_2 == '0'" />
                </template>
                <template slot-scope="{ row }" slot="Clyj_1">
                  <Icon type="md-checkmark" v-show="row.Clyj_2 == '1'" />
                </template>
                <template slot-scope="{ row }" slot="Clyj_2">
                  <Icon type="md-checkmark" v-show="row.Clyj_2 == '2'" />
                </template>
                <template slot-scope="{ row }" slot="Clyj_3">
                  <Icon type="md-checkmark" v-show="row.Clyj_2 == '0'" />
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="success" @click="tableAction('edit', row)">{{ $t('smartCity.Home.943046-71') }}</Button>
                </template>
              </Table>
              <div class="new-user-top-list-page">
                <Page :total="logsTotal" @on-change="logsPageChange" :current="logPageIndex" :page-size="6" size="small"
                  show-elevator show-total placement="top" />
                <div class="btn-group">
                  <Button type="primary" @click="tableAction('add')">{{ $t('smartCity.Home.943046-79') }}</Button>
                  <Button type="error" style="margin-left: 0.5vw;" @click="tableAction('del')">{{
                    $t('smartCity.Home.943046-87') }}</Button>
                </div>
              </div>
            </template>
            <template v-else-if="popupType == 9">
              <Table :columns="columns9" :data="UserGasCheckLogs" class="table7" @on-selection-change="logSelect" border>
                <template slot-scope="{ row }" slot="Rq3_3">
                  {{ row.Rq3_3.slice(0, 10) }}
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="success" @click="tableAction('edit', row)">{{ $t('smartCity.Home.943046-71') }}</Button>
                </template>
              </Table>
              <div class="new-user-top-list-page">
                <Page :total="logsTotal" @on-change="logsPageChange" :current="logPageIndex" :page-size="6" size="small"
                  show-elevator show-total placement="top" />
                <div class="btn-group">
                  <Button type="primary" @click="tableAction('add')">{{ $t('smartCity.Home.943046-79') }}</Button>
                  <Button type="error" style="margin-left: 0.5vw;" @click="tableAction('del')">{{
                    $t('smartCity.Home.943046-87') }}</Button>
                </div>
              </div>
            </template>
            <template v-else-if="popupType == 10">
              <div class="picLists">
                <div v-for="(item, index) in picList" @click="selectPic(item, index)" class="picContainer">
                  <img class="pic" :src="item.FileUrlYS" />
                </div>
              </div>
              <div class="new-user-top-list-page">
                <Page :total="picsTotal" @on-change="picsPageChange" :current="picPageIndex" :page-size="picPageSize"
                  size="small" @on-page-size-change="picsPageSizeChange" show-elevator show-total show-sizer
                  placement="top" />
              </div>
            </template>
            <template v-else-if="popupType == 11">
              <div class="map-bottom-content-tab">
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-266') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-267') }}</div>
                <div class="map-bottom-content-tab-item">{{ $t('smartCity.Home.943046-268') }}</div>
                <div class="map-bottom-content-tab-item">IMEI</div>
                <div class="map-bottom-content-tab-item tabHandle">{{ $t('smartCity.Home.943046-269') }}</div>
              </div>
              <div class="map-bottom-list">
                <div id="content" class="map-bottom-lists" v-if="qtcgqTtItemLists.length > 0">
                  <div class="map-bottom-list-item" v-for="(item) in qtcgqTtItemLists" :key="item.Id">
                    <div class="map-bottom-list-item-device">{{ item.TanTouName }}</div>
                    <div class="map-bottom-list-item-device">{{ item.DangQianNdz }}</div>
                    <div class="map-bottom-list-item-device">{{ item.BaojingZt }}</div>
                    <div class="map-bottom-list-item-device">{{ item.IMEI }}</div>
                    <div class="map-bottom-list-item-handle">{{ item.CreateTime }}</div>
                  </div>
                </div>
                <div class="map-right-group-list-none" v-else>{{ $t('smartCity.Home.943046-270') }}</div>
              </div>
            </template>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="doubleState" @click="doubleShutDown('self')">
      <div class="outline-top1" @click.stop="doubleShutDown()">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="$t('smartCity.Home.943046-271')">
          <div class="outline-remove" @click="doubleShutDown('self')">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right">
                  <Row>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-90')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="DeviceCode" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-272')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="cmmModel.Cname" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-130')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="cmmModel.ProvinceName"
                        :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-131')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="cmmModel.CityName" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-132')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="cmmModel.AreaName" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-263')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="villModel.Vname" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-273')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="villModel.Address" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-137')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="villModel.Jd" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-138')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="villModel.Wd" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-274')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="roomModel.Zhuang" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-275')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="roomModel.Unit" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-276')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="roomModel.Floor" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-277')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="roomModel.RoomNo" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-253')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="roomModel.OwnerName" :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-278')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="roomModel.OwnerPhone"
                        :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-279')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="elecFixModel.ElecName"
                        :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-280')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="elecFixModel.ElecMobile"
                        :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-281')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="elecFixModel.ElecIDCode"
                        :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-282')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="elecFixModel.CanFixTime"
                        :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem :label="$t('smartCity.Home.943046-283')" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <Input disabled v-model="elecFixModel.Content"
                        :placeholder="$t('smartCity.Home.943046-82')"></Input>
                    </FormItem>
                    </Col>
                  </Row>
                  <div v-for="(item, index) in elecFixModel.ListIDCodePic" :key="index">
                    <Col span="6">
                    <!-- <FormItem :label="'{{ $t('smartCity.Home.943046-284') }}(' + (index + 1) + ')'" class="f12"
                      style="margin-right: 10%;margin-left: 8%;">
                      <img :src="item" alt="" style="width: 100%;">
                    </FormItem> -->
                    </Col>
                  </div>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="doubleState = false">{{
                $t('smartCity.Home.943046-285') }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="editState" @click="editState = false">
      <div class="outline-top3" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="$t('smartCity.Home.943046-286')">
          <div class="outline-remove" @click="editState = false">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right" :label-width="140">
                  <Row span="24">
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-274')" prop="Zhuang" class="f12">
                      <Input v-model="userModel.Zhuang" :placeholder="$t('smartCity.Home.943046-287')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-275')" prop="Unit" class="f12">
                      <Input v-model="userModel.Unit" :placeholder="$t('smartCity.Home.943046-288')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-276')" prop="Floor" class="f12">
                      <Input v-model="userModel.Floor" :placeholder="$t('smartCity.Home.943046-289')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-277')" prop="RoomNo" class="f12">
                      <Input v-model="userModel.RoomNo" :placeholder="$t('smartCity.Home.943046-290')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-253')" prop="OwnerName" class="f12">
                      <Input v-model="userModel.OwnerName" :placeholder="$t('smartCity.Home.943046-291')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-278')" prop="OwnerPhone" class="f12">
                      <Input v-model="userModel.OwnerPhone" :placeholder="$t('smartCity.Home.943046-292')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-293')" prop="RoomType" class="f12">
                      <Select v-model="userModel.RoomType" :placeholder="$t('smartCity.Home.943046-294')" clearable>
                        <Option :value="1">{{ $t('smartCity.Home.943046-66') }}</Option>
                        <Option :value="2">{{ $t('smartCity.Home.943046-67') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-295')" prop="OrganizationName" class="f12">
                      <Input v-model="userModel.OrganizationName" :placeholder="$t('smartCity.Home.943046-296')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-297')" prop="AreaManagerPhone" class="f12">
                      <Input v-model="userModel.AreaManagerPhone" :placeholder="$t('smartCity.Home.943046-298')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-299')" prop="YearExamState" class="f12">
                      <Select v-model="userModel.YearExamState" :placeholder="$t('smartCity.Home.943046-300')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-68') }}</Option>
                        <Option value="2">{{ $t('smartCity.Home.943046-69') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-301')" class="f12">
                      <div class="">
                        <div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                          <input ref="input" type="text" id="suggestId" name="address_detail"
                            :placeholder="$t('smartCity.Home.943046-273')" v-show="!address_detail"
                            class="input_style ivu-input ivu-input-default" />
                          <input type="text" v-show="address_detail" v-model="address_detail"
                            @click="addressDetailClick()" class="input_style ivu-input ivu-input-default" />
                        </div>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-137')" prop="Jd" class="f12">
                      <Input v-model="userModel.Jd" :placeholder="$t('smartCity.Home.943046-137')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-138')" prop="Wd" class="f12">
                      <Input v-model="userModel.Wd" :placeholder="$t('smartCity.Home.943046-138')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-247')" prop="AddressDetail" class="f12">
                      <Input v-model="userModel.AddressDetail" :placeholder="$t('smartCity.Home.943046-302')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-303')" prop="UserLimitYear" class="f12">
                      <Input v-model="userModel.UserLimitYear" :placeholder="$t('smartCity.Home.943046-304')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-305')" prop="AreaManager" class="f12">
                      <Input v-model="userModel.AreaManager" :placeholder="$t('smartCity.Home.943046-306')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-307')" prop="Jdzsyxq" class="f12">
                      <DatePicker format="yyyy/MM/dd" type="daterange" placement="bottom-end"
                        :placeholder="$t('smartCity.Home.943046-308')" style="width: 200px" @on-change="JdzsyxqChange"
                        v-model="Jdzsyxq"></DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-309')" prop="Sfyzj" class="f12">
                      <Select v-model="userModel.Sfyzj" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-311') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-312') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-313')" prop="Sfypt" class="f12">
                      <Select v-model="userModel.Sfypt" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-311') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-312') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-314')" prop="Sfydxts" class="f12">
                      <Select v-model="userModel.Sfydxts" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-311') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-312') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-315')" prop="Sfysgbj" class="f12">
                      <Select v-model="userModel.Sfysgbj" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-311') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-312') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-316')" prop="Sfyqd" class="f12">
                      <Select v-model="userModel.Sfyqd" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-311') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-312') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-317')" prop="Sfyfj" class="f12">
                      <Select v-model="userModel.Sfyfj" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-311') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-312') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-318')" prop="Ttsl" class="f12">
                      <Input v-model="userModel.Ttsl" :placeholder="$t('smartCity.Home.943046-319')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-320')" prop="Frxm" class="f12">
                      <Input v-model="userModel.Frxm" :placeholder="$t('smartCity.Home.943046-321')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-260')" prop="Lxdh" class="f12">
                      <Input v-model="userModel.Lxdh" :placeholder="$t('smartCity.Home.943046-322')"></Input>
                    </FormItem>
                    </Col>
                  </Row>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="editState = false, EditRoshRoom()">{{
                $t('smartCity.Home.943046-285') }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="addState" @click="addState = false, reset()">
      <div class="outline-top2" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="actionType">
          <div class="outline-remove" @click="addState = false">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode" v-if="logType == 1">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right" :rules="ruleValidate.rule1" ref="addFormItem" :model="addFormItem">
                  <FormItem :label="$t('smartCity.Home.943046-323')" class="f12" prop="Rq1_1"
                    style="margin-right: 10%;margin-left: 8%;">
                    <DatePicker type="date" :placeholder="$t('smartCity.Home.943046-324')" v-model="addFormItem.Rq1_1">
                    </DatePicker>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-325')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem.ZiJian_1">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-61') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-326') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-237')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem.XiaoYin_1">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-61') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-326') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-327')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem.DianYuan_1">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-61') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-326') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-328')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem.XunJian_1">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-61') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-326') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-329')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem.Bjsbyxqk_1">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-61') }}</Radio>
                      <Radio label="2" class="alarm">{{ $t('smartCity.Home.943046-62') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-330') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-331')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem.Ldsbyxqk_1">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-61') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-330') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-332')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input type="textarea" v-model="addFormItem.BjbwyyClqk_1" :autosize="{ minRows: 3, maxRows: 5 }"
                      :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-334')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem.Zbr_1" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="handleSubmit('addFormItem')">{{
                $t('smartCity.Home.943046-285') }}</Button>
              <Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="addState = false, reset()">{{
                $t('smartCity.Home.943046-335') }}</Button>
              </Col>
            </div>
          </div>

          <div class="outline-mode" v-if="logType == 2">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right" :rules="ruleValidate.rule2" ref="addFormItem2" :model="addFormItem2">
                  <FormItem :label="$t('smartCity.Home.943046-323')" class="f12" prop="Rq2_2"
                    style="margin-right: 10%;margin-left: 8%;">
                    <DatePicker type="date" :placeholder="$t('smartCity.Home.943046-324')" v-model="addFormItem2.Rq2_2">
                    </DatePicker>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-336')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem2.Tcqxh_2" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-337')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem2.Xcdzzjl_2">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-68') }}</Radio>
                      <Radio label="2" class="alarm">{{ $t('smartCity.Home.943046-338') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-69') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-339')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <RadioGroup v-model="addFormItem2.Clyj_2">
                      <Radio label="1" class="normal">{{ $t('smartCity.Home.943046-340') }}</Radio>
                      <Radio label="2" class="alarm">{{ $t('smartCity.Home.943046-341') }}</Radio>
                      <Radio label="0" class="abnormal">{{ $t('smartCity.Home.943046-342') }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-343')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem2.Djr_2" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="handleSubmit('addFormItem2')">{{
                $t('smartCity.Home.943046-285') }}</Button>
              <Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="addState = false, reset()">{{
                $t('smartCity.Home.943046-335') }}</Button>
              </Col>
            </div>
          </div>

          <div class="outline-mode" v-if="logType == 3">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right" :rules="ruleValidate.rule3" ref="addFormItem3" :model="addFormItem3">
                  <FormItem :label="$t('smartCity.Home.943046-323')" class="f12" prop="Rq3_3"
                    style="margin-right: 10%;margin-left: 8%;">
                    <DatePicker type="date" :placeholder="$t('smartCity.Home.943046-324')" v-model="addFormItem3.Rq3_3">
                    </DatePicker>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-37')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem3.Sbzl_3" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-344')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem3.Jcsynr_3" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-345')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem3.Jcsyjg_3" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-346')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem3.Yqzj_3" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-330')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem3.Gz_3" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-347')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem3.Pcqk_3" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-348')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input type="textarea" v-model="addFormItem3.Bz_3" :autosize="{ minRows: 3, maxRows: 5 }"
                      :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-349')" class="f12"
                    style="margin-right: 10%;margin-left: 8%;">
                    <Input v-model="addFormItem3.Jcr_3" :placeholder="$t('smartCity.Home.943046-333')"></Input>
                  </FormItem>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="handleSubmit('addFormItem3')">{{
                $t('smartCity.Home.943046-285') }}</Button>
              <Button style="font-size: 0.6vw; margin-left: 0.5vw;" @click="addState = false, reset()">{{
                $t('smartCity.Home.943046-335') }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <audio id="Play" loop="true">
      <source src="../../assets/electricity/bj.wav" />
    </audio>
    <div class="alarm-popup" :class="{ 'alarm-popup-display': alarmState, 'alarm-popup-hide': !alarmState }">
      <div class="alarm-header">
        <div class="alarm-header-inco">
          <img src="../../assets/home/alarm.png" alt="">
        </div>
        <div class="alarm-header-text">{{ $t('smartCity.Home.943046-119') }}</div>
      </div>
      <div class="alarm-details">
        <div class="alarm-details-title">{{ $t('smartCity.Home.943046-350') }}</div>
        <div class="alarm-details-text" @click="openPopup(1, $t('smartCity.Home.943046-12'))">
          {{
            `$t('smartCity.Home.943046-30')${deviceAlarm.UserDeviceName}在${deviceAlarm.AbnormalTime}发生${deviceAlarm.AbnormalName}$t('smartCity.Home.943046-62')，请及时处理`
          }}</div>

      </div>
      <div class="alarm-operat">
        <div class="alarm-operat-btn2"
          @click="ProcessUserDeviceAbnormalDeviceCode(deviceAlarm.DeviceCode, deviceAlarm.AbnormalTime, 2)">{{
            $t('smartCity.Home.943046-250') }}</div>
        <div class="alarm-operat-btn3"
          @click="ProcessUserDeviceAbnormalDeviceCode(deviceAlarm.DeviceCode, deviceAlarm.AbnormalTime, 3)">{{
            $t('smartCity.Home.943046-121') }}</div>
        <div class="alarm-operat-btn1" @click="openPopup(1, $t('smartCity.Home.943046-12'))">{{
          $t('smartCity.Home.943046-352') }}</div>
      </div>
      <div class="alarm-down" @click="alarmState = false">
        <img src="../../assets/home/remove.png" alt="">
      </div>
    </div>
    <div class="model" v-if="picState">
      <div class="left-img" @click.stop="preImg" :style="{ cursor: (selectedPicIndex == 0 ? 'not-allowed' : 'pointer') }">
        <Icon type="ios-arrow-back" style="font-size: 32px;" />
      </div>
      <img style="max-height: 80vh; background-size: contain; margin: 0 20px; cursor: zoom-out; user-select: none;"
        :src="picList[selectedPicIndex].FileUrl" @click="picState = false" />
      <div class="right-img" @click.stop="nextImg"
        :style="{ cursor: (selectedPicIndex == (picList.length - 1) ? 'not-allowed' : 'pointer') }">
        <Icon type="ios-arrow-forward" style="font-size: 32px;" />
      </div>
    </div>
    <div class="model2" v-if="devicePicState" style="cursor: zoom-out;" @click="devicePicState = false">
      <img style="max-height: 80vh; background-size: contain; margin: 0 20px; user-select: none;"
        :src="selectedDevicePic" />
    </div>
    <div class="spin-view" v-if="spinMsg">
      <div class="spin-loading">
        <div class="loader">
          <div class="outer1"></div>
          <div class="middle"></div>
          <div class="inner"></div>
          <div class="loader-title">{{ spinTitle }}</div>
        </div>
      </div>
    </div>
    <div class="outline-view1" v-if="editDeviceState" @click="editDeviceState = false">
      <div class="outline-top4" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="$t('smartCity.Home.943046-353')">
          <div class="outline-remove" @click="editDeviceState = false">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right" :label-width="140">
                  <FormItem :label="$t('smartCity.Home.943046-354')" class="f12" style="margin-right: 100px;">
                    <Input v-model="selectedRow.DeviceCode" :placeholder="$t('smartCity.Home.943046-355')"
                      disabled></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-23')" class="f12" style="margin-right: 100px;">
                    <Input v-model="selectedRow.UserDeviceName" :placeholder="$t('smartCity.Home.943046-356')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-357')" class="f12" style="margin-right: 100px;">
                    <Input v-model="selectedRow.ContactsName" :placeholder="$t('smartCity.Home.943046-358')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-260')" class="f12" style="margin-right: 100px;">
                    <Input v-model="selectedRow.ContactsPhone" :placeholder="$t('smartCity.Home.943046-322')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-359')" class="f12">
                    <div class="demo-upload-list" v-for="item in uploadList">
                      <template>
                        <img :src="item.FileUrl" class="img">
                        <div class="demo-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                          <Poptip confirm transfer placement="top" :title="$t('smartCity.Home.943046-360')"
                            @on-ok="handleRemove(item)" @on-cancel="cancel">
                            <Icon type="ios-trash-outline" @click.native=""></Icon>
                          </Poptip>
                        </div>
                      </template>
                    </div>
                    <Upload v-if="uploadList.length < 3" ref="upload"
                      :action="`http://yhj.hxpwr.com/api/YhjDevice/UserDeviceBackPhoto?UserDeviceId=${selectedRow.Id}&filetype=2&deviceCode=${selectedRow.DeviceCode}`"
                      :format="['jpg', 'jpeg', 'png']" :show-upload-list="false" type="drag"
                      style="display: inline-block;width:80px;" :headers="getHeaders()" :on-success="handleSuccess">
                      <div style="width: 80px;height:80px;line-height: 80px;">
                        <Icon type="ios-camera" size="30"></Icon>
                      </div>
                    </Upload>
                  </FormItem>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="editDeviceState = false, EditDevice()">{{
                $t('smartCity.Home.943046-285') }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="clockState" @click="clockState = false, ReplyTime = null">
      <div class="outline-top4" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="$t('smartCity.Home.943046-361')">
          <div class="outline-remove" @click="clockState = false, ReplyTime = null">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right" :label-width="140">
                  <FormItem :label="$t('smartCity.Home.943046-362')" class="f12" style="margin-right: 100px;">
                    <Input v-model="ReplyTime" :placeholder="$t('smartCity.Home.943046-363')" disabled></Input>
                  </FormItem>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="SetSZ_ModbusV3()">{{
                $t('smartCity.Home.943046-364') }}</Button>
              <Button type="success" style="font-size: 0.6vw; margin-left: 0.5vw;" @click="DeviceRWByTypeModbusV3()">{{
                $t('smartCity.Home.943046-365') }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="passWordState" @click="passWordState = false">
      <div class="outline-top4" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="$t('smartCity.Home.943046-366')">
          <div class="outline-remove" @click="passWordState = false">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <Form label-position="right" :label-width="140">
                  <FormItem :label="$t('smartCity.Home.943046-367')" class="f12" style="margin-right: 100px;">
                    <Input v-model="formPassWord.OldPassword" :placeholder="$t('smartCity.Home.943046-368')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-369')" class="f12" style="margin-right: 100px;">
                    <Input v-model="formPassWord.NewPassword" :placeholder="$t('smartCity.Home.943046-368')"></Input>
                  </FormItem>
                  <FormItem :label="$t('smartCity.Home.943046-370')" class="f12" style="margin-right: 100px;">
                    <Input v-model="formPassWord.ConfirmPassword" :placeholder="$t('smartCity.Home.943046-368')"></Input>
                  </FormItem>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="EditPassWord()">{{ $t('smartCity.Home.943046-285')
              }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="gasState" @click="gasState = false, resetGasModel()">
      <div class="outline-top3" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)"
          :title="gasStatus == 'add' ? $t('smartCity.Home.943046-371') : $t('smartCity.Home.943046-372')">
          <div class="outline-remove" @click="gasState = false, resetGasModel()">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists" style="padding-bottom: 10px">
                <Form ref="gasForm" :model="gasModel" :rules="ruleValidate.gasRule" label-position="right"
                  :label-width="170" class="gasForm">
                  <Row>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-373')" prop="Xsfs" class="f12">
                      <Select v-model="gasModel.Xsfs" :placeholder="$t('smartCity.Home.943046-310')">
                        <Option value="1">{{ $t('smartCity.Home.943046-80') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-81') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                  </Row>

                  <Row v-if="gasModel.Xsfs == '0'">
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-77')" prop="Qjmc" class="f12">
                      <Input v-model="gasModel.Qjmc" :placeholder="$t('smartCity.Home.943046-333')" clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-374')" prop="Qjlx" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Qjlx" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Qjlx" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Qjlx', $t('smartCity.Home.943046-374'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-375')" prop="Sydw" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Sydw" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sydw" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Sydw', $t('smartCity.Home.943046-375'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-376')" prop="Sydwtyshxydm" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Sydwtyshxydm" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sydwtyshxydm" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Sydwtyshxydm', $t('smartCity.Home.943046-376'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-377')" prop="Gqdw" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Gqdw" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Gqdw" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Gqdw', $t('smartCity.Home.943046-377'))" />
                      </div>
                    </FormItem>
                    </Col>
                  </Row>

                  <Row v-if="gasModel.Xsfs == '1'">
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-77')" prop="Qjmc" class="f12">
                      <Input v-model="gasModel.Qjmc" :placeholder="$t('smartCity.Home.943046-333')" clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-374')" prop="Qjlx" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Qjlx" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Qjlx" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Qjlx', $t('smartCity.Home.943046-374'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-375')" prop="Sydw" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Sydw" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sydw" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Sydw', $t('smartCity.Home.943046-375'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-376')" prop="Sydwtyshxydm" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Sydwtyshxydm" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sydwtyshxydm" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Sydwtyshxydm', $t('smartCity.Home.943046-376'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-377')" prop="Gqdw" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Gqdw" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Gqdw" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Gqdw', $t('smartCity.Home.943046-377'))" />
                      </div>
                    </FormItem>
                    </Col>

                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-378')" prop="Xhgg" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Xhgg" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Xhgg" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Xhgg', $t('smartCity.Home.943046-378'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-379')" prop="Ccbh" class="f12">
                      <Input v-model="gasModel.Ccbh" :placeholder="$t('smartCity.Home.943046-333')" clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-380')" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Sccjtyshxydm" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sccjtyshxydm" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Sccjtyshxydm', $t('smartCity.Home.943046-380'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-381')" prop="Sccj" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Sccj" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sccj" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Sccj', $t('smartCity.Home.943046-381'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-382')" class="f12">
                      <Input v-model="gasModel.Xspzzsh" :placeholder="$t('smartCity.Home.943046-333')" clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-383')" prop="Azdd" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Azdd" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Azdd" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Azdd', $t('smartCity.Home.943046-383'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-384')" prop="Lzsyfs" class="f12">
                      <Select v-model="gasModel.Lzsyfs" :placeholder="$t('smartCity.Home.943046-310')"
                        @on-change="$set(gasModel, 'Jlxnfhx', '')">
                        <Option value="0">{{ $t('smartCity.Home.943046-82') }}</Option>
                        <Option value="1">{{ $t('smartCity.Home.943046-83') }}</Option>
                        <Option value="2">{{ $t('smartCity.Home.943046-84') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                  </Row>

                  <Row v-if="gasModel.Xsfs == '1' && gasModel.Lzsyfs != '0'">
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-385')" prop="Lzsyjg" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasModel.Lzsyjg" :placeholder="$t('smartCity.Home.943046-310')" placement="top"
                          clearable>
                          <Option v-for="item in selectionList.Lzsyjg" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                        <Icon type="ios-add-circle-outline" class="gasFormAdd"
                          @click="showSelectionPopup('Lzsyjg', $t('smartCity.Home.943046-385'))" />
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-386')" prop="Lzsyrq" class="f12">
                      <DatePicker format="yyyy/MM/dd" type="date" placement="top"
                        :placeholder="$t('smartCity.Home.943046-308')" style="width: 200px" v-model="gasModel.Lzsyrq">
                      </DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-387')" prop="Zsbh" class="f12">
                      <Input v-model="gasModel.Zsbh" :placeholder="$t('smartCity.Home.943046-333')" clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-388')" prop="Jlxnfhx" class="f12">
                      <Select v-model="gasModel.Jlxnfhx" :placeholder="$t('smartCity.Home.943046-310')" placement="top"
                        clearable v-if="gasModel.Lzsyfs == '1'" key="1">
                        <Option value="1">{{ $t('smartCity.Home.943046-68') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-69') }}</Option>
                      </Select>
                      <Select v-model="gasModel.Jlxnfhx" :placeholder="$t('smartCity.Home.943046-310')" placement="top"
                        clearable v-if="gasModel.Lzsyfs == '2'" key="2">
                        <Option value="2">{{ $t('smartCity.Home.943046-85') }}</Option>
                        <Option value="3">{{ $t('smartCity.Home.943046-86') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                  </Row>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw;" @click="gasComfirm()">{{ $t('smartCity.Home.943046-285')
              }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="gasQueryState" @click="gasQueryState = false">
      <div class="outline-top3" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="$t('smartCity.Home.943046-78')">
          <div class="outline-remove" @click="gasQueryState = false">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists" style="padding-bottom: 10px">
                <Form label-position="right" :label-width="170" class="gasForm">
                  <Row>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-374')" prop="Qjlx" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Qjlx" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Qjlx" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-378')" prop="Xhgg" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Xhgg" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Xhgg" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-379')" prop="Ccbh" class="f12">
                      <Input v-model="gasQueryModel.Ccbh" :placeholder="$t('smartCity.Home.943046-333')"
                        clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-380')" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Sccjtyshxydm" :placeholder="$t('smartCity.Home.943046-310')"
                          clearable>
                          <Option v-for="item in selectionList.Sccjtyshxydm" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-381')" prop="Sccj" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Sccj" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sccj" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-382')" class="f12">
                      <Input v-model="gasQueryModel.Xspzzsh" :placeholder="$t('smartCity.Home.943046-333')"
                        clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-373')" prop="Xsfs" class="f12">
                      <Select v-model="gasQueryModel.Xsfs" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-80') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-81') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-375')" prop="Sydw" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Sydw" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Sydw" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-376')" prop="Sydwtyshxydm" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Sydwtyshxydm" :placeholder="$t('smartCity.Home.943046-310')"
                          clearable>
                          <Option v-for="item in selectionList.Sydwtyshxydm" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-377')" prop="Gqdw" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Gqdw" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Gqdw" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-383')" prop="Azdd" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Azdd" :placeholder="$t('smartCity.Home.943046-310')" clearable>
                          <Option v-for="item in selectionList.Azdd" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-384')" prop="Lzsyfs" class="f12">
                      <Select v-model="gasQueryModel.Lzsyfs" :placeholder="$t('smartCity.Home.943046-310')"
                        @on-change="$set(gasQueryModel, 'Jlxnfhx', '')" clearable>
                        <Option value="0">{{ $t('smartCity.Home.943046-82') }}</Option>
                        <Option value="1">{{ $t('smartCity.Home.943046-83') }}</Option>
                        <Option value="2">{{ $t('smartCity.Home.943046-84') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>

                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-385')" prop="Lzsyjg" class="f12">
                      <div class="gasFormSelect">
                        <Select v-model="gasQueryModel.Lzsyjg" :placeholder="$t('smartCity.Home.943046-310')"
                          placement="top" clearable>
                          <Option v-for="item in selectionList.Lzsyjg" :value="item.ParamVal" :key="item.Id">{{
                            item.ParamName }}</Option>
                        </Select>
                      </div>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-386')" prop="Lzsyrq" class="f12">
                      <DatePicker format="yyyy/MM/dd" type="date" placement="top"
                        :placeholder="$t('smartCity.Home.943046-308')" style="width: 200px"
                        v-model="gasQueryModel.Lzsyrq"></DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem :label="$t('smartCity.Home.943046-387')" prop="Zsbh" class="f12">
                      <Input v-model="gasQueryModel.Zsbh" :placeholder="$t('smartCity.Home.943046-333')"
                        clearable></Input>
                    </FormItem>
                    </Col>
                    <Col span="10" offset="1">
                    <FormItem :label="$t('smartCity.Home.943046-388')" prop="Jlxnfhx" class="f12">
                      <Select v-model="gasQueryModel.Jlxnfhx" :placeholder="$t('smartCity.Home.943046-310')"
                        placement="top" clearable>
                        <Option value="1">{{ $t('smartCity.Home.943046-68') }}</Option>
                        <Option value="0">{{ $t('smartCity.Home.943046-69') }}</Option>
                        <Option value="2">{{ $t('smartCity.Home.943046-85') }}</Option>
                        <Option value="3">{{ $t('smartCity.Home.943046-86') }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                  </Row>
                </Form>
              </div>
              <Col span="24"
                style="position: absolute; bottom: 0.75vw; right: 2.5vw; display: flex; justify-content: flex-end;">
              <Button type="primary" style="font-size: 0.6vw; margin-right: 8px;"
                @click="getGasList(), gasQueryState = false">{{ $t('smartCity.Home.943046-389') }}</Button>
              <Button type="warning" @click="gasQueryModel = {}, getGasList()">{{ $t('smartCity.Home.943046-65')
              }}</Button>
              </Col>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="selectionState" @click="">
      <div class="outline-top5" @click.stop="">
        <dv-border-box-11 backgroundColor="rgba(7,22,55, 0.9)" :title="selectionTitle" :titleWidth="300">
          <div class="outline-remove" @click="closeSelectionPopup">
            <img src="../../assets/home/remove.png" alt="">
          </div>
          <div class="outline-mode">
            <div class="add-community-view-input-div">
              <div class="add-community-view-input-div-lists">
                <div style="display: flex; margin-bottom: 1vh;">
                  <Input v-model="addSelectionModel.ParamName" style="width: 250px;"
                    :placeholder="$t('smartCity.Home.943046-390')" @on-enter="addSelectOption"></Input>
                  <Button type="primary" style="margin-left: 8px;" @click="addSelectOption">{{
                    $t('smartCity.Home.943046-79') }}</Button>
                </div>
                <div style="display: flex; margin-bottom: 1vh;"
                  v-for="item in selectionList[addSelectionModel.ParamType]">
                  <Input v-model="item.ParamName" style="width: 250px;"
                    :placeholder="$t('smartCity.Home.943046-390')"></Input>
                  <Button type="primary" style="margin-left: 8px;" @click="editSelectOption(item)">{{
                    $t('smartCity.Home.943046-391') }}</Button>
                  <Poptip confirm :title="$t('smartCity.Home.943046-392')" placement="top-end" offset='-20'
                    @on-ok="delSelectOption(item)" @on-cancel="cancel">
                    <Button type="error" style="margin-left: 8px;">{{ $t('smartCity.Home.943046-87') }}</Button>
                  </Poptip>
                </div>
              </div>
            </div>
          </div>
        </dv-border-box-11>
      </div>
    </div>
    <div class="outline-view1" v-if="showGuideModal" @click="VivianSaid">
      <div class="guide-container" @click.stop="">
        <div class="guide-left">
          <img src="../../assets/newHome/aqyd.png" class="guide-img"
            :class="{ 'guide-img-actived': currenGuideIndex == 0 }">
          <img src="../../assets/newHome/aqyq.png" class="guide-img"
            :class="{ 'guide-img-actived': currenGuideIndex == 1 }">
          <img src="../../assets/newHome/nyjn.png" class="guide-img"
            :class="{ 'guide-img-actived': currenGuideIndex == 2 }">
          <div class="dot-list">
            <div class="dot" :class="{ 'dot-actived': currenGuideIndex == 0 }" @click="changeGuideIndex(0)"></div>
            <div class="dot" :class="{ 'dot-actived': currenGuideIndex == 1 }" @click="changeGuideIndex(1)">></div>
            <div class="dot" :class="{ 'dot-actived': currenGuideIndex == 2 }" @click="changeGuideIndex(2)">></div>
          </div>
        </div>
        <div class="guide-right">
          <div class="guide-right-top">
            <span style="font-size: 32px; font-weight: bold;">{{ $t('smartCity.Home.943046-33') }}</span>
          </div>
          <div class="guide-right-middle">
            <div class="guide-item">
              <img src="../../assets/newHome/icon-yjdr.png">
              <span class="guide-text">{{ $t('smartCity.Home.943046-393') }}</span>
              <Button type="primary" @click="openGuide('yjdr')">{{ $t('smartCity.Home.943046-394') }}</Button>
            </div>
            <div class="guide-item">
              <img src="../../assets/newHome/icon-aqyq.png">
              <span class="guide-text">{{ $t('smartCity.Home.943046-27') }}</span>
              <Button type="primary" @click="openGuide('aqyq')">{{ $t('smartCity.Home.943046-394') }}</Button>
            </div>
            <div class="guide-item">
              <img src="../../assets/newHome/icon-sjzx.png">
              <span class="guide-text">{{ $t('smartCity.Home.943046-395') }}</span>
              <Button type="primary" @click="openGuide('sjzx')">{{ $t('smartCity.Home.943046-394') }}</Button>
            </div>
          </div>
          <div class="guide-right-bottom">
            <span class="cursor" type="primary" @click="VivianSaid">{{ $t('smartCity.Home.943046-396') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import Cookies from 'js-cookie'
import api from '../../api/request.js'
const colors = ['#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];
export default {
  name: 'App',
  data() {
    return {
      activeNames: ['1'],
      show: false,
      show2: false,
      over: false,
      GetAbDataLists: [], // 及时告警消息列表
      GetAbDataCount: 0, // 数量
      GetAbDataListsMsg: false,
      GetEchartAbDataMsg: false,
      GetNavDatas: {}, // 导航栏数据
      GetNavDatasNew: {},
      GetNavDataYHJs: {}, // 导航栏数据yhj
      processed: '', // 已处理数
      GetOperationDataList: [], // 当天操作日志数据列表
      GetOperationDataListMsg: false,
      cityName: '', // 获取地理位置
      GetDeviceDataLists: [], // 设备相关数据列表
      GetDeviceDataListsMsg: false,
      HomeModeList: [],//首页模式列表

      PlayIndex: false, // 播放按钮
      offsetMsg: false,

      popupState: false, // 弹窗状态
      doubleState: false, // 双击弹窗装填
      popupType: 0, // 弹窗类型
      popupTitle: "", // 弹窗title
      pageIndex: 1,
      pageSize: 10,
      DeviceLists: [], // 设备列表
      DeviceTotal: 0, // 设备数量
      DeviceCategory: '',
      DeviceAbnormalList: [], // 报警列表
      DeviceAbnormalTotalCount: 0, // 报警数量
      DeviceCountList: [], // 当前报警设备
      GetCurrRoomAbLists: [], // 当前报警住户

      TittleName: '', // 中文title
      TittleNameEN: '', // 英文title
      ImageUrl: '',

      DeviceCode: "",
      cmmModel: {}, // 城市信息
      villModel: {}, // 小区信息
      roomModel: {}, // 业主信息
      elecFixModel: {}, // 维修信息

      alarmState: false, // 警报状态
      alarmTime: null, // 报警定时器
      deviceAlarm: {}, // 设备报警信息

      themeList: [],
      themeCode: '',

      villageList: [],
      threeLevelList: [],
      fourLevelList: [],
      areaList: [],
      deviceCatCountList: [],
      deviceCatCountListAll: [],
      deviceAbnormalCountList: [],
      selectedArea: {}, // 选择的市
      selectedVillage: '', // 选择的区
      selectedThreeLevel: {},
      selectedFourLevel: {},
      selectedUser: {}, // 选择的用户
      selectedDevice: {}, // 选择的设备
      showArea: true,
      point: null, // 地图点位
      dataList: [], // 设备列表
      dataListAll: [], // 无参数设备列表
      cityName: Cookies.get('cityName') || this.$t('smartCity.Home.943046-397'),
      areaMap: null, // 地图
      map: null, // 地图
      GetNavDataYHJsNew: {},
      timer: null, // 轮询获取数据
      level: 2,

      GetRoshRoomAllLists: [],
      UserTotalCount: 0,
      UserPageIndex: 1,
      UserPageSize: 12,
      mapGetRoshRoomAllLists: [],
      mapUserTotalCount: 0,
      AlarmTotalCount: 0,
      deviceType: '',
      key1: 'key1',
      key2: 'key2',
      mode: 'map',
      isDetail: false,
      isFromMap: false,
      userSearchForm: {
        RunStatus: '',
        OwnerName: '',
        UserId: null
      },
      deviceSearchForm: {
        RunStatus: '',
        DeviceType: '',
        deviceName: '',
        deviceCode: '',
        onlineState: ''
      },
      address_detail: null, //详细地址
      columns1: [
        { title: ' ', key: 'RunStatus', slot: 'RunStatus', width: 70 },
        { title: this.$t('smartCity.Home.943046-246'), key: 'OwnerName', className: 'underline', minWidth: 120 },
        { title: this.$t('smartCity.Home.943046-295'), key: 'OrganizationName', minWidth: 160 },
        { title: this.$t('smartCity.Home.943046-260'), key: 'OwnerPhone', minWidth: 160 },
        { title: this.$t('smartCity.Home.943046-398'), key: 'RoomAddress', minWidth: 200 },
        { title: this.$t('smartCity.Home.943046-293'), slot: 'RoomType', minWidth: 100 },
        { title: this.$t('smartCity.Home.943046-399'), key: 'QiTiBaoJingQiCount', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-400'), key: 'RanQiDcfCount', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-303'), key: 'UserLimitYear', minWidth: 100 },
        { title: this.$t('smartCity.Home.943046-305'), key: 'AreaManager', minWidth: 120 },
        { title: this.$t('smartCity.Home.943046-297'), key: 'AreaManagerPhone', minWidth: 160 },
        { title: this.$t('smartCity.Home.943046-299'), slot: 'YearExamState', minWidth: 160 },
        { title: this.$t('smartCity.Home.943046-307'), slot: 'Jdzsyxq', minWidth: 220 },
        { title: this.$t('smartCity.Home.943046-31'), slot: 'action', align: 'center', width: 190, fixed: 'right' },
        // {title: this.$t('smartCity.Home.943046-31'), slot: 'action', align: 'center', width: 250, fixed: 'right'},
      ],
      columns2: [
        { title: ' ', slot: 'IsHealth', key: 'IsHealth', width: 70 },
        { title: this.$t('smartCity.Home.943046-23'), key: 'UserDeviceName', minWidth: 230 },
        { title: this.$t('smartCity.Home.943046-90'), key: 'DeviceCode', minWidth: 230 },
        { title: this.$t('smartCity.Home.943046-256'), slot: 'IsOnline', minWidth: 100, align: 'center' },
        { title: this.$t('smartCity.Home.943046-24'), slot: 'SwitchStatus', minWidth: 100, align: 'center' },
        { title: this.$t('smartCity.Home.943046-357'), key: 'ContactsName', minWidth: 100 },
        { title: this.$t('smartCity.Home.943046-260'), key: 'ContactsPhone', minWidth: 160 },
        { title: this.$t('smartCity.Home.943046-89'), slot: 'DeviceId', key: 'DeviceId', minWidth: 170 },
        { title: this.$t('smartCity.Home.943046-255'), key: 'UpdateTime', minWidth: 210 },
        { title: this.$t('smartCity.Home.943046-401'), key: 'Address', minWidth: 330 },
        { title: this.$t('smartCity.Home.943046-31'), slot: 'action', width: 292, fixed: 'right' },
      ],
      columns3: [
        { title: this.$t('smartCity.Home.943046-77'), key: 'Qjmc', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-374'), key: 'Qjlx', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-378'), key: 'Xhgg', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-379'), key: 'Ccbh', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-380'), key: 'Sccjtyshxydm', minWidth: 300 },
        { title: this.$t('smartCity.Home.943046-381'), key: 'Sccj', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-382'), key: 'Xspzzsh', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-373'), slot: 'Xsfs', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-375'), key: 'Sydw', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-376'), key: 'Sydwtyshxydm', minWidth: 300 },
        { title: this.$t('smartCity.Home.943046-377'), key: 'Gqdw', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-383'), key: 'Azdd', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-384'), slot: 'Lzsyfs', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-385'), key: 'Lzsyjg', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-386'), slot: 'Lzsyrq', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-387'), key: 'Zsbh', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-388'), slot: 'Jlxnfhx', minWidth: 150 },
        { title: this.$t('smartCity.Home.943046-31'), slot: 'action', align: 'center', width: 160, fixed: 'right' },
      ],
      columns7: [
        { type: 'selection', width: 60, align: 'center' },
        { title: this.$t('smartCity.Home.943046-323'), slot: 'Rq1_1', align: 'center' },
        {
          title: this.$t('smartCity.Home.943046-402'),
          align: 'center',
          children: [
            { title: this.$t('smartCity.Home.943046-325'), slot: 'ZiJian_1', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-237'), slot: 'XiaoYin_1', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-327'), slot: 'DianYuan_1', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-328'), slot: 'XunJian_1', width: 75, align: 'center' },
          ]
        },
        {
          title: this.$t('smartCity.Home.943046-329'),
          align: 'center',
          children: [
            { title: this.$t('smartCity.Home.943046-61'), slot: 'Bjsbyxqk_1', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-62'), slot: 'Bjsbyxqk_2', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-330'), slot: 'Bjsbyxqk_3', width: 75, align: 'center' },
          ]
        },
        {
          title: this.$t('smartCity.Home.943046-331'),
          align: 'center',
          children: [
            { title: this.$t('smartCity.Home.943046-61'), slot: 'Ldsbyxqk_1', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-330'), slot: 'Ldsbyxqk_2', width: 75, align: 'center' },
          ]
        },
        { title: this.$t('smartCity.Home.943046-332'), key: 'BjbwyyClqk_1', align: 'center' },
        { title: this.$t('smartCity.Home.943046-334'), key: 'Zbr_1', align: 'center' },
        { title: this.$t('smartCity.Home.943046-31'), slot: 'action', align: 'center' },
      ],
      columns8: [
        { type: 'selection', width: 60, align: 'center' },
        { title: this.$t('smartCity.Home.943046-323'), slot: 'Rq2_2', align: 'center' },
        { title: this.$t('smartCity.Home.943046-336'), key: 'Tcqxh_2', align: 'center' },
        {
          title: this.$t('smartCity.Home.943046-337'),
          align: 'center',
          children: [
            { title: this.$t('smartCity.Home.943046-68'), slot: 'Xcdzzjl_1', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-338'), slot: 'Xcdzzjl_2', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-69'), slot: 'Xcdzzjl_3', width: 90, align: 'center' },
          ]
        },
        {
          title: this.$t('smartCity.Home.943046-339'),
          align: 'center',
          children: [
            { title: this.$t('smartCity.Home.943046-340'), slot: 'Clyj_1', width: 100, align: 'center' },
            { title: this.$t('smartCity.Home.943046-341'), slot: 'Clyj_2', width: 75, align: 'center' },
            { title: this.$t('smartCity.Home.943046-342'), slot: 'Clyj_3', width: 100, align: 'center' },
          ]
        },
        { title: this.$t('smartCity.Home.943046-343'), key: 'Djr_2', align: 'center' },
        { title: this.$t('smartCity.Home.943046-31'), slot: 'action', align: 'center' },
      ],
      columns9: [
        { type: 'selection', width: 60, align: 'center' },
        {
          title: this.$t('smartCity.Home.943046-295'),
          align: 'center',
          children: [
            { title: this.$t('smartCity.Home.943046-323'), slot: 'Rq3_3', align: 'center' },
            { title: this.$t('smartCity.Home.943046-37'), key: 'Sbzl_3', align: 'center' },
            { title: this.$t('smartCity.Home.943046-344'), key: 'Jcsynr_3', align: 'center' },
            { title: this.$t('smartCity.Home.943046-345'), key: 'Jcsyjg_3', align: 'center' },
          ]
        },
        {
          title: this.$t('smartCity.Home.943046-403'),
          align: 'center',
          children: [
            { title: this.$t('smartCity.Home.943046-346'), key: 'Yqzj_3', align: 'center' },
            { title: this.$t('smartCity.Home.943046-330'), key: 'Gz_3', align: 'center' },
            { title: this.$t('smartCity.Home.943046-347'), key: 'Pcqk_3', align: 'center' },
            { title: this.$t('smartCity.Home.943046-348'), key: 'Bz_3', align: 'center' },
            { title: this.$t('smartCity.Home.943046-349'), key: 'Jcr_3', align: 'center' }
          ]
        },
        { title: this.$t('smartCity.Home.943046-31'), slot: 'action', align: 'center' },
      ],
      userDeviceList: [],
      checkCode: 'Axiangdianya',
      devicePage: 1,
      devicePageSize: 10,
      deviceTotal: 0,
      AbnormalList: [],
      AbnormalTotal: 0,
      AbnormalPage: 1,
      AbnormalPageSize: 5,
      userEx: {},
      tabValue: 'tab1',
      DeviceParameterLookLists: [],
      DeviceInfoBaseModel: [],
      DeviceDianCiModelL: [],
      picList: [],
      picState: false,
      selectedPicIndex: 0,
      picsTotal: 0,
      picPageIndex: 1,
      picPageSize: 10,
      picRow: {}, // 查看图片的用户项
      editState: false, // 编辑用户弹窗状态
      userModel: {}, // 用户信息
      Jdzsyxq: [],

      // 检查记录弹框
      UserGasCheckLogs: [],
      addState: false,
      logType: 0,
      addFormItem: {
        Rq1_1: '',
        ZiJian_1: -1,
        XiaoYin_1: -1,
        DianYuan_1: -1,
        XunJian_1: -1,
        Bjsbyxqk_1: -1,
        Ldsbyxqk_1: -1,
        BjbwyyClqk_1: '',
        Zbr_1: ''
      },
      addFormItem2: {
        Rq2_2: '',
        Tcqxh_2: '',
        Xcdzzjl_2: -1,
        Clyj_2: -1,
        Djr_2: ''
      },
      addFormItem3: {
        Id: null,
        Rq3_3: '',
        Sbzl_3: '',
        Jcsynr_3: '',
        Jcsyjg_3: '',
        Yqzj_3: '',
        Gz_3: '',
        Pcqk_3: '',
        Bz_3: '',
        Jcr_3: ''
      },
      ruleValidate: {
        rule1: {
          Rq1_1: [{ required: true, type: 'date', message: this.$t('smartCity.Home.943046-308'), trigger: 'change' }],
        },
        rule2: {
          Rq2_2: [{ required: true, type: 'date', message: this.$t('smartCity.Home.943046-308'), trigger: 'change' }],
        },
        rule3: {
          Rq3_3: [{ required: true, type: 'date', message: this.$t('smartCity.Home.943046-308'), trigger: 'change' }],
        },
        gasRule: {
          Xsfs: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Qjmc: [{ required: true, message: this.$t('smartCity.Home.943046-333'), trigger: 'change' }],
          Qjlx: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Sydw: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Sydwtyshxydm: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Gqdw: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Xhgg: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Ccbh: [{ required: true, message: this.$t('smartCity.Home.943046-333'), trigger: 'change' }],
          Sccj: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Azdd: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Lzsyfs: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Lzsyjg: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Lzsyrq: [{ required: true, type: 'date', message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
          Zsbh: [{ required: true, message: this.$t('smartCity.Home.943046-333'), trigger: 'change' }],
          Jlxnfhx: [{ required: true, message: this.$t('smartCity.Home.943046-310'), trigger: 'change' }],
        }
      },
      selectedRow: {},
      logsTotal: 0,
      logPageIndex: 1,
      idList: [],
      actionType: this.$t('smartCity.Home.943046-79'),

      // 更多按钮
      DeviceBtns: [],
      moreStatu: false,
      moreX: 0,
      moreY: 0,
      editDeviceState: false,
      operatMsg: false, // 延迟操作状态（分合闸，召测需延迟7s）
      callState: true,
      spinMsg: false,
      spinTitle: '',
      mapSpin: false,
      qtcgqTtItemLists: [],
      ReplyTime: null, // 设备时钟
      clockState: false,
      passWordIndex: false,
      saveState: true,
      operatPassword: '',
      formPassWord: {
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      },
      passWordState: false,
      moreSpin: false,
      uploadList: [],
      devicePicState: false,
      selectedDevicePic: '',

      // tab
      pstate: 0,
      option: {
        title: {
          text: this.$t('smartCity.Home.943046-404'),
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          name: this.$t('smartCity.Home.943046-29'),
          axisLine: {
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          },
          data: []
        },
        legend: {
          textStyle: {
            color: '#fff'
          }
        },
        textStyle: {
          color: '#fff'
        },
        yAxis: {
          axisLine: {
            show: true,
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            name: ''
          },
          {
            type: 'line',
            data: [],
            name: ''
          },
          {
            type: 'line',
            data: [],
            name: ''
          },
          {
            type: 'line',
            data: [],
            name: ''
          }
        ],
      },
      byDateOption: {
        title: {
          text: this.$t('smartCity.Home.943046-405'),
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          name: this.$t('smartCity.Home.943046-29'),
          data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          axisLabel: {
            rotate: 45
          },
          axisLine: {
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          }
        },
        yAxis: {
          name: this.$t('smartCity.Home.943046-406'),
          axisLine: {
            show: true,
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#038bff',
              type: 'dotted'
            }
          }
        },
        color: ['#0efcff'],
        textStyle: {
          color: '#fff'
        },
        series: [
          {
            data: [],
            type: 'line',
            smooth: true
          }
        ]
      },
      formThreshold: {},

      // 燃气填报
      gasList: [], // 燃气表
      gasPage: { // 燃气表翻页
        pageIndex: 1,
        pageSize: 10,
        TotalCount: 0
      },
      gasQueryModel: {}, // 燃气参数
      gasQueryState: false, // 燃气查询弹窗
      gasModel: {
        Xsfs: '0',
        Lzsyfs: '0'
      },
      gasState: false, // 新增、编辑燃气弹窗
      gasStatus: 'add', // 判断是新增还是编辑
      selectionState: false, // 自定义下拉选项框
      selectionTitle: '', // 自定义下拉框弹框标题
      addSelectionModel: {
        ParamType: '',
        ParamName: ''
      },  // 新增下拉选项参数
      selectionList: {
        Qjlx: [],
        Xhgg: [],
        Sccjtyshxydm: [],
        Sccj: [],
        Sydw: [],
        Sydwtyshxydm: [],
        Gqdw: [],
        Lzsyjg: [],
        Azdd: []
      },

      // 系统引导
      showGuideModal: false,
      tableKey: 0,
      currenGuideIndex: 0,
      guideTimer: null, // 系统引导插画轮播
      wsDeviceId: '',
      wsType: -1,
      LangageType: localStorage.getItem('language')
    }
  },
  created() {
    let _this = this;
    // 获取播放状态
    _this.PlayIndex = Cookies.get('PlayIndex') == 'true' ? true : false;
    _this.themeList = _this.$store.getters.getThemeList;
    _this.themeCode = _this.$store.getters.getThemeCode;
    _this.HomeModeList = _this.$store.getters.getHomeModeList;

    // if (_this.themeCode === 'default') {
    // 	require('./smart_city_default.scss')
    // } else {
    // 	require('./smart_city.scss')
    // }
    this.initWebSocket();

  },

  computed: {
    SignalRState() {
      let _this = this;
      return _this.$store.getters.getSignalRState;
    },
    homeType() {
      return this.$store.state.HomeType;
    },

  },

  watch: {
    SignalRState(value) {
      let _this = this;
      if (value) {
        if (_this.PlayIndex) {
          _this.play = document.getElementById('Play');
          _this.play.play();
        }

        // 根据集团 公司 部门获取设备异常（yhj）
        _this.GetDeviceAbnormalPageListWith3Code('self');

        // 获取导航栏数据（yhj）
        _this.GetNavDataYHJ();

        // 告警异常处理情况图表数据
        _this.GetEchartAbData();

        // 判断当前用户是否超级管理员
        _this.IsOrNOSuperAdmin();

        _this.deviceAlarm = _this.$store.getters.getDeviceAlarm; // 报警详情
        _this.alarmClick();

      }
      _this.$store.dispatch("setSignalRState", false);
    },
    PlayIndex(value) {
      let _this = this;
      if (value) {
        _this.play = document.getElementById('Play');
        _this.GetAbDeviceCount(); // 获取异常设备条数
      } else {
        _this.play = document.getElementById('Play');
        _this.play.pause();
      }
    },
  },

  mounted() {
    let _this = this;

    // 判断当前用户是否超级管理员
    _this.IsOrNOSuperAdmin();

    // 根据集团 公司 部门获取设备异常（yhj）
    _this.GetDeviceAbnormalPageListWith3Code();

    // 获取导航栏数据
    _this.GetNavData();

    // 获取导航栏数据（yhj）
    _this.GetNavDataYHJ();



    // 当天操作日志数据（yhj）
    _this.GetOperationData();

    // 根据集团 公司 部门编号 等条件查询设备列表
    _this.GetUserDevicesPage();

    // 加载城市列表
    _this.GetRoshCommunityList();

    // 获取当前位置
    // _this.getPosition();

    _this.$nextTick(function () {
      _this.modeFlashing();
    });
    //切换首页页面，default为默认页面，newHome为新页面
    if (this.homeType == 'newHome') {
      this.switchIndex('newHome', false);
    } else {
      this.switchIndex('default', false);
    }
    // 获取用户是否有操作密码
    this.GetPassWord();

    if (this.$route.params.fromLogin && this.homeType == 'newHome') {
      this.showGuide();
    }

    // setInterval(() => {
    //   _this.getNumScroll(_this.GetNavDataYHJs);
    // }, 10000);
  },
  methods: {
    setLangage(type) {
      localStorage.setItem('language', type)
      this.$i18n.locale = type
      this.LangageType = type
    },
    handleClick() {
      this.show = !this.show;
      this.show2 = !this.show2;
      this.over = !this.over;
    },
    initWebSocket() {
      const ws = new WebSocket("ws://yhj.hxpwr.com:7127/yhjhome_index");
      // ws.onopen = function(evt) {
      // 	console.log('open', evt);
      // };
      ws.addEventListener('message', (evt) => {
        if (evt.data.includes('yhjhome_index')) {
          return;
        }
        let data = JSON.parse(evt.data);
        if (data.deviceCode == this.wsDeviceId && data.sendType == this.wsType) {
          setTimeout(() => {
            this.getUserDevice();
          }, 2000)
          this.wsDeviceId = '';
          this.wsType = -1;
        }
      })
      ws.addEventListener(('close'), (evt) => {
        if (evt.wasClean) {
          console.log("close", evt);
        } else {
          this.initWebSocket();
          console.log('reconnect');
        }
      })
      ws.addEventListener('error', function (event) {
        console.log('error: ', event);
      });
      this.ws = ws;
    },
    // 改变轮播图当前插画
    changeGuideIndex(index) {
      this.currenGuideIndex = index;
      clearInterval(this.guideTimer);
      this.guideTimer = setInterval(() => {
        if (this.currenGuideIndex < 2) {
          this.currenGuideIndex++;
        } else {
          this.currenGuideIndex = 0;
        }
      }, 5000);
    },
    // 开启系统引导
    showGuide() {
      this.showGuideModal = true;
      let guideTimer = setInterval(() => {
        if (this.currenGuideIndex < 2) {
          this.currenGuideIndex++;
        } else {
          this.currenGuideIndex = 0;
        }
      }, 5000);
      this.guideTimer = guideTimer;
    },
    // 关闭系统引导
    VivianSaid() {
      // 关闭窗口
      this.showGuideModal = false;
      clearInterval(this.guideTimer);
    },
    // 打开引导页
    openGuide(type) {
      this.showGuideModal = false;
      switch (type) {
        case 'yjdr':
          setTimeout(() => {
            const step = [
              {
                element: "#smartElectricity",
                popover: {
                  title: this.$t('smartCity.Home.943046-26'),
                  description: this.$t('smartCity.Home.943046-407'),
                  position: "left",
                  className: 'robotLeft'
                }
              }
            ]
            this.$driver.defineSteps(step);
            this.$driver.start();
          })
          break;
        case 'aqyq':
          setTimeout(() => {
            const step = [
              {
                element: "#useGas",
                popover: {
                  title: this.$t('smartCity.Home.943046-27'),
                  description: this.$t('smartCity.Home.943046-408'),
                  position: "left",
                  className: 'robotLeft'
                }
              }
            ]
            this.$driver.defineSteps(step);
            this.$driver.start();
          })
          break;
        case 'sjzx':
          setTimeout(() => {
            const step = [
              {
                element: "#area",
                popover: {
                  title: this.$t('smartCity.Home.943046-409'),
                  description: this.$t('smartCity.Home.943046-410'),
                  position: "right-bottom",
                  className: 'guide1 robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  this.setArea(this.areaList[0]);
                }
              },
              {
                element: "#menu-left",
                popover: {
                  title: this.$t('smartCity.Home.943046-411'),
                  description: this.$t('smartCity.Home.943046-412'),
                  position: "right",
                  className: 'robotRight'
                },
                onPrevious: () => {
                  this.$driver.preventMove();
                  this.back();
                }
              },
              {
                element: "#preLevelTag",
                popover: {
                  title: this.$t('smartCity.Home.943046-413'),
                  description: this.$t('smartCity.Home.943046-414'),
                  position: "right",
                  className: 'robotRight'
                }
              },
              {
                element: "#gasModeTag",
                popover: {
                  title: this.$t('smartCity.Home.943046-38'),
                  description: this.$t('smartCity.Home.943046-415'),
                  position: "bottom",
                  className: 'robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  this.switchMode('gas');
                }
              },
              {
                element: "#gasTable",
                popover: {
                  title: this.$t('smartCity.Home.943046-38'),
                  description: this.$t('smartCity.Home.943046-416'),
                  position: "mid-center",
                  className: 'robotLeft'
                }
              },
              {
                element: "#mapModeTag",
                popover: {
                  title: this.$t('smartCity.Home.943046-39'),
                  description: this.$t('smartCity.Home.943046-417'),
                  position: "bottom",
                  className: 'robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  this.switchMode('map');
                },
                onPrevious: () => {
                  this.$driver.preventMove();
                  this.switchMode('gas', 'prev');
                }
              },
              {
                element: "#mapModeMain",
                popover: {
                  title: this.$t('smartCity.Home.943046-39'),
                  description: this.$t('smartCity.Home.943046-418'),
                  position: "mid-center",
                  className: 'robotLeft'
                }
              },
              {
                element: "#tableModeTag",
                popover: {
                  title: this.$t('smartCity.Home.943046-40'),
                  description: this.$t('smartCity.Home.943046-419'),
                  position: "bottom",
                  className: 'robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  this.switchMode('table');
                },
                onPrevious: () => {
                  this.$driver.preventMove();
                  this.switchMode('map', 'prev');
                }
              },
              {
                element: "#userTable",
                popover: {
                  title: this.$t('smartCity.Home.943046-48'),
                  description: this.$t('smartCity.Home.943046-420'),
                  position: "mid-center",
                  className: 'robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  if (this.GetRoshRoomAllLists[0]) {
                    this.rowDbClick(this.GetRoshRoomAllLists[0]);
                  } else {
                    console.log(this.$t('smartCity.Home.943046-421'));
                  }
                }
              },
              {
                element: "#deviceTable",
                popover: {
                  title: this.$t('smartCity.Home.943046-422'),
                  description: this.$t('smartCity.Home.943046-423'),
                  position: "mid-center",
                  className: 'robotLeft'
                },
                onPrevious: () => {
                  this.$driver.preventMove();
                  this.back('prev');
                }
              },
              {
                element: "#backTag",
                popover: {
                  title: this.$t('smartCity.Home.943046-42'),
                  description: this.$t('smartCity.Home.943046-424'),
                  position: "left",
                  className: 'robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  this.back();
                },
                onPrevious: () => {
                  this.$driver.preventMove();
                  this.rowDbClick(this.GetRoshRoomAllLists[0], 'prev');
                }
              },
              {
                element: "#cardModeTag",
                popover: {
                  title: this.$t('smartCity.Home.943046-41'),
                  description: this.$t('smartCity.Home.943046-425'),
                  position: "left",
                  className: 'robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  this.switchMode('card');
                }
              },
              {
                element: "#userCard",
                popover: {
                  title: this.$t('smartCity.Home.943046-426'),
                  description: this.$t('smartCity.Home.943046-427'),
                  position: "mid-center",
                  className: 'robotLeft'
                },
                onNext: () => {
                  this.$driver.preventMove();
                  this.rowDbClick(this.GetRoshRoomAllLists[0]);
                },
                onPrevious: () => {
                  this.$driver.preventMove();
                  this.switchMode('table', 'prev');
                }
              },
              {
                element: "#deviceCard",
                popover: {
                  title: this.$t('smartCity.Home.943046-428'),
                  description: this.$t('smartCity.Home.943046-429'),
                  position: "mid-center",
                  className: 'robotLeft'
                },
                onPrevious: () => {
                  this.$driver.preventMove();
                  this.back('prev');
                }
              },
            ]
            this.$driver.defineSteps(step);
            this.$driver.start();
          })
          break;
        default:
          break;
      }

    },
    // 获取燃气所有下拉项
    getAllSelection() {
      if (!this.selectionList.Qjlx.length) {
        this.getSelectOption('Qjlx');
      }
      if (!this.selectionList.Xhgg.length) {
        this.getSelectOption('Xhgg');
      }
      if (!this.selectionList.Sccjtyshxydm.length) {
        this.getSelectOption('Sccjtyshxydm');
      }
      if (!this.selectionList.Sccj.length) {
        this.getSelectOption('Sccj');
      }
      if (!this.selectionList.Sydw.length) {
        this.getSelectOption('Sydw');
      }
      if (!this.selectionList.Sydwtyshxydm.length) {
        this.getSelectOption('Sydwtyshxydm');
      }
      if (!this.selectionList.Gqdw.length) {
        this.getSelectOption('Gqdw');
      }
      if (!this.selectionList.Lzsyjg.length) {
        this.getSelectOption('Lzsyjg');
      }
      if (!this.selectionList.Azdd.length) {
        this.getSelectOption('Azdd');
      }
    },
    // 燃气表操作
    gasOption(type, row) {
      if (this.$driver.isActivated) {
        return;
      }
      switch (type) {
        case 'add':
          this.gasStatus = 'add';
          this.gasState = true;
          break;
        case 'edit':
          this.gasStatus = 'edit';
          this.gasModel = { ...row };
          // 将/转为空字符串
          for (let key in this.gasModel) {
            if (this.gasModel[key] == '/') {
              this.gasModel[key] = '';
            }
          }
          if (this.gasModel.Lzsyrq) {
            // 编辑时将日期字符串转为date格式
            this.gasModel.Lzsyrq = new Date(this.gasModel.Lzsyrq);
          }
          // 初始化Lzsyfs
          if (!this.gasModel.Lzsyfs) {
            this.gasModel.Lzsyfs = '0';
          }
          // 如果下拉项已被删除 则置空值
          if (!this.selectionList.Qjlx.some((item) => { return item.ParamVal == row.Qjlx })) {
            this.gasModel.Qjlx = null;
          }
          if (!this.selectionList.Xhgg.some((item) => { return item.ParamVal == row.Xhgg })) {
            this.gasModel.Xhgg = null;
          }
          if (!this.selectionList.Sccjtyshxydm.some((item) => { return item.ParamVal == row.Sccjtyshxydm })) {
            this.gasModel.Sccjtyshxydm = null;
          }
          if (!this.selectionList.Sccj.some((item) => { return item.ParamVal == row.Sccj })) {
            this.gasModel.Sccj = null;
          }
          if (!this.selectionList.Sydw.some((item) => { return item.ParamVal == row.Sydw })) {
            this.gasModel.Sydw = null;
          }
          if (!this.selectionList.Sydwtyshxydm.some((item) => { return item.ParamVal == row.Sydwtyshxydm })) {
            this.gasModel.Sydwtyshxydm = null;
          }
          if (!this.selectionList.Gqdw.some((item) => { return item.ParamVal == row.Gqdw })) {
            this.gasModel.Gqdw = null;
          }
          if (!this.selectionList.Lzsyjg.some((item) => { return item.ParamVal == row.Lzsyjg })) {
            this.gasModel.Lzsyjg = null;
          }
          if (!this.selectionList.Azdd.some((item) => { return item.ParamVal == row.Azdd })) {
            this.gasModel.Azdd = null;
          }
          this.gasState = true;
          break;
        case 'del':
          this.$Modal.confirm({
            title: this.$t('smartCity.Home.943046-430'),
            content: `<p>是否删除"${row.Qjmc}"</p>`,
            onOk: () => {
              this.DelGasUserReport(row);
            },
            onCancel: () => { }
          });
          break;
      }
    },
    resetGasModel() {
      this.gasModel = {
        Xsfs: '0',
        Lzsyfs: '0'
      }
    },
    formatGasModel() {
      // 如果是非数显
      if (this.gasModel.Xsfs == '0') {
        this.gasModel.Xhgg = "/";
        this.gasModel.Xhgg = "/";
        this.gasModel.Ccbh = "/";
        this.gasModel.Sccjtyshxydm = "/";
        this.gasModel.Sccj = "/";
        this.gasModel.Xspzzsh = "/";
        this.gasModel.Azdd = "/";
        this.gasModel.Lzsyfs = "/";
        this.gasModel.Lzsyjg = "/";
        this.gasModel.Lzsyrq = "/";
        this.gasModel.Zsbh = "/";
        this.gasModel.Jlxnfhx = "/";
      } else {
        // 如果量值溯源方式为无
        if (this.gasModel.Lzsyfs == '0') {
          this.gasModel.Lzsyjg = "/";
          this.gasModel.Lzsyrq = "/";
          this.gasModel.Zsbh = "/";
          this.gasModel.Jlxnfhx = "/";
        }
      }
    },
    // 删除自定义下拉项
    DelGasUserReport(row) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/User/DelGasUserReport`,
        //假设后台需要的是表单数据这里你就可以更改
        params: {
          Id: row.Id
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.getGasList();
        }
      });
    },
    // 编辑燃气填报
    UpdateGasUserReport() {
      this.formatGasModel();
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: `api/User/UpdateGasUserReport`,
        //假设后台需要的是表单数据这里你就可以更改
        data: {
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode,
          ...this.gasModel
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.getGasList();
          this.gasState = false;
          this.resetGasModel();
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 新增燃气填报
    AddGasUserReport() {
      this.formatGasModel();
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: `api/User/AddGasUserReport`,
        //假设后台需要的是表单数据这里你就可以更改
        data: {
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode,
          ...this.gasModel
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.getGasList();
          this.gasState = false;
          this.resetGasModel();
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 燃气确认
    gasComfirm() {
      console.log(this.gasModel);
      console.log(this.$refs['gasForm']);
      this.$refs['gasForm'].validate((valid) => {
        if (valid) {
          if (this.gasStatus == 'add') {
            this.AddGasUserReport();
          } else {
            this.UpdateGasUserReport();
          }
        } else {
          this.$Message.error(this.$t('smartCity.Home.943046-432'));
        }
      })
    },
    // 下拉框右侧加号点击事件
    showSelectionPopup(ParamType, title) {
      this.selectionTitle = title;
      this.addSelectionModel.ParamType = ParamType;
      this.selectionState = true;
    },
    closeSelectionPopup() {
      this.addSelectionModel.ParamName = '';
      this.getSelectOption(this.addSelectionModel.ParamType);
      this.selectionState = false
    },
    // 获取下拉选项
    getSelectOption(ParamType) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/User/GetRosh_GasUseReportParamModels`,
        //假设后台需要的是表单数据这里你就可以更改
        params: {
          ParamType,
          pageIndex: 1,
          pageSize: 100
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.selectionList[ParamType] = res.Data || [];
        }
      });
    },
    // 删除自定义下拉项
    delSelectOption(item) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/User/DelGasUserReportParam`,
        //假设后台需要的是表单数据这里你就可以更改
        params: {
          Id: item.Id
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.getSelectOption(item.ParamType);
        }
      });
    },
    // 编辑自定义下拉项
    editSelectOption(item) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: `api/User/UpdateGasUserReportParam`,
        //假设后台需要的是表单数据这里你就可以更改
        data: {
          Id: item.Id,
          ParamName: item.ParamName,
          ParamType: item.ParamType
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.getSelectOption(item.ParamType);
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 新增自定义下拉项
    addSelectOption() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: `api/User/AddGasUseReportParam`,
        //假设后台需要的是表单数据这里你就可以更改
        data: {
          ...this.addSelectionModel
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.getSelectOption(this.addSelectionModel.ParamType);
          this.addSelectionModel.ParamName = '';
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 分页获取 在用燃气报警器填报
    getGasList() {
      const { GroupCode, DepartmentCode, CompanyCode, IsAdmin } = JSON.parse(
        Cookies.get("AdminData")
      );
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: `api/User/GetRosh_GasUseReportModelsV2`,
        //假设后台需要的是表单数据这里你就可以更改
        data: {
          groupCode: GroupCode,
          companyCode: CompanyCode,
          departmentCode: DepartmentCode,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode,
          pageIndex: this.gasPage.pageIndex,
          pageSize: this.gasPage.pageSize,
          ...this.gasQueryModel
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.gasList = res.Data || [];
          this.gasPage.TotalCount = res.TotalCount;
        }
      });
    },
    // 获取乡镇参数
    getThreeLevelList(item) {
      // 选中2级
      if (item.Id != this.selectedVillage.Id) {
        this.setVillage(item);
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/User/GetSVillageList?Vcode=${item.Vcode}`,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.threeLevelList = res.Data || [];
          this.level = 3;
        }
      });
    },
    // 获取村列表
    getFourLevelList(item) {
      // 选中3级
      if (item.Id != this.selectedThreeLevel.Id) {
        this.setThreeLevel(item);
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/User/GetZVillageList?Scode=${item.Scode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.fourLevelList = res.Data || [];
          this.level = 4;
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    handleView(item) {
      this.selectedDevicePic = item.FileUrl;
      this.devicePicState = true;
    },
    handleSuccess(res, file, fileList) {
      this.$Message['success']({
        background: true,
        content: res.Message
      });
      this.GetUserDevicePhotos();
    },
    openEdit() {
      this.editDeviceState = true;
      this.moreStatu = false;
      this.GetUserDevicePhotos();
    },
    GetUserDevicePhotos() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/GetUserDevicePhotos`,
        params: {
          userDeviceId: 0,
          deviceCode: this.selectedRow.DeviceCode
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.uploadList = res.Data;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    handleRemove(item) {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/DeleteUserDevicePhoto`,
        params: {
          Id: item.Id,
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
          _this.GetUserDevicePhotos();
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    getHeaders() {
      return {
        "Authorization": Cookies.get('Token')
      }
    },
    // 返回设备开关状态图片
    getOnlineImg(item) {
      if (item.IsOnline) {
        return require('@/assets/newHome/village/online.png');
      } else {
        return require('@/assets/newHome/village/offline.png');
      }
    },
    // 返回设备开关状态图片
    getSwitchImg(item) {
      if (this.DeviceIdToStr(item.DeviceId, item.DeviceItemId) != this.$t('smartCity.Home.943046-53')) {
        return null;
      } else {
        if (item.IsOnline) {
          if (item.SwitchStatus == 1) {
            return require('@/assets/newHome/village/online-on.png');
          } else {
            return require('@/assets/newHome/village/online-off.png');
          }
        } else {
          if (item.SwitchStatus == 1) {
            return require('@/assets/newHome/village/offline-on.png');
          } else {
            return require('@/assets/newHome/village/offline-off.png');
          }
        }
      }
    },
    // 返回设备图片
    getDeviceImg(item) {
      if (this.DeviceIdToStr(item.DeviceId, item.DeviceItemId) != this.$t('smartCity.Home.943046-53')) {
        return item.DeviceImg;
      } else {
        switch (item.DeviceP) {
          case "1P":
          case "2P":
            if (item.SwitchStatus == 1) {
              return require('@/assets/newHome/village/on-2p.png');
            } else {
              return require('@/assets/newHome/village/off-2p.png');
            }
            break;
          case "3P":
            if (item.SwitchStatus == 1) {
              return require('@/assets/newHome/village/on-3p.png');
            } else {
              return require('@/assets/newHome/village/off-3p.png');
            }
            break;
          case "4P":
            if (item.SwitchStatus == 1) {
              return require('@/assets/newHome/village/on-4p.png');
            } else {
              return require('@/assets/newHome/village/off-4p.png');
            }
            break;
        }
      }
    },
    // 删除设备
    DelDevice() {
      let _this = this;
      let data = {
        DeviceCodeList: [this.selectedRow.DeviceCode]
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/YhjDevice/DeleteUserDevice',
        data: data,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
          _this.getUserDevice();
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 编辑设备
    EditDevice() {
      let _this = this;
      this.selectedRow.UserId = this.selectedRow.User_Id
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/YhjDevice/UpdateUserDevice',
        data: this.selectedRow,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
          _this.getUserDevice();
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 检定证书有效期
    JdzsyxqChange(date) {
      this.userModel.Jdzsyxq_start = date[0];
      this.userModel.Jdzsyxq_end = date[1];
    },
    // 删除用户
    removeClick(row) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: 'api/User/DeleteRoshRoom',
        data: { ...row },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        if (res.Success) {
          this.$Message["success"]({
            background: true,
            content: res.Message,
          });
          this.GetRoshRoomAll();
        } else {
          this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    },
    // 编辑用户
    EditRoshRoom() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: "api/User/EditRoshRoom",
        data: { ...this.userModel },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        this.shows = false;
        if (res.Success) {
          this.$Message["success"]({
            background: true,
            content: res.Message,
          });
          this.GetRoshRoomAll();
        } else {
          this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    },
    // 设备表操作
    deviceOption(type, row, e) {
      if (this.$driver.isActivated) {
        return;
      }
      this.selectedRow = { ...row };
      switch (type) {
        case 1:
          this.logType = type;
          this.openPopup(7, this.$t('smartCity.Home.943046-434'));
          break;
        case 2:
          this.logType = type;
          this.openPopup(8, this.$t('smartCity.Home.943046-337'));
          break;
        case 3:
          this.logType = type;
          this.openPopup(9, this.$t('smartCity.Home.943046-435'));
          break;
        case 4:
          this.moreSpin = true;
          this.more(row, e);
      }
    },
    // 用户表操作
    userOption(type, row) {
      if (this.$driver.isActivated) {
        return;
      }
      switch (type) {
        case 'showPics':
          this.picRow = row;
          this.showPics();
          break;
        case 'edit':
          this.userModel = { ...row };
          this.Jdzsyxq = [row.Jdzsyxq_start, row.Jdzsyxq_end];
          this.editState = true;

          let map = this.areaMap;
          let th = this;
          //建立一个自动完成的对象
          this.$nextTick(() => {
            let ac = new BMap.Autocomplete({
              input: "suggestId",
              location: map
            });

            let myValue;
            //鼠标点击下拉列表后的事件
            ac.addEventListener("onconfirm", function (e) {
              let _value = e.item.value;
              myValue =
                _value.province +
                _value.city +
                _value.district +
                _value.street +
                _value.business;
              this.address_detail = myValue;
              setPlace();
            });

            function setPlace() {
              function myFun() {
                //获取第一个智能搜索的结果
                let userlocation = local.getResults().getPoi(0).point;
                th.userModel.Jd = userlocation.lng;
                th.userModel.Wd = userlocation.lat;
                // console.log(local.getResults());
                // th.userModel.RoomAddress = local.getResults().getPoi(0).title;
                th.userModel.RoomAddress = local.getResults().keyword;
              }
              //智能搜索
              var local = new BMap.LocalSearch(map, {
                onSearchComplete: myFun
              });
              local.search(myValue);
            }
          })
          break;
        case 'del':
          this.$Modal.confirm({
            title: this.$t('smartCity.Home.943046-430'),
            content: `<p>是否删除"${row.OwnerName}"</p>`,
            onOk: () => {
              this.removeClick(row)
            },
            onCancel: () => { }
          });
          break;
      }
    },
    selectPic(item, index) {
      this.selectedPicIndex = index;
      this.picState = true;
    },
    showPics() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: 'api/User/GetUserFiles',
        params: {
          roomCode: this.picRow.RoomCode,
          pageIndex: this.picPageIndex,
          pageSize: this.picPageSize
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.picList = res.Data;
          this.picsTotal = res.TotalCount;
          this.openPopup(10, this.$t('smartCity.Home.943046-70'));
        }
      })
    },
    nextImg() {
      if (this.selectedPicIndex < this.picList.length - 1) {
        this.selectedPicIndex++;
      }
    },
    preImg() {
      if (this.selectedPicIndex > 0) {
        console.log('-');
        this.selectedPicIndex--;
      }
    },
    // 获取modbus v3 时钟，时钟设置时候显示
    GetSZ_ModbusV3(DeviceCode) {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/GetSZ_ModbusV3?deviceCode=${DeviceCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.ReplyTime = res.Data.ReplyTime;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    // 设置modbus v3 时钟
    SetSZ_ModbusV3() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/SetSZ_ModbusV3?deviceCode=${_this.selectedRow.DeviceCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
          setTimeout(() => {
            _this.GetSZ_ModbusV3(_this.selectedRow.DeviceCode);
          }, 2000);
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    // 读取时钟
    DeviceRWByTypeModbusV3() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/DeviceRWByType?deviceCode=${_this.selectedRow.DeviceCode}&zcType=28`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
          setTimeout(() => {
            _this.GetSZ_ModbusV3(_this.selectedRow.DeviceCode);
          }, 2000);
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    // 获取传感器探头
    GetQtcgqTtItemList(DeviceCode) {
      let _this = this;
      this.openPopup(11, _this.$t('smartCity.Home.943046-436'));
      this.moreStatu = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/GetQtcgqTtItemList?deviceCode=${DeviceCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.qtcgqTtItemMsg = true;
        if (res.Success) {
          _this.qtcgqTtItemLists = res.Data;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    GetPassWord() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: 'api/User/GetPassWord',
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then(function (res) {
        if (res.Success) {
          // Code：0 不存在操作密码，Code：1 存在操作密码
          if (res.Code > 0) {
            _this.passWordIndex = true;
          } else {
            _this.passWordIndex = false;
          }
        } else {
          if (res.Code == -9) {
            if (window.location.host == 'xed.hxpwr.com') {
              this.$router.push({
                name: 'xed_login'
              })
            } else {
              this.$router.push({
                name: 'login'
              })
            }
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        }
      }).catch(function (err) {
        if (err.data.Code == -9 || err.data.Code == -1) {
          _this.$store.dispatch("setUserState", true);
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
        }
      });
    },
    // 验证密码
    VerifyPassword(type) {
      let _this = this;
      if (!_this.saveState) {
        return;
      }
      // 存在操作密码
      if (this.passWordIndex) {
        this.$Modal.confirm({
          title: _this.$t('smartCity.Home.943046-437'),
          render: (h) => {
            return h('Input', {
              props: {
                value: this.operatPassword,
                autofocus: true,
                placeholder: _this.$t('smartCity.Home.943046-438')
              },
              on: {
                input: (val) => {
                  this.operatPassword = val;
                }
              }
            })
          },
          onOk: () => {
            // 检查密码是否一致
            this.getVerifyPassword(type)
          },
          onCancel: () => {
            this.operatPassword = '';
          }
        })
      } else {
        if (type == 1) {
          // 分合闸（yhj）
          _this.SaveDeviceKGStatus();
        } else if (type == 2) {
          // 关阀
          _this.CloseRanQiDianCiFa();
        }
      }
    },
    // 检查密码是否一致
    getVerifyPassword(type) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/User/VerifyPassword',
        data: {
          password: this.operatPassword
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          // 分合闸（yhj）
          if (type == 1) {
            this.SaveDeviceKGStatus();
          } else if (type == 2) {
            this.CloseRanQiDianCiFa();
          }
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
        this.operatPassword = '';
      });
    },
    // 修改操作密码
    EditPassWord() {
      let _this = this;
      if (!_this.formPassWord.OldPassword) {
        _this.$Message['error']({
          background: true,
          content: this.$t('smartCity.Home.943046-439')
        });
        return;
      }
      if (!_this.formPassWord.NewPassword) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-440')
        });
        return;
      }
      if (!_this.formPassWord.ConfirmPassword) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-441')
        });
        return;
      }
      if (_this.formPassWord.NewPassword != _this.formPassWord.ConfirmPassword) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-442')
        });
        return;
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/User/UpdatePassWord',
        data: _this.formPassWord,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then(function (res) {
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: _this.$t('smartCity.Home.943046-443')
          });
          _this.GetPassWord();
          _this.formPassWord = {};
          _this.passWordState = false;
        } else {
          if (res.Code == -9) {
            if (window.location.host == 'xed.hxpwr.com') {
              this.$router.push({
                name: 'xed_login'
              })
            } else {
              this.$router.push({
                name: 'login'
              })
            }
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        }
      }).catch(function (err) {
        if (err.data.Code == -9 || err.data.Code == -1) {
          _this.$store.dispatch("setUserState", true);
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
        }
      });
    },
    // 分合闸（yhj）
    SaveDeviceKGStatus() {
      let _this = this;
      if (_this.operatMsg) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-444')
        });
        return;
      }
      let data = {
        Id: _this.selectedRow.Id,
        SwitchStatus: _this.selectedRow.SwitchStatus == 2 ? 1 : 2,
      }
      _this.spinMsg = true;
      _this.spinTitle = _this.$t('smartCity.Home.943046-445');
      _this.saveState = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/YhjDevice/SaveDeviceKGStatus',
        data: data,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        _this.saveState = true;
        _this.moreStatu = false;
        if (res.Success) {
          // 分合闸成功后记录下召测的设备id及type 用于websocket
          _this.wsDeviceId = _this.selectedRow.DeviceCode;
          _this.wsType = 2;
          // _this.getUserDevice();
          _this.$Notice.success({
            title: _this.$t('smartCity.Home.943046-430'),
            desc: res.Message
          });
          _this.operatMsg = true;
          setTimeout(() => {
            _this.operatMsg = false;
          }, 7000);
        } else {
          _this.$Notice.error({
            title: _this.$t('smartCity.Home.943046-430'),
            desc: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Notice.error({
          title: _this.$t('smartCity.Home.943046-433'),
          desc: res.Message
        });
      });
    },
    // 召测（yhj）
    InitDeviceRead(DeviceCode, Id) {
      let _this = this;
      this.moreStatu = false;
      if (_this.operatMsg) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-444')
        });
        return;
      }
      if (!_this.callState) {
        return;
      }
      _this.spinMsg = true;
      _this.spinTitle = _this.$t('smartCity.Home.943046-446');
      _this.callState = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: 'api/YhjDevice/InitDeviceRead?deviceCode=' + DeviceCode,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.callState = true;
        _this.spinMsg = false;
        _this.spinTitle = '';
        if (res.Success) {
          if (res.Code === 0) {
            // 召测成功后记录下召测的设备id及type 用于websocket
            _this.wsDeviceId = DeviceCode;
            _this.wsType = 4;
            _this.$Notice.success({
              title: _this.$t('smartCity.Home.943046-430'),
              desc: res.Message
            });
            // _this.getUserDevice();
          } else {
            _this.$Notice.error({
              title: _this.$t('smartCity.Home.943046-430'),
              desc: res.Message
            });
          }
          _this.operatMsg = true;
          setTimeout(() => {
            _this.operatMsg = false;
          }, 7000);
        } else {
          _this.callState = true;
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 烟感设备消音（yhj）
    Device_YanGan_Silence() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/Device_YanGan_Silence?deviceCode=${_this.selectedRow.DeviceCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 关闭燃气电磁阀/切断阀
    CloseRanQiDianCiFa() {
      let _this = this;
      if (_this.operatMsg) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-444')
        });
        return;
      }
      _this.spinMsg = true;
      _this.spinTitle = _this.$t('smartCity.Home.943046-445');
      _this.saveState = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: 'api/YhjDevice/CloseRanQiDianCiFa?deviceCode=' + _this.selectedRow.DeviceCode,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        _this.saveState = true;
        _this.moreStatu = false;
        if (res.Success) {
          _this.getUserDevice();
          _this.$Notice.success({
            title: _this.$t('smartCity.Home.943046-430'),
            desc: res.Message
          });
          _this.operatMsg = true;
          setTimeout(() => {
            _this.operatMsg = false;
          }, 7000);
        } else {
          _this.$Notice.error({
            title: _this.$t('smartCity.Home.943046-430'),
            desc: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Notice.error({
          title: _this.$t('smartCity.Home.943046-433'),
          desc: res.Message
        });
      });
    },
    // 隐藏更多按钮显示的弹框
    cancelMore() {
      if (this.moreStatu) {
        this.moreStatu = false;
      }
    },
    // 设备获取按钮列表
    GetDeviceBtn(btnType) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: 'api/Device/GetDeviceBtn?btnType=' + btnType,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then((res) => {
        if (res.Success) {
          this.DeviceBtns = [];
          res.Data.forEach(item => {
            this.DeviceBtns.push(item.BtonEnName);
          })
          this.moreSpin = false;
          // if (btnType != 4) {
          // 	if (_this.DeviceBtns.indexOf('state') >= 0) {
          // 		_this.navDeviceTab(1)
          // 	} else {
          // 		_this.navDeviceTab(2)
          // 	}
          // }
        }
      })
    },
    more(row, e) {
      this.moreX = e.x - 340 + 15 + 3; // 容器宽度 + 三角形一半宽度 + 三角形位置调整
      this.moreY = e.y + 15;
      this.moreStatu = true;
      let btnType = this.DeviceIdToStr(row.DeviceId, row.DeviceItemId);
      if (btnType == _this.$t('smartCity.Home.943046-53')) {
        this.GetDeviceBtn(1);
      } else if (btnType == _this.$t('smartCity.Home.943046-57')) {
        this.GetDeviceBtn(2);
      } else if (btnType == _this.$t('smartCity.Home.943046-55')) {
        this.GetDeviceBtn(3);
      } else if (btnType == _this.$t('smartCity.Home.943046-60')) {
        this.GetDeviceBtn(5);
      } else {
        this.DeviceBtns = ['edit', 'del'];
        this.moreSpin = false;
      }
    },
    // 时间转换
    formDate(dateForm) {
      // console.log({dateForm});
      if (dateForm == '/') {
        return "/";
      } else {
        var dateee = new Date(dateForm).toJSON();
        var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
          /\.[\d]{3}Z/, '');
        // console.log(date);
        return date;
      }
    },
    formDateNew(date) {
      if (date) {
        let str = date.replace(/-/g, '/');
        return str.slice(0, 11);
      } else {
        return ''
      }
    },
    // 重置数据
    reset() {
      this.addFormItem = {
        Rq1_1: '',
        ZiJian_1: -1,
        XiaoYin_1: -1,
        DianYuan_1: -1,
        XunJian_1: -1,
        Bjsbyxqk_1: -1,
        Ldsbyxqk_1: -1,
        BjbwyyClqk_1: '',
        Zbr_1: ''
      }
      this.addFormItem2 = {
        Rq2_2: '',
        Tcqxh_2: '',
        Xcdzzjl_2: -1,
        Clyj_2: -1,
        Djr_2: ''
      }
      this.addFormItem3 = {
        Rq3_3: '',
        Sbzl_3: '',
        Jcsynr_3: '',
        Jcsyjg_3: '',
        Yqzj_3: '',
        Gz_3: '',
        Pcqk_3: '',
        Bz_3: '',
        Jcr_3: ''
      }
    },
    // 检查记录表格操作
    tableAction(actionType, row) {
      if (actionType == 'add') {
        this.addState = true;
        this.actionType = this.$t('smartCity.Home.943046-79');
      } else if (actionType == 'edit') {
        this.addState = true;
        this.actionType = this.$t('smartCity.Home.943046-71');
        if (this.logType == 1) {
          this.addFormItem.Id = row.Id;
          this.addFormItem.Rq1_1 = new Date(row.Rq1_1);
          this.addFormItem.ZiJian_1 = row.ZiJian_1;
          this.addFormItem.XiaoYin_1 = row.XiaoYin_1;
          this.addFormItem.DianYuan_1 = row.DianYuan_1;
          this.addFormItem.XunJian_1 = row.XunJian_1;
          this.addFormItem.Bjsbyxqk_1 = row.Bjsbyxqk_1;
          this.addFormItem.Ldsbyxqk_1 = row.Ldsbyxqk_1;
          this.addFormItem.BjbwyyClqk_1 = row.BjbwyyClqk_1;
          this.addFormItem.Zbr_1 = row.Zbr_1;
        } else if (this.logType == 2) {
          this.addFormItem2.Id = row.Id;
          this.addFormItem2.Rq2_2 = new Date(row.Rq2_2);
          this.addFormItem2.Tcqxh_2 = row.Tcqxh_2;
          this.addFormItem2.Xcdzzjl_2 = row.Xcdzzjl_2;
          this.addFormItem2.Clyj_2 = row.Clyj_2;
          this.addFormItem2.Djr_2 = row.Djr_2;
        } else if (this.logType == 3) {
          this.addFormItem3.Id = row.Id;
          this.addFormItem3.Rq3_3 = new Date(row.Rq3_3);
          this.addFormItem3.Sbzl_3 = row.Sbzl_3;
          this.addFormItem3.Jcsynr_3 = row.Jcsynr_3;
          this.addFormItem3.Jcsyjg_3 = row.Jcsyjg_3;
          this.addFormItem3.Yqzj_3 = row.Yqzj_3;
          this.addFormItem3.Gz_3 = row.Gz_3;
          this.addFormItem3.Pcqk_3 = row.Pcqk_3;
          this.addFormItem3.Bz_3 = row.Bz_3;
          this.addFormItem3.Jcr_3 = row.Jcr_3;
        }
      } else if (actionType == 'del') {
        this.DelUserGasCheckLogs();
      }
    },
    // 检查记录选择事件
    logSelect(selection) {
      let tempArr = [];
      selection.map((item) => {
        tempArr.push(item.Id);
      });
      this.idList = tempArr;
    },
    // 删除检查记录
    DelUserGasCheckLogs() {
      let AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: 'post',
        url: 'api/CommElecDevice/DelUserGasCheckLogs',
        data: this.idList,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj')
        .then((res) => {
          if (res.Success) {
            this.$Message['success']({
              background: true,
              content: res.Message
            });
            this.GetUserGasCheckLogs();
          }
        })
    },
    // 表单提交必填项检查
    handleSubmit(name) {
      console.log(this.$refs[name]);
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          this.$Message.error(this.$t('smartCity.Home.943046-447'));
        }
      })
    },
    // 新增、编辑检查记录
    addSubmit() {
      let AdminData = JSON.parse(Cookies.get('AdminData'));
      let formItem;
      if (this.logType == 1) {
        this.addFormItem.Rq1_1 = this.formDate(this.addFormItem.Rq1_1);
        formItem = this.addFormItem;
      } else if (this.logType == 2) {
        this.addFormItem2.Rq2_2 = this.formDate(this.addFormItem2.Rq2_2);
        formItem = this.addFormItem2;
      } else if (this.logType == 3) {
        this.addFormItem3.Rq3_3 = this.formDate(this.addFormItem3.Rq3_3);
        formItem = this.addFormItem3;
      }
      console.log({ formItem });
      api({
        method: 'post',
        url: 'api/CommElecDevice/SaveUserGasCheckLogs',
        data: {
          GroupCode: AdminData.GroupCode,
          CompanyCode: AdminData.CompanyCode,
          DepartmentCode: AdminData.DepartmentCode,
          LogType: this.logType,
          RoomCode: this.selectedRow.RoomNo,
          SN: this.selectedRow.DeviceCode,
          Status: 1,
          ...formItem
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj')
        .then((res) => {
          if (res.Success) {
            this.$Message['success']({
              background: true,
              content: res.Message
            });
            this.addState = false;
            this.GetUserGasCheckLogs();
            this.reset();
          }
        })
    },
    // 获取城镇燃气报警控制系统日常维护检查记录
    GetUserGasCheckLogs() {
      let AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: 'get',
        url: 'api/CommElecDevice/GetUserGasCheckLogs',
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          logType: this.logType,
          roomCode: this.selectedRow.RoomNo,
          deviceCode: this.selectedRow.DeviceCode,
          pageIndex: this.logPageIndex,
          pageSize: 6,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj')
        .then((res) => {
          if (res.Success) {
            this.UserGasCheckLogs = res.Data;
            this.logsTotal = res.TotalCount;
          }
        })
    },
    // 获取Zigbee设备状态
    DeviceParameterLook_Zigbee() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/YhjDevice/DeviceParameterLook_Zigbee',
        data: {
          deviceCode: this.selectedDevice.DeviceCode
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.GetUserDeviceParamList = res.Data;
          if (!res.Data.ZbDeviceModel.DeviceInfoBaseModel) {
            _this.DeviceInfoBaseModel = {};
          } else {
            _this.DeviceInfoBaseModel = res.Data.ZbDeviceModel.DeviceInfoBaseModel;
          }
          // _this.ZbDeviceModel = res.Data.ZbDeviceModel;
          if (!res.Data.ZbDeviceModel.DeviceDianCiModel) {
            _this.DeviceDianCiModel = {};
          } else {
            _this.DeviceDianCiModel = res.Data.ZbDeviceModel.DeviceDianCiModel;
          }
          // _this.DeviceDetails.UpdateTime = res.Data.ZbDeviceModel.UpdateTime
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 获取设备状态（yhj）
    DeviceParameterLook() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/YhjDevice/DeviceParameterLook',
        data: {
          deviceCode: this.selectedDevice.DeviceCode
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.DeviceParameterLookLists = (res.Data || []);
        } else {
          _this.DeviceParameterLookLists = [];
          // _this.$Message['error']({
          // 	background: true,
          // 	content: res.Message
          // });
        }
      }).catch(function (err) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 获取能耗分时统计数据
    getNnegHaoTongJiByDate() {
      api({
        method: 'get',
        url: 'api/YhjStatic/GetNnegHaoTongJiByDate',
        params: {
          deviceCode: this.selectedDevice.DeviceCode
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj')
        .then((res) => {
          this.byDateOption.series[0].data = [];
          res.Data.map((item) => {
            this.byDateOption.series[0].data.push(item.Etotal);
          })
          let myChart = echarts.init(document.getElementById('tab5Chart'))
          myChart.setOption(this.byDateOption);
        })
    },
    // 点击设备表
    selectDevice(item) {
      if (item) {
        this.selectedDevice = item;
        this.AbnormalPage = 1;
        // 报警信息tab
        this.GetDeviceAbnormal();
        // 附属信息tab
        this.GetOneUserDeviceModel_Ext();
        // 实时值tab
        if (item.DeviceId == '7febbea4-0326-496d-9b71-5b058729cb42') {
          this.DeviceParameterLook_Zigbee();
        } else {
          this.DeviceParameterLook();
        }
        // 如果是微断设备
        if (item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab') {
          this.getNnegHaoTongJiByDate();
          this.getDeviceCheckDataABCxiang_T(this.checkCode);
          // 参数设置tab
          this.GetDeviceParameter();
        } else {
          if (this.tabValue == 'tab4' || this.tabValue == 'tab5' || this.tabValue == 'tab6') {
            this.tabValue = 'tab1'
          }
        }
      } else {
        this.selectedDevice = {};
        this.userEx = {};
        this.AbnormalList = [];
        this.AbnormalTotal = 0;
        this.DeviceParameterLookLists = [];
      }
    },
    GetDeviceParameter() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/GetDeviceParameter?deviceCode=${this.selectedDevice.DeviceCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          if (res.Data) {
            _this.formThreshold = res.Data;
          } else {
            _this.formThreshold = {};
          }
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 获取设备附属信息
    GetOneUserDeviceModel_Ext() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetOneUserDeviceModel_Ext`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          deviceCode: this.selectedDevice.DeviceCode
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.userEx = res.Data;
        }
      })
    },
    pstateChange(pstate) {
      if (this.pstate == pstate) {
        this.pstate = 0;
      } else {
        this.pstate = pstate;
      }
      this.GetDeviceAbnormal();
    },
    // 获取设备报警信息
    GetDeviceAbnormal() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${this.AbnormalPage}&pageSize=${this.AbnormalPageSize}&pstate=${this.pstate}&isAdmin=${AdminData.IsAdmin}&deviceCode=${this.selectedDevice.DeviceCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.AbnormalList = res.Data;
          _this.AbnormalTotal = res.TotalCount;
        }
      })
    },

    // 搜索设备
    deviceSearch(RunStatus) {
      this.deviceSearchForm.RunStatus = this.deviceSearchForm.RunStatus == RunStatus ? '' : RunStatus;
      this.devicePage = 1;
      this.getUserDevice();
    },

    deviceFormReset() {
      this.deviceSearchForm = {
        RunStatus: '',
        DeviceType: '',
        deviceName: '',
        deviceCode: '',
        onlineState: ''
      }
      this.devicePage = 1;
    },

    clear() {
      this.deviceFormReset();
      this.getUserDevice();
    },
    // 设备读写，根据召测类型（NB/集中器）
    DeviceRWByType(type = 0) {
      let _this = this;
      _this.spinMsg = true;
      _this.spinTitle = _this.$t('smartCity.Home.943046-445');
      let typeUrl = '';
      if (type != 0) {
        typeUrl = `&type=${type}`
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjDevice/DeviceRWByType?deviceCode=${_this.selectedDevice.DeviceCode}&zcType=23` +
          typeUrl,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
          setTimeout(() => {
            _this.GetDeviceParameter();
          }, 2000)
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 设置阈值判断
    setThreshold() {
      let _this = this;
      // 新协议
      // _this.SetDeviceParameter();
      // 配置阈值（yhj）
      _this.formThreshold.SN = _this.selectedDevice.DeviceCode;
      if (_this.selectedDevice.DeviceItemId == '0b4550c8-bbaa-43bb-9bf4-d8f6cd02766c') { // 集中器 V3
        _this.SetFZ_ModbusV3_2(); // 设置 modbus v3第2组参数
      } else {
        _this.EditDeviceParameterNew(); // 其它新协议设备
      }
    },
    // 设置 modbus v3第2组参数
    SetFZ_ModbusV3_2() {
      let _this = this;
      _this.spinMsg = true;
      _this.spinTitle = _this.$t('smartCity.Home.943046-445');
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: `api/YhjDevice/SetFZ_ModbusV3_2`,
        data: _this.formThreshold,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 其它新协议设备
    EditDeviceParameterNew() {
      let _this = this;
      _this.spinMsg = true;
      _this.spinTitle = _this.$t('smartCity.Home.943046-445');
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: `api/YhjDevice/EditDeviceParameterNew`,
        data: _this.formThreshold,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        if (res.Success) {
          _this.$Message['success']({
            background: true,
            content: res.Message
          });
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        _this.$Message['error']({
          background: true,
          content: _this.$t('smartCity.Home.943046-433')
        });
      });
    },
    // 获取用户设备表
    getUserDevice() {
      const { GroupCode, DepartmentCode, CompanyCode, IsAdmin } = JSON.parse(
        Cookies.get("AdminData")
      );
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `api/CommElecDevice/GetUserDevicesPageV2`,
          params: {
            groupCode: GroupCode,
            companyCode: CompanyCode,
            departmentCode: DepartmentCode,
            isAdmin: IsAdmin,
            pageIndex: this.devicePage,
            pageSize: this.devicePageSize,
            RoomCode: this.selectedUser.RoomCode,
            runStatus: this.deviceSearchForm.RunStatus,
            onlineState: this.deviceSearchForm.onlineState,
            deviceType: this.deviceSearchForm.DeviceType,
            deviceName: this.deviceSearchForm.deviceName,
            deviceCode: this.deviceSearchForm.deviceCode,
            Ccode: this.selectedArea.Ccode,
            Vcode: this.selectedVillage.Vcode,
            Scode: this.selectedThreeLevel.Scode,
            Zcode: this.selectedFourLevel.Zcode
          },
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token"),
          },
        },
        "yhj"
      )
        .then((res) => {
          if (res.Success) {
            let tempData = res.Data;
            tempData.forEach((item, index) => {
              if (this.devicePage == 1 && index == 0) {
                item._highlight = true;
              }
              // 是否报警
              if (item.IsHealth == 1) {
                item.cellClassName = {
                  IsHealth: 'statu0'
                }
              } else if (item.IsHealth == 2) {
                item.cellClassName = {
                  IsHealth: 'statu2'
                }
              }
              // 是否在线
              // if (!item.IsOnline) {
              //   item.cellClassName.IsHealth  = 'statu3'
              // }
            })
            this.userDeviceList = tempData;
            this.deviceTotal = res.TotalCount;
            this.selectDevice(tempData[0]);
          }
        })
        .finally(() => {
          this.spinMsg = false;
          this.spinTitle = '';
          this.loading = false;
        });
    },
    // 历史曲线 电压、电流、温度
    getDeviceCheckDataABCxiang_T(checkCode) {
      this.checkCode = checkCode;
      let startDt = new Date();
      startDt.setTime(startDt.getTime() - 3600 * 1000 * 24 * 1);
      let endDt = new Date();
      api({
        method: 'get',
        // url: `api/YhjStatic/GetDeviceCheckDataABCxiang?checkCode=${this.checkCode}&deviceCode=${this.selectedDevice.DeviceCode}&startDt=${startDt}&endDt=${endDt}`,
        url: `api/YhjStatic/GetDeviceCheckDataABCxiang`,
        params: {
          checkCode: this.checkCode,
          deviceCode: this.selectedDevice.DeviceCode,
          startDt,
          endDt
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        }
      }, 'yhj')
        .then((res) => {
          this.option.series[0].data = [];
          this.option.series[1].data = [];
          this.option.series[2].data = [];
          this.option.series[3].data = [];
          this.option.series[3].name = "";
          this.option.xAxis.data = [];
          switch (checkCode) {
            case "Axiangdianya":
              this.option.series[0].name = "A相电压(V)";
              this.option.series[1].name = "B相电压(V)";
              this.option.series[2].name = "C相电压(V)";
              break;
            case "Axiangdianliu":
              this.option.series[0].name = "A相电流(A)";
              this.option.series[1].name = "B相电流(A)";
              this.option.series[2].name = "C相电流(A)";
              break;
            case "Axiangwendu":
              this.option.series[0].name = "A相温度(℃)";
              this.option.series[1].name = "B相温度(℃)";
              this.option.series[2].name = "C相温度(℃)";
              break;
          }
          res.Data.listA.map((item) => {
            this.option.xAxis.data.push(item.CreateDate);
            this.option.series[0].data.push(item.CheckValue);
          })
          res.Data.listB.map((item) => {
            this.option.series[1].data.push(item.CheckValue);
          })
          res.Data.listC.map((item) => {
            this.option.series[2].data.push(item.CheckValue);
          })
          this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById('tab4Chart'))
            myChart.setOption(this.option);
          })
        })
    },
    // 历史曲线 有功功率、无功功率
    getDeviceCheckDataGL_T(checkCode) {
      this.checkCode = checkCode;
      let startDt = new Date();
      startDt.setTime(startDt.getTime() - 3600 * 1000 * 24 * 1);
      let endDt = new Date();
      api({
        method: 'get',
        url: `api/YhjStatic/GetDeviceCheckDataGL`,
        params: {
          checkCode: this.checkCode,
          deviceCode: this.selectedDevice.DeviceCode,
          startDt,
          endDt
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        }
      }, 'yhj')
        .then((res) => {
          this.option.series[0].data = [];
          this.option.series[1].data = [];
          this.option.series[2].data = [];
          this.option.series[3].data = [];
          this.option.series[3].name = "";
          this.option.xAxis.data = [];
          switch (checkCode) {
            case "yggl":
              this.option.series[0].name = "A相有功功率(W)";
              this.option.series[1].name = "B相有功功率(W)";
              this.option.series[2].name = "C相有功功率(W)";
              this.option.series[3].name = "总有功功率(W)";
              break;
            case "wggl":
              this.option.series[0].name = "A相无功功率(W)";
              this.option.series[1].name = "B相无功功率(W)";
              this.option.series[2].name = "C相无功功率(W)";
              this.option.series[3].name = "总无功功率(W)";
              break;
          }
          res.Data.listA.map((item) => {
            this.option.xAxis.data.push(item.CreateDate);
            this.option.series[0].data.push(item.CheckValue);
          })
          res.Data.listB.map((item) => {
            this.option.series[1].data.push(item.CheckValue);
          })
          res.Data.listC.map((item) => {
            this.option.series[2].data.push(item.CheckValue);
          })
          res.Data.listTotal.map((item) => {
            this.option.series[3].data.push(item.CheckValue);
          })
          this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById('tab4Chart'))
            myChart.setOption(this.option);
          })
        })
    },
    // 历史曲线 漏电
    getDeviceCheckDataV2_T(checkCode) {
      this.checkCode = checkCode;
      let startDt = new Date();
      // startDt.setTime(startDt.getTime() - 3600 * 1000 * 24 * 1);
      let endDt = new Date();
      api({
        method: 'get',
        url: `api/YhjStatic/GetDeviceCheckDatas`,
        params: {
          checkCode: this.checkCode,
          deviceCode: this.selectedDevice.DeviceCode,
          startDt,
          endDt
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        }
      }, 'yhj')
        .then((res) => {
          this.option.series[0].data = [];
          this.option.series[1].data = [];
          this.option.series[2].data = [];
          this.option.series[3].data = [];
          this.option.series[0].name = "漏电(mA)";
          this.option.series[1].name = "";
          this.option.series[2].name = "";
          this.option.series[3].name = "";
          this.option.xAxis.data = [];
          res.Data.map((item) => {
            this.option.xAxis.data.push(item.CreateDate);
            this.option.series[0].data.push(item.CheckValue);
          })
          this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById('tab4Chart'))
            myChart.setOption(this.option);
          })
        })
    },
    cellClick(row, column, data, event) {
      if (column.key == 'OwnerName') {
        this.selectedUser = row;
        this.isDetail = true;
        this.spinMsg = true;
        this.spinTitle = this.$t('smartCity.Home.943046-465');
        this.getUserDevice();
        if (this.$driver.isActivated) {
          this.$nextTick(() => {
            this.$driver.moveNext();
          })
        }
      }
    },
    // 首页表格行双击事件
    rowDbClick(row, type = 'next') {
      this.selectedUser = row;
      this.isDetail = true;
      this.spinMsg = true;
      this.spinTitle = this.$t('smartCity.Home.943046-465');
      this.getUserDevice();
      if (this.$driver.isActivated) {
        this.$nextTick(() => {
          if (type == 'next') {
            this.$driver.moveNext();
          } else {
            this.$driver.movePrevious();
          }
        })
      }
    },
    // 数字状态转文字
    statusToStr(status) {
      switch (status) {
        case "0":
          return this.$t('smartCity.Home.943046-61');
        case "1":
          return this.$t('smartCity.Home.943046-62');
        default:
          return this.$t('smartCity.Home.943046-61');
      }
    },
    IsHealthToStr(status, online) {
      if (status == 1) {
        return this.$t('smartCity.Home.943046-61');
      } else if (status == 2) {
        return this.$t('smartCity.Home.943046-62');
      }
    },
    DeviceIdToStr(id1, id2) {
      if (id1 == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857' || id2 == 'e4bf369a-44fe-4a9c-b764-5a2563d67865') {
        return this.$t('smartCity.Home.943046-55');
      } else if (id1 == '6ee95d23-a802-4bd8-b823-19c0944ac5ab') {
        return this.$t('smartCity.Home.943046-53');
      } else if (id2 == '5af29384-3a36-42b1-bde5-b950e375a598' || id2 == '2ae268bf-84ab-41ea-9940-a6b92c80a817') {
        return this.$t('smartCity.Home.943046-57')
      } else if (id2 == '2f6fa7d9-8dea-4157-98be-01dd8cdd3527') {
        return this.$t('smartCity.Home.943046-60')
      } else {
        return this.$t('smartCity.Home.943046-466')
      }
    },
    ProcessStatusToStr(status) {
      if (status == 1) {
        return this.$t('smartCity.Home.943046-120');
      } else if (status == 2) {
        return this.$t('smartCity.Home.943046-7');
      } else if (status == 3) {
        return this.$t('smartCity.Home.943046-121');
      }
    },
    // 切换首页
    switchIndex(type, flag) {
      console.log('type', type, flag)
      let _this = this;
      if (flag && type != 'DMapMode') {
        this.setHome(type);
      }
      if (type == 'newHome') {
        this.GetEchartAbData("new");
        this.GetDeviceZLData("new");
        this.getUserDevicesPageV2();
        this.GetDeviceAbnormalCountMonth();
        // 获取设备种类
        this.GetDeviceCatCount('all');
        this.$nextTick(function () {
          _this.initMap();
        });
      }
      if (type == 'default') {
        this.GetDeviceAbnormalCountMonth();
        this.GetDeviceCatCount('all');
        // 图表在线离线数据（yhj）
        _this.GetDeviceZLData();
        // 告警异常处理情况图表数据
        _this.GetEchartAbData();
        this.getUserDevicesPageV2();
        this.$nextTick(function () {
          _this.initMap();
        });
      }
      if (type == 'DMapMode') {
        _this.$router.push({
          name: 'homebak1'
        })
      }
    },
    // 切换模式
    switchMode(mode, type = 'next') {
      this.mode = mode;
      this.$nextTick(() => {
        if (this.$driver.isActivated) {
          if (type == 'next') {
            this.$driver.moveNext();
          } else {
            this.$driver.movePrevious();
          }
        } else {
          this.tableKey = new Date().getTime();
        }
      })

    },
    // 返回
    back(type = 'next') {
      if (this.isDetail) {
        this.isDetail = false;
        this.userDeviceList = [];
        this.selectedDevice = {};
        this.selectedUser = {};
        this.deviceFormReset();
        // 如果是从地图模式跳转过来的
        if (this.isFromMap) {
          this.mode = 'map';
          this.isFromMap = false;
        }
        if (this.$driver.isActivated) {
          this.$nextTick(() => {
            if (type == 'next') {
              this.$driver.moveNext();
            } else {
              this.$driver.movePrevious();
            }
          })
        }
      } else {
        // 移除重写的浏览器后退事件
        window.removeEventListener('popstate', this.reWriteBack);
        // 清除地图模式90s一次的上方数据更新定时器
        clearInterval(this.timer);
        this.showArea = true;
        this.mode = 'map';
        this.villageList = [];
        this.deviceCatCountList = [];
        this.userFormReset();
        // 防止智慧用电 安全用气边框样式错乱
        this.$nextTick(() => {
          this.key1 = new Date().getTime();
          this.key2 = new Date().getTime();
        })
        this.level = 2;
        this.selectedArea = {};
        this.selectedVillage = {};
        this.selectedThreeLevel = {};
        this.selectedFourLevel = {};
        if (this.$driver.isActivated) {
          this.$nextTick(() => {
            this.$driver.movePrevious();
          })
        }
      }
    },

    // 最近报警已处理情况图表
    drawNewChart1(legends, series) {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart1'))
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          textStyle: {
            color: '#ffffff',
          },
          left: '10%',
          data: legends
        },
        series: [{
          name: _this.$t('smartCity.Home.943046-467'),
          type: 'pie',
          label: {
            formatter: '{b}: {c} ({d}%)'
          },
          radius: '50%',
          center: ['50%', '45%'],
          data: series,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      });
      // // 饼图点击跳转到指定页面
      // myChart.on('click', function(param) {
      //   _this.openPopup(3, param.name == _this.$t('smartCity.Home.943046-7') ? _this.$t('smartCity.Home.943046-8') : param.name == _this.$t('smartCity.Home.943046-120') ? _this.$t('smartCity.Home.943046-10') : _this.$t('smartCity.Home.943046-477'), param.name == _this.$t('smartCity.Home.943046-7') ? '2' : param.name == _this.$t('smartCity.Home.943046-120') ? '1' : '3')
      // });
    },

    // 设备状态图表
    drawNewChart2(series) {
      console.log('series',series)
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart2'))
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          textStyle: {
            color: '#ffffff',
          },
          right: '10%',
        },
        series: [{
          name: _this.$t('smartCity.Home.943046-21'),
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['50%', '50%'],
          label: {
            formatter: '{b}: {c} ({d}%)'
          },
          data: series
        }]
      });

      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },

    // 最近报警已处理情况图表
    drawNewChart3(legends) {
      let data = [{ value: this.GetNavDataYHJs.todayAbWeiSolve, name: this.$t('smartCity.Home.943046-468') }, { value: this.GetNavDataYHJs.todayAbSolve, name: this.$t('smartCity.Home.943046-469') }];
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart3'))
      myChart.setOption({
        color: ['#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          textStyle: {
            color: '#ffffff',
          },
          left: '10%',
        },
        series: [{
          name: _this.$t('smartCity.Home.943046-467'),
          type: 'pie',
          label: {
            formatter: '{b}: {c} ({d}%)'
          },
          radius: '50%',
          center: ['50%', '45%'],
          data: data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },

    // 设备种类图表
    drawNewChart4() {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart4'))
      myChart.setOption({
        color: ['#73c0de', '#ee6666', '#91cc75', '#fac858', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          bottom: 10,
          textStyle: {
            color: '#ffffff',
          },
          left: '5%',
          type: 'scroll',
          pageTextStyle: {
            color: '#FFF'
          }
        },
        series: [{
          name: this.$t('smartCity.Home.943046-470'),
          type: 'pie',
          label: {
            formatter: '{b}: {c} ({d}%)'
          },
          radius: '30%',
          center: ['53%', '45%'],
          data: _this.deviceCatCountListAll,
          // minShowLabelAngle: 1,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },

    // 最近7天每天的设备异常次数图表
    drawNewChart5(xData, yData) {
      let _this = this;
      let myChart = echarts.init(document.getElementById('newChart5'))
      myChart.setOption({
        color: ['#73c0de', '#ee6666', '#91cc75', '#fac858', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        grid: {
          bottom: '10%'
        },
        title: {
          text: this.$t('smartCity.Home.943046-471'),
          textStyle: {
            color: '#FFF'
          }
        },
        xAxis: {
          type: 'category',
          name: this.$t('smartCity.Home.943046-323'),
          data: xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#FFF'
            }
          }
        },
        yAxis: {
          name: this.$t('smartCity.Home.943046-472'),
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#FFF'
            }
          }
        },
        series: [{
          name: this.$t('smartCity.Home.943046-472'),
          type: 'line',
          data: yData,
          smooth: true
        }],
        tooltip: {
          trigger: 'axis',
          // axisPointer: {
          //   type: 'cross'
          // }
        }
      });
      window.addEventListener('resize', function () {
        if (_this.homeType == 'newHome' && _this.showArea) {
          myChart.resize();
        }
      })
    },

    goToUser(row) {
      this.spinMsg = true;
      this.spinTitle = this.$t('smartCity.Home.943046-465');
      this.popupState = false;
      this.mode = 'table';
      this.userSearchForm.UserId = row.Id;
      this.GetRoshRoomAll();
    },

    goToDevice(row) {
      if (this.homeType == 'newHome' && !this.showArea) {
        this.popupState = false;
        this.mode = 'table';
        this.isDetail = true;
        this.deviceSearchForm.deviceCode = row.DeviceCode;
        this.spinMsg = true;
        this.spinTitle = this.$t('smartCity.Home.943046-465');
        this.getUserDevice();
        this.isFromMap = true;
      }
    },

    userSearch(RunStatus) {
      this.userSearchForm.RunStatus = this.userSearchForm.RunStatus == RunStatus ? '' : RunStatus;
      this.UserPageIndex = 1;
      this.GetRoshRoomAll();
    },

    userFormReset() {
      this.userSearchForm = {
        RunStatus: '',
        OwnerName: '',
        UserId: null
      }
      this.UserPageIndex = 1;
      this.GetRoshRoomAll();
    },

    // 加载导航栏用户列表
    GetRoshRoomAll(type) {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      let data = {
        Status: 'A',
        GroupCode: AdminData.GroupCode,
        CompanyCode: AdminData.CompanyCode,
        DepartmentCode: AdminData.DepartmentCode,
        pageIndex: type == 'map' ? _this.pageIndex : _this.UserPageIndex,
        pageSize: type == 'map' ? _this.pageSize : _this.UserPageSize,
        Ccode: this.selectedArea.Ccode,
        Vcode: this.selectedVillage.Vcode,
        Scode: this.selectedThreeLevel.Scode,
        Zcode: this.selectedFourLevel.Zcode,
        OwnerName: type == 'map' ? null : this.userSearchForm.OwnerName,
        RunStatus: type == 'map' ? null : this.userSearchForm.RunStatus,
        Id: type == 'map' ? null : this.userSearchForm.UserId,
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/User/GetRoshRoomAll',
        data: data,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then(function (res) {
        _this.spinMsg = false;
        _this.spinTitle = '';
        if (res.Success) {
          let tempData = res.Data;
          // 如果是地图模式的用户列表
          if (type == 'map') {
            _this.mapGetRoshRoomAllLists = tempData;
            _this.mapUserTotalCount = res.TotalCount;
          } else {
            tempData.forEach((item) => {
              if (item.RunStatus == "0" || !item.RunStatus) {
                item.cellClassName = {
                  RunStatus: 'statu0'
                }
              } else if (item.RunStatus == "1") {
                item.cellClassName = {
                  RunStatus: 'statu2'
                }
              }
            })
            _this.GetRoshRoomAllLists = tempData;
            _this.UserTotalCount = res.TotalCount;
          }

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          })
        }
      }).catch(function (err) {

      });
    },

    picsPageChange(e) {
      this.picPageIndex = e;
      this.showPics();
    },

    picsPageSizeChange(e) {
      this.picPageIndex = 1;
      this.picPageSize = e;
      this.showPics();
    },

    logsPageChange(e) {
      this.logPageIndex = e;
      this.GetUserGasCheckLogs();
    },

    UserPageChange(e) {
      let _this = this;
      _this.UserPageIndex = e;
      _this.GetRoshRoomAll()
    },

    UserPageSizeChange(e) {
      let _this = this;
      _this.UserPageIndex = 1;
      _this.UserPageSize = e;
      _this.GetRoshRoomAll()
    },

    GasPageChange(e) {
      this.gasPage.pageIndex = e;
      this.getGasList();
    },

    GasPageSizeChange(e) {
      this.gasPage.pageIndex = 1;
      this.gasPage.pageSize = e;
      this.getGasList();
    },

    mapUserPageChange(e) {
      let _this = this;
      _this.pageIndex = e;
      _this.GetRoshRoomAll('map');
    },

    mapUserPageSizeChange(e) {
      let _this = this;
      _this.pageIndex = 1;
      _this.pageSize = e;
      _this.GetRoshRoomAll('map');
    },

    AlarmPageChange(e) {
      let _this = this;
      _this.pageIndex = e;
      _this.GetCurrRoomAbDevices();
    },

    AlarmPageSizeChange(e) {
      let _this = this;
      _this.pageIndex = 1;
      _this.pageSize = e;
      _this.GetCurrRoomAbDevices();
    },

    DevicePageChange(e) {
      this.devicePage = e;
      this.getUserDevice();
    },

    DevicePageSizeChange(e) {
      this.devicePage = 1;
      this.devicePageSize = e;
      this.getUserDevice();
    },

    AbnormalPageChange(e) {
      this.AbnormalPage = e;
      this.GetDeviceAbnormal();
    },

    // 加载城市列表
    GetRoshCommunityList(type = "") {
      api({
        method: "get",
        url: "api/User/GetCommunitylist",
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          this.areaList = res.Data
          this.$nextTick(() => {
            let height = this.$refs.con.clientHeight
            if (height > 100) {
              this.show = true
            }
          })
        }
      });
    },

    // 获取设备种类数量统计
    GetDeviceCatCount(flag) {
      if (!Cookies.get('AdminData')) {
        return;
      }
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: "get",
        url: `api/CommElecDevice/GetDeviceCatCount`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }, 'yhj').then(res => {
        if (flag == 'all') {
          this.deviceCatCountListAll = res
          _this.drawNewChart4();
        } else {
          let deviceCatCountList = [{ name: this.$t('smartCity.Home.943046-54'), value: 0 }, { name: this.$t('smartCity.Home.943046-56'), value: 0 }, { name: this.$t('smartCity.Home.943046-58'), value: 0 }, { name: this.$t('smartCity.Home.943046-60'), value: 0 }];
          res.map((item, index) => {
            if (item.name == this.$t('smartCity.Home.943046-54')) {
              deviceCatCountList[0].value = item.value;
            } else if (item.name == this.$t('smartCity.Home.943046-56')) {
              deviceCatCountList[1].value = item.value;
            } else if (item.name == this.$t('smartCity.Home.943046-58')) {
              deviceCatCountList[2].value = item.value;
            } else if (item.name == this.$t('smartCity.Home.943046-60')) {
              deviceCatCountList[3].value = item.value;
            }
          })
          this.deviceCatCountList = deviceCatCountList;
        }
      });
    },

    // 获取当月最近7天每天的设备异常次数
    GetDeviceAbnormalCountMonth() {
      if (!Cookies.get('AdminData')) {
        return;
      }
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        method: "get",
        url: `api/CommElecDevice/DeviceAbnormalCountMonth?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }, 'yhj').then(res => {
        this.deviceAbnormalCountList = res;
        let xData = [];
        let yData = [];
        res.map((item) => {
          xData.push(item.name);
          yData.push(item.value);
        })
        this.drawNewChart5(xData, yData);
        // this.drawNewChart7(xData, yData);
        // this.drawNewChart8(xData, yData);
      });
    },

    // 选择区域
    setArea(item) {
      let that = this;
      api({
        method: "get",
        url: `api/User/GetJwdByCityName?provinceName=${item.ProvinceName}&cityName=${item.CityName}`,
        data: {},
      }, 'ros').then(res => {
        let Data = res.Data
        let ind = Data.indexOf(',')
        let lng = Data.substring(0, ind) ? Data.substring(0, ind) : '120.39'
        let lat = Data.substring(ind + 1) ? Data.substring(ind + 1) : '28.01'
        that.selectedArea = item;
        let ls = new BMap.LocalSearch(this.map, {
          onSearchComplete: function (res) {
            let Jd = lng;
            let Wd = lat;
            that.point = new BMap.Point(Jd, Wd);
            that.initAreaMap(that.point, 11);
            that.getUserDevicesPageV2();
          }
        });
        ls.search(item.Cname);
        that.GetVillagelist(item); // 获取选择区域下的所有子区域
        that.showArea = false;
        that.mapSpin = true;
        that.GetNavDataYHJ('new');
        that.GetDeviceCatCount();
        that.GetRoshRoomAll();
        // 燃气表
        that.getGasList();
        // 新增燃气下拉选项
        that.getAllSelection();
        // 每90s更新一次地图模式上面一排的数据
        that.timer = setInterval(() => {
          console.log('setAreaTimer');
          that.GetNavDataYHJ('new');
        }, 90000);
        // 手动添加一层路由 防止后退至登录页
        that.pushHistory();
        window.addEventListener("popstate", that.reWriteBack);
        if (that.$driver.isActivated) {
          that.$nextTick(() => {
            that.$driver.moveNext();
          })
        }

      });






    },

    reWriteBack() {
      this.back();
    },

    pushHistory() {
      let state = {
        title: 'title',
        url: '#'
      };
      window.history.pushState(state, 'title', '#/');
    },

    getManyDatas(item, level) {

      // 地图模式最上面一排数据
      this.GetNavDataYHJ('new');
      // 地图模式最右边一列数据
      this.GetDeviceCatCount();
      // 用户表
      this.GetRoshRoomAll();
      // 燃气表
      this.getGasList();
      // 设置地图中心
      if (item.Jd && item.Wd) {
        this.point = new BMap.Point(item.Jd, item.Wd)
      } else {
        this.point = null
      }
      this.initAreaMap(this.point, level);
      // 获取设备 显示地图marker
      this.getUserDevicesPageV2();
    },

    preLevel() {
      if (this.level == 4) {
        this.selectedFourLevel = {};
        this.getManyDatas(this.selectedThreeLevel, 17);
      } else {
        this.selectedThreeLevel = {};
        this.getManyDatas(this.selectedVillage, 16);
      }
      this.level--;
    },

    // 选择村落
    setVillage(item) {
      // 如果是取消选择
      if (item.Id == this.selectedVillage.Id) {
        this.selectedVillage = {};
        this.getManyDatas(this.selectedArea, 11);
      } else {
        this.selectedVillage = item;
        this.getManyDatas(item, 16);
      }
      this.isDetail = false;
    },
    setThreeLevel(item) {
      // 如果是取消选择
      if (item.Id == this.selectedThreeLevel.Id) {
        this.selectedThreeLevel = {};
        this.getManyDatas(this.selectedVillage, 16);
      } else {
        this.selectedThreeLevel = item;
        this.getManyDatas(item, 17);
      }
      this.isDetail = false;

    },
    setFourLevel(item) {
      // 如果是取消选择
      if (item.Id == this.selectedFourLevel.Id) {
        this.selectedFourLevel = {};
        this.getManyDatas(this.selectedThreeLevel, 17);
      } else {
        this.selectedFourLevel = item;
        this.getManyDatas(item, 18);
      }
      this.isDetail = false;
    },

    // 区域
    GetVillagelist(item) {
      api({
        method: "get",
        url: `api/User/GetVillagelist?Ccode=${item.Ccode}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          this.villageList = res.Data;
          // this.setVillage(this.villageList[0]);
        }
      });
    },

    // 加载地图
    initMap() {
      let myMap = document.getElementById('myMap');
      var map = new BMap.Map("myMap");
      //  map.centerAndZoom(this.point || this.cityName, 5);
      map.centerAndZoom(new BMap.Point(120.58, 28.08), 5);
      map.enableScrollWheelZoom();
      map.disableDoubleClickZoom();
      map.addEventListener('dblclick', function (e) {
        myMap.requestFullscreen();
      })
      this.map = map;
    },

    initAreaMap(point, level) {
      let areaMap = document.getElementById('areaMap');
      let map = new BMap.Map("areaMap");
      console.log('point', point)
      map.centerAndZoom(new BMap.Point(point.lng, point.lat), level);
      map.enableScrollWheelZoom();
      map.disableDoubleClickZoom();
      map.addEventListener('dblclick', function (e) {
        areaMap.requestFullscreen();
      })
      this.areaMap = map;
      this.mapSpin = false;
    },

    // 获取设备数据
    getUserDevicesPageV2() {
      const { GroupCode, DepartmentCode, CompanyCode, IsAdmin } = JSON.parse(
        Cookies.get("AdminData")
      );
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `api/CommElecDevice/GetUserDevicesPageV2`,
          params: {
            groupCode: GroupCode,
            companyCode: CompanyCode,
            departmentCode: DepartmentCode,
            isAdmin: IsAdmin,
            pageIndex: 1,
            pageSize: 1000,
            Ccode: this.selectedArea.Ccode,
            Vcode: this.selectedVillage.Vcode,
            Scode: this.selectedThreeLevel.Scode,
            Zcode: this.selectedFourLevel.Zcode
          },
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token"),
          },
        },
        "yhj"
      )
        .then((res) => {
          if (res.Success) {
            if (!this.showArea) {
              this.dataList = res.Data;
              this.mapAddMarker(this.areaMap, 'area');
            } else {
              this.dataListAll = res.Data;
              this.mapAddMarker(this.map, 'all');
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 地图添加Marker
    mapAddMarker(map, type) {
      let that = this;
      if (map) {
        let data;
        if (type == 'all') {
          data = this.dataListAll;
        } else {
          data = this.dataList;
        }
        map.clearOverlays();
        data.forEach(item => {
          // 创建图标
          let myIcon = new BMap.Icon(
            item.IsOnline ? require("@/assets/electricity/greenmaker1.png") : require("@/assets/electricity/greenmaker1.png"),
            new BMap.Size(100, 100)
          );
          var markers = new BMap.Marker(
            new BMap.Point(item.Longitude, item.Latitude), {
            icon: myIcon
          }
          )
          var label = new BMap.Label(item.UserDeviceName, {
            offset: new BMap.Size(25, 5)
          });

          label.setStyle({
            color: "#ffffff",
            fontSize: "0.6vw",
            height: "1.5vw",
            padding: "0 0.5vw",
            marginTop: "-0.5vw",
            borderRadius: "0.25vw",
            border: "0.05vw solid rgba(15,72,151,0.7)",
            backgroundColor: "rgba(15,72,151,0.7)",
            marginLeft: "0.5vw",
            lineHeight: "1.35vw",
            fontFamily: this.$t('smartCity.Home.943046-473')
          });
          // 在地图上添加点标记
          map.addOverlay(markers);
          markers.setLabel(label);
          markers.addEventListener('click', function () {
            if (that.$driver.isActivated) {
              return;
            }
            that.deviceDetails(item);
          })
        })
      }
    },

    // 设置主题
    setTheme({ code }) {
      if (code !== this.themeCode) {
        this.$store.dispatch("setThemeCode", code);
        this.themeCode = code;
        localStorage.setItem('themeCode', code);
      }
    },

    // 设置首页
    setHome(type) {
      if (type != 'newHome') {
        // 图表在线离线数据（yhj）
        this.GetDeviceZLData();
        // 告警异常处理情况图表数据
        this.GetEchartAbData();
      }
      this.$store.commit("setHomeType", type);
      localStorage.setItem('HomeType', type);
    },

    // 刷新翻牌器
    getNumScroll(GetNavDataYHJs) {
      let _this = this;
      _this.numScroll('itemImg1', GetNavDataYHJs.todayAbSolve);
      _this.numScroll('itemImg2', GetNavDataYHJs.todayAbWeiSolve);
      _this.numScroll('itemImg4', GetNavDataYHJs.AbTenant);
      _this.numScroll('itemImg5', GetNavDataYHJs.abDevice);
      _this.numScroll('itemImg6', GetNavDataYHJs.ZxDevice);
      _this.numScroll('itemImg7', GetNavDataYHJs.LxDevice);
    },
    // 数字翻牌器
    numScroll(id, maxNum, time = 1000) {
      var numDom = document.getElementById(id)
      if (!numDom) {
        return;
      }
      var numInit = 0
      var addNum = maxNum / (time / 10)
      var minTime = time / maxNum
      var t = setInterval(function () {
        if (numInit >= maxNum) {
          clearInterval(t)
          numDom.innerText = maxNum
        } else {
          numInit += addNum
          numDom.innerText = Math.round(numInit)
        }
      }, 7)
    },

    modeFlashing() {

      let tmpe = 0;
      $(".mode-view-flashing").each(function (index) {
        let top = Math.ceil(Math.random() * $(document).height());
        let left = Math.ceil(Math.random() * $(document).width());
        $(this).offset({
          'left': left,
          'top': top
        });
        if (tmpe == 0) {
          $(this).addClass("flashing-delay0");
          $(this).addClass("flashing-duration4");
          tmpe = 1;
        } else if (tmpe == 1) {
          $(this).addClass("flashing-delay1_2");
          $(this).addClass("flashing-duration3");
          tmpe = 2;
        } else if (tmpe == 2) {
          $(this).addClass("flashing-delay0_7");
          $(this).addClass("flashing-duration2");
          tmpe = 3;
        } else if (tmpe == 3) {
          $(this).addClass("flashing-delay1_9");
          $(this).addClass("flashing-duration1");
          tmpe = 0;
        }

      })

    },

    alarmClick() {
      let _this = this;
      _this.alarmState = true;
      this.GetNavDataYHJ('new');
      if (_this.alarmState) {
        clearTimeout(_this.alarmTime);
        _this.alarmTime = setTimeout(() => {
          _this.alarmState = false;
        }, 5000);
      }
    },

    Carousel() {
      this.roll(50, document.getElementById("content"), document.getElementById("fakeContent"), document.getElementById("wrapper"), '#wrapper');
      this.roll(50, document.getElementById("content2"), document.getElementById("fakeContent2"), document.getElementById("wrapper2"), '#wrapper2');
    },

    roll(t, content, fakeContent, wrapper, wrapperId) {
      let _this = this;

      if (!content) {
        return;
      }

      if (fakeContent) {
        fakeContent.innerHTML = content.innerHTML;
      }

      // 开始无滚动时设为0
      wrapper.scrollTop = 0;

      let timer = null;

      //鼠标事件绑定
      $(wrapperId).hover(function () {
        clearInterval(timer);
        timer = null
      }, function () {
        timer = setInterval(() => {
          _this.rollStart(wrapper, content)
        }, t);
      }).mouseout();

    },

    // 开始滚动函数
    rollStart(wrapper, content) {
      // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
      if (wrapper.scrollTop >= content.scrollHeight) {
        wrapper.scrollTop = 0;
      } else {
        wrapper.scrollTop++;
      }
    },

    // SignalR
    connectServer(value) {
      let _this = this;
      let conn = $.hubConnection("http://yhj.hxpwr.com/signalr/hubs", {
        useDefaultPath: false
      })
      _this.proxy = conn.createHubProxy("HomeHub");
      _this.proxy.on("SendBjCount", (data) => {
        if (data) {
          if (_this.PlayIndex) {
            _this.play = document.getElementById('Play');
            _this.play.play();
          }

          // 根据集团 公司 部门获取设备异常（yhj）
          _this.GetDeviceAbnormalPageListWith3Code();

          // 获取导航栏数据（yhj）
          _this.GetNavDataYHJ();

          // 告警异常处理情况图表数据
          _this.GetEchartAbData();

        }
      })
      conn.start().done((data) => {
        _this.proxy.invoke("sendLogin", value).done((msg) => {
          console.log(this.$t('smartCity.Home.943046-474'));
        });
      }).fail((data) => {
        console.log(this.$t('smartCity.Home.943046-475'))
      });
    },

    GetAbDeviceCount() {
      let _this = this;
      _this.play = document.getElementById('Play');
      _this.play.pause();
    },

    PlaySound() {
      this.PlayIndex = true;
      Cookies.set('PlayIndex', true);
    },

    StopSound() {
      this.PlayIndex = false;
      Cookies.set('PlayIndex', false);
    },

    ceshi() {
      this.offsetMsg = true;
      setTimeout(() => {
        this.offsetMsg = false;
      }, 2000)
    },

    // 判断当前用户是否超级管理员
    IsOrNOSuperAdmin() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: 'api/User/IsOrNOSuperAdmin',
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then(function (res) {
        // 连接SignalR
        // _this.connectServer(res.Data);
      }).catch(function (err) {
        if (err.data.Code == -9) {
          _this.$store.dispatch("setUserState", true);
          if (window.location.host == 'xed.hxpwr.com') {
            _this.$router.push({
              name: 'xed_login'
            })
          } else {
            _this.$router.push({
              name: 'login'
            })
          }
        } else if (err.data.Code == -1 && err.data.Message == _this.$t('smartCity.Home.943046-476')) {
          if (window.location.host == 'xed.hxpwr.com') {
            _this.$router.push({
              name: 'xed_login'
            })
          } else {
            _this.$router.push({
              name: 'login'
            })
          }
        }
      });
    },

    // 根据集团 公司 部门编号 等条件查询设备列表
    GetUserDevicesPage() {

      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetDeviceDataListsMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPage?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}&pageIndex=1&pageSize=100`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.GetDeviceDataListsMsg = true;

        if (res.Success) {
          _this.GetDeviceDataLists = res.Data;
          _this.$nextTick(function () {
            _this.Carousel();
          });
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.GetDeviceDataListsMsg = true;
      });
    },

    // 获取当前位置
    getPosition() {
      let _this = this;
      // var geolocation = new BMap.Geolocation();
      // var gc = new BMap.Geocoder();
      // geolocation.getCurrentPosition(function (r) {
      // 	_this.cityName = `${r.address.province}-${r.address.city}`
      // 	Cookies.set('cityName', _this.cityName)
      // }, { enableHighAccuracy: true });
    },


    drawLine(legends, series) {
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          textStyle: {
            color: '#ffffff',
          },
          left: 'center',
          data: legends
        },
        series: [{
          name: _this.$t('smartCity.Home.943046-467'),
          type: 'pie',
          label: {
            // normal: {
            // 	position: 'inner',
            // 	show: false
            // },
            formatter: '{b}: {c} ({d}%)'
          },
          radius: '50%',
          center: ['50%', '50%'],
          data: series,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
      window.addEventListener('resize', function () {
        if (_this.homeType != 'newHome') {
          myChart.resize();
        }
      })
      // 饼图点击跳转到指定页面
      myChart.on('click', function (param) {
        _this.openPopup(3, param.name == _this.$t('smartCity.Home.943046-7') ? _this.$t('smartCity.Home.943046-8') : param.name == _this.$t('smartCity.Home.943046-120') ? _this.$t('smartCity.Home.943046-10') : _this.$t('smartCity.Home.943046-477'), param.name ==
          _this.$t('smartCity.Home.943046-7') ? '2' : param.name == _this.$t('smartCity.Home.943046-120') ? '1' : '3')
      });
    },

    myChart1(series) {
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('myChart1'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },

        series: [{
          name:  _this.$t('smartCity.Home.943046-21'),
          type: 'pie',
          radius: ['50%', '70%'],
          label: {
            formatter: '{b}: {c} ({d}%)'
          },
          data: series
        }]
      });

      window.addEventListener('resize', function () {
        if (_this.homeType != 'newHome') {
          myChart.resize();
        }
      })

      // 饼图点击跳转到指定页面
      myChart.on('click', function (param) {
        _this.openPopup(2, param.name == _this.$t('smartCity.Home.943046-91') ?  _this.$t('smartCity.Home.943046-17') :  _this.$t('smartCity.Home.943046-19'), param.name ==  _this.$t('smartCity.Home.943046-91') ? '1' : '0')
      });

    },

    // 根据集团 公司 部门获取设备异常（yhj）
    GetDeviceAbnormalPageListWith3Code(type) {

      if (!Cookies.get('AdminData')) {
        if (window.location.host == 'xed.hxpwr.com') {
          this.$router.push({
            name: 'xed_login'
          })
        } else {
          this.$router.push({
            name: 'login'
          })
        }
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetAbDataListsMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=100&pstate=1&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        _this.GetAbDataListsMsg = true;
        if (res.Success) {

          _this.GetAbDataLists = res.Data;
          _this.GetAbDataCount = res.TotalCount;
          _this.numScroll('itemImg3', _this.GetAbDataCount);

          if (type == 'self') {
            _this.offsetMsg = true;
            setTimeout(() => {
              _this.offsetMsg = false;
            }, 2000)
          } else {
            _this.$nextTick(function () {
              _this.roll(50, document.getElementById("content3"), document.getElementById("fakeContent3"), document.getElementById("wrapper3"), '#wrapper3');
            });
          }

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },

    // 获取导航栏数据（旧接口，能用 取一个参数）
    GetNavData() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/Device/GetNavData`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then(function (res) {
        if (res.Success) {

          _this.GetNavDatas = res.Data;

        } else {
          if (res.Code == -9) {
            if (window.location.host == 'xed.hxpwr.com') {
              this.$router.push({
                name: 'xed_login'
              })
            } else {
              this.$router.push({
                name: 'login'
              })
            }
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        }
      })
    },

    // 获取导航栏数据（yhj）
    GetNavDataYHJ(flag) {
      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));

      _this.TittleName = AdminData.TittleName;
      _this.TittleNameEN = AdminData.TittleNameEN;
      _this.ImageUrl = AdminData.ImageUrl;

      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetNavData`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          if (flag == 'new') {
            _this.GetNavDataYHJsNew = res.Data;
          } else {
            _this.GetNavDataYHJs = res.Data;
          }
          // _this.drawNewChart3();

          _this.getNumScroll(_this.GetNavDataYHJs);

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },

    // 图表在线离线数据（yhj）
    GetDeviceZLData(flag) {
      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetDeviceZLData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          let series = [];
          res.Data.forEach((item, index) => {
            series.push({
              value: item.value,
              name: item.name,
              itemStyle: {
                color: index === 0 ? '#8256F3' : '#2AEED0'
              }
            })
          })
          _this.$nextTick(function () {
            if (flag == "new") {
              _this.drawNewChart2(series);
            } else {
              _this.myChart1(series);
            }
          });

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        // if (err.data.Code == -9 || err.data.Code == -1) {
        // 	_this.$router.push({
        // 		name: 'login'
        // 	})
        // }
      });
    },

    // 告警异常处理情况图表数据
    GetEchartAbData(flag) {
      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetEchartAbDataMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetEchartAbData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.GetEchartAbDataMsg = true;

        if (res.Success) {

          let series = [],
            legends = [];
          res.Data.forEach((item, index) => {
            series.push({
              value: item.value,
              name: item.name,
              itemStyle: {
                color: index === 0 ? '#2094DF' : index === 1 ? '#2AEED0' : '#8256F3'
              }
            })
            legends.push(item.name);

            if (item.name == _this.$t('smartCity.Home.943046-7')) {
              _this.processed = item.value
            }
          })

          if (series.length == 0) {
            series = [], legends = [];
            series.push({
              value: 0,
              name: _this.$t('smartCity.Home.943046-7'),
              itemStyle: {
                color: '#2094DF'
              }
            })
            legends.push(_this.$t('smartCity.Home.943046-7'));

            _this.processed = 0
          }


          _this.$nextTick(function () {
            if (flag == 'new') {
              _this.drawNewChart1(legends, series);
            } else {
              _this.drawLine(legends, series);
            }
          });

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        // if (err.data.Code == -9 || err.data.Code == -1) {
        // 	_this.$router.push({
        // 		name: 'login'
        // 	})
        // }
      });
    },

    // 当天操作日志数据（yhj）
    GetOperationData() {
      if (!Cookies.get('AdminData')) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.GetOperationDataListMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetOperationData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}&pageIndex=1&pageSize=100`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        _this.GetOperationDataListMsg = true;
        if (res.Success) {

          _this.GetOperationDataList = res.Data;

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        if (err.data.Code == -9) {
          if (window.location.host == 'xed.hxpwr.com') {
            _this.$router.push({
              name: 'xed_login'
            })
          } else {
            _this.$router.push({
              name: 'login'
            })
          }
        }
      });
    },

    // 获取设备相关数据
    GetDeviceData() {
      let _this = this;
      _this.GetDeviceDataListsMsg = false;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/Device/GetDeviceData`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then(function (res) {
        _this.GetDeviceDataListsMsg = true;
        if (res.Success) {

          _this.GetDeviceDataLists = res.Data;

        } else {
          if (res.Code == -9) {
            if (window.location.host == 'xed.hxpwr.com') {
              this.$router.push({
                name: 'xed_login'
              })
            } else {
              this.$router.push({
                name: 'login'
              })
            }
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        }
      }).catch(function (err) {
        // if (err.data.Code == -9 || err.data.Code == -1) {
        // 	_this.$router.push({
        // 		name: 'login'
        // 	})
        // }
      });
    },

    // 退出登录
    ok() {
      let _this = this;
      Cookies.set('Token', '');
      Cookies.set('AdminData', '');
      _this.$store.dispatch("setCodeValue", ``);
      // _this.$store.dispatch("setHomeType", "newHome");
      // localStorage.setItem('HomeType', "newHome");
      if (window.location.host == 'xed.hxpwr.com') {
        this.$router.push({
          name: 'xed_login'
        })
      } else {
        this.$router.push({
          name: 'login'
        })
      }
    },
    cancel() { },

    // 前往智慧用电
    goPages(page) {
      this.$router.push({
        name: page
      })
    },

    // 开启弹窗
    openPopup(type, title, category = '', deviceType) {
      if (this.$driver.isActivated) {
        return;
      }
      let _this = this;
      _this.popupState = true;
      _this.popupType = type;
      _this.popupTitle = title;
      _this.pageIndex = 1;
      _this.pageSize = 10;

      if (type == 1) {
        _this.getDeviceAbnormalPages()
      } else if (type == 2 || type == 2.5) {
        _this.DeviceCategory = category;
        _this.deviceType = deviceType;
        // _this.getUserDevicesPages()
        _this.getUserDevicesPagesNew();
      } else if (type == 3) {
        _this.DeviceCategory = category;
        _this.getThatDayDeviceAbnormalPages();
      } else if (type == 4) {
        _this.GetCurrRoomAbDevices();
      } else if (type == 5) {
        _this.GetCurrRoomAbList();
      } else if (type == 6) {
        _this.GetRoshRoomAll('map');
      } else if (type == 7) {
        _this.GetUserGasCheckLogs(1);
      } else if (type == 8) {
        _this.GetUserGasCheckLogs(2);
      } else if (type == 9) {
        _this.GetUserGasCheckLogs(3);
      }

    },

    // 根据集团 公司 部门编号 等条件查询设备列表
    getUserDevicesPages() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPage`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          onlineState: this.DeviceCategory
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.DeviceLists = res.Data;
          _this.DeviceTotal = res.TotalCount;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {

      });
    },

    // 升级原接口到V2版本
    getUserDevicesPagesNew() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPageV2`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          onlineState: this.DeviceCategory,
          deviceType: this.deviceType
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.DeviceLists = res.Data;
          _this.DeviceTotal = res.TotalCount;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {

      });
    },
    DeviceChange(e) {
      let _this = this;
      _this.pageIndex = e;
      _this.getUserDevicesPagesNew();
    },
    DeviceSizeChange(e) {
      let _this = this;
      _this.pageIndex = 1;
      _this.pageSize = e;
      _this.getUserDevicesPagesNew();
    },

    // 根据集团 公司 部门获取设备异常（yhj）
    getDeviceAbnormalPages() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&pstate=1&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {

          _this.DeviceAbnormalList = res.Data;
          _this.DeviceAbnormalTotalCount = res.TotalCount;

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    DeviceAbnormalChange(e) {
      let _this = this;
      _this.pageIndex = e;
      _this.getDeviceAbnormalPages()
    },
    DeviceAbnormalSizeChange(e) {
      let _this = this;
      _this.pageIndex = 1;
      _this.pageSize = e;
      _this.getDeviceAbnormalPages()
    },

    getThatDayDeviceAbnormalPages() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));

      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          pstate: this.DeviceCategory,
          startDt: this.getNowFormatDate(new Date()),
          endDt: this.getNowFormatDate(new Date()),
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {

          _this.DeviceAbnormalList = res.Data;
          _this.DeviceAbnormalTotalCount = res.TotalCount;

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },
    DeviceAbnormalChange1(e) {
      let _this = this;
      _this.pageIndex = e;
      _this.getThatDayDeviceAbnormalPages()
    },
    DeviceAbnormalSizeChange1(e) {
      let _this = this;
      _this.pageIndex = 1;
      _this.pageSize = e;
      _this.getThatDayDeviceAbnormalPages()
    },

    // 获取日期
    getNowFormatDate(date) {
      let seperator1 = "-";
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    // 获取告警设备列表
    GetCurrRoomAbDevices() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));

      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetCurrRoomAbDevices`,
        params: {
          groupCode: AdminData.GroupCode,
          companyCode: AdminData.CompanyCode,
          departmentCode: AdminData.DepartmentCode,
          isAdmin: AdminData.IsAdmin,
          Ccode: this.selectedArea.Ccode,
          Vcode: this.selectedVillage.Vcode,
          Scode: this.selectedThreeLevel.Scode,
          Zcode: this.selectedFourLevel.Zcode,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {

        _this.DeviceCountList = res.Data;
        _this.AlarmTotalCount = res.TotalCount;

      })
    },

    // 当前报警住户列表
    GetCurrRoomAbList() {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));

      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetCurrRoomAbList?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
        }
      }, 'yhj').then(function (res) {

        _this.GetCurrRoomAbLists = res;

      })
    },

    // 及时告警信息处理 type 2、处理 3、误报（yhj）
    SolveAbData(Id, type, state) {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      _this.$Modal.confirm({
        title: _this.$t('smartCity.Home.943046-430'),
        content: `<p>是否对设备进行${type == 2 ? _this.$t('smartCity.Home.943046-250') : _this.$t('smartCity.Home.943046-121')}操作</p>`,
        onOk: () => {
          api({
            //这里是你自己的请求方式、url和data参数
            method: 'get',
            url: `api/YhjDevice/ProcessUserDeviceAbnormal?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&userDeviceAbnormal_Id=${Id}&pstate=${type}`,
            data: {},
            //假设后台需要的是表单数据这里你就可以更改
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              "Authorization": Cookies.get('Token')
            }
          }, 'yhj').then(function (res) {
            if (res.Success) {
              _this.$Message['success']({
                background: true,
                content: res.Message
              });

              // 根据集团 公司 部门获取设备异常（yhj）
              _this.GetDeviceAbnormalPageListWith3Code();

              // 获取导航栏数据（yhj）
              _this.GetNavDataYHJ();

              // 告警异常处理情况图表数据
              _this.GetEchartAbData();

              // 判断当前用户是否超级管理员
              _this.IsOrNOSuperAdmin();
              _this.GetNavDataYHJ('new');

              if (_this.popupType == 1) {
                //
                _this.getDeviceAbnormalPages()
              } else if (_this.popupType == 3) {
                _this.getThatDayDeviceAbnormalPages();
              }


            } else {
              _this.$Message['error']({
                background: true,
                content: res.Message
              });
            }
          }).catch(function (err) {
            // _this.$Message['error']({
            //   background: true,
            //   content: this.$t('smartCity.Home.943046-433')
            // });
          });
        },
        onCancel: () => {

        }
      });

    },

    // 根据设备编号及时告警信息处理 pstate 2、处理 3、误报（yhj）
    ProcessUserDeviceAbnormalDeviceCode(deviceCode, abCreateTime, pstate) {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));

      _this.$Modal.confirm({
        title: _this.$t('smartCity.Home.943046-430'),
        content: `<p>是否对设备进行${pstate == 2 ? _this.$t('smartCity.Home.943046-250') : _this.$t('smartCity.Home.943046-121')}操作</p>`,
        onOk: () => {
          api({
            //这里是你自己的请求方式、url和data参数
            method: 'get',
            url: `api/YhjDevice/ProcessUserDeviceAbnormalDeviceCode?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&deviceCode=${deviceCode}&abCreateTime=${abCreateTime}&pstate=${pstate}`,
            data: {},
            //假设后台需要的是表单数据这里你就可以更改
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              "Authorization": Cookies.get('Token')
            }
          }, 'yhj').then(function (res) {
            if (res.Success) {
              _this.$Message['success']({
                background: true,
                content: res.Message
              });

              _this.alarmState = false;

              // 根据集团 公司 部门获取设备异常（yhj）
              _this.GetDeviceAbnormalPageListWith3Code();

              // 获取导航栏数据（yhj）
              _this.GetNavDataYHJ();

              // 告警异常处理情况图表数据
              _this.GetEchartAbData();

              // 判断当前用户是否超级管理员
              _this.IsOrNOSuperAdmin();

              if (_this.popupType == 1) {
                //
                _this.getDeviceAbnormalPages()
              } else if (_this.popupType == 3) {
                _this.getThatDayDeviceAbnormalPages();
              }


            } else {
              _this.$Message['error']({
                background: true,
                content: res.Message
              });
            }
          }).catch(function (err) {
            // _this.$Message['error']({
            //   background: true,
            //   content: this.$t('smartCity.Home.943046-433')
            // });
          });
        },
        onCancel: () => {

        }
      });
    },

    // 关闭弹窗
    shutDown(type) {
      if (type == 'self') {
        let _this = this;
        this.idList = [];
        _this.popupState = false;
      }
    },

    // 双击详情
    deviceDetails(item) {
      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceVCR?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&deviceCode=${item.DeviceCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.cmmModel = res.Data.cmmModel;
          _this.villModel = res.Data.villModel;
          _this.roomModel = res.Data.roomModel;
          _this.elecFixModel = res.Data.elecFixModel;
          console.log(res);
          _this.DeviceCode = item.DeviceCode;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) { });
      _this.doubleState = true;
    },

    // 关闭双击弹窗
    doubleShutDown(type) {
      if (type == 'self') {
        let _this = this;
        _this.doubleState = false;
      }
    }

  },
  filters: {
    intercept: function (value) {
      if (!value) return '';
      return value.slice(11, 16);
    },
  }
}
</script>
<style scoped="scoped" lang="scss">@import url('./index.css');
@import "./smart_city_default.scss";
@import "./smart_city.scss";
@import "./new_smart_city.scss";</style>
<style lang="scss">.village {
  position: absolute;
  z-index: 10;

  .content {
    position: relative;
    height: 95px;
    transition: height .5s linear;
    overflow: hidden;

    .el-icon-arrow-right:before {
      font-size: 18px;
      color: #fff;
    }

    .el-icon-arrow-down:before {
      font-size: 18px;
      color: #fff;
    }

    .con {
      display: flex;
      flex-wrap: wrap;
      background-color: rgba(0, 0, 0, .2);
    }
  }

  .content2 {
    height: 1000px;
  }
}

div#driver-popover-item {
  background-color: transparent;
  background-image: url(../../assets/newHome/guide-card.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px 20px;
  box-shadow: unset;

  .driver-popover-tip {
    display: none;
  }

  .driver-popover-title {
    // display: none;
    color: #FFF;
  }

  .driver-popover-description {
    color: #FFF;
  }

  .driver-popover-footer {
    position: absolute;
    top: 110px;

    button {
      text-shadow: unset;
    }

    .driver-close-btn {
      margin-left: 10px;
      margin-right: 40px;
      border-radius: 20px;
      background-color: transparent;
      border: solid 2px #3cd6f5;
      color: #3cd6f5;
    }

    .driver-btn-group {
      color: #FFF;

      .driver-prev-btn {
        // display: none !important;
        color: #FFF;
        border-radius: 20px;
        background-color: #0272c3;
        padding: 5px 12px;
        border: unset;
      }

      .driver-next-btn {
        color: #08213b;
        border-radius: 20px;
        background-color: #3cd6f5;
        padding: 5px 12px;
        border: unset;
      }
    }
  }
}

.guide1 {
  transform: translateY(110px);
}

.robotLeft:before {
  position: absolute;
  left: -70px;
  top: 80px;
  height: 150px;
  width: 150px;
  content: '';
  background-image: url(../../assets/newHome/fire.png);
  background-size: contain;
  background-repeat: no-repeat;
  animation: fly 2s linear infinite alternate;
}

.robotLeft::after {
  position: absolute;
  left: -100px;
  top: 0px;
  height: 150px;
  width: 150px;
  content: '';
  background-image: url(../../assets/newHome/robot.png);
  background-size: contain;
  background-repeat: no-repeat;
  animation: fly 2s linear infinite alternate;
  z-index: 20;
}

.robotRight:before {
  position: absolute;
  left: 300px;
  top: 80px;
  height: 150px;
  width: 150px;
  content: '';
  background-image: url(../../assets/newHome/fire.png);
  background-size: contain;
  background-repeat: no-repeat;
  animation: fly 2s linear infinite alternate;
}

.robotRight::after {
  position: absolute;
  left: 270px;
  top: 0px;
  height: 150px;
  width: 150px;
  content: '';
  background-image: url(../../assets/newHome/robot.png);
  background-size: contain;
  background-repeat: no-repeat;
  animation: fly 2s linear infinite alternate;
  z-index: 20;
}

@keyframes fly {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(10px);
  }
}</style>



// WEBPACK FOOTER //
// src/components/smartCity/Home.vue